import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Duration: { input: any; output: any };
  JSONObject: {
    input: Record<string, unknown>;
    output: Record<string, unknown>;
  };
  LocalDate: { input: string; output: string };
  LocalDateTime: { input: string; output: string };
  LocalTime: { input: string; output: string };
  ZoneId: { input: string; output: string };
  ZonedDateTime: { input: string; output: string };
};

export enum AccessRole {
  Admin = 'admin',
  Coach = 'coach',
  Self = 'self',
}

export type ActiveCustomPlanDay = {
  __typename?: 'ActiveCustomPlanDay';
  date: Scalars['LocalDate']['output'];
  itemCompletedCount: Scalars['Int']['output'];
  itemCount: Scalars['Int']['output'];
};

export type Activity = {
  date: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  program?: Maybe<Program>;
  progress: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  trendType?: Maybe<ActivityTrendType>;
  type: ActivityType;
};

export type ActivityAggregates = {
  __typename?: 'ActivityAggregates';
  /** count of activities completed excluding sleep */
  activities: Scalars['Int']['output'];
  /** selected date range */
  date?: Maybe<ZonedDateTimeRange>;
  /** count of days that had at least 1 activity */
  days: Scalars['Int']['output'];
  /** count of real activity minutes excluding sleep */
  minutes: Scalars['Int']['output'];
  minutesAsleepPerDayAverage: Scalars['Int']['output'];
  restingHeartRatePerDayAverage: Scalars['Int']['output'];
  stepsPerDayAverage: Scalars['Int']['output'];
};

export type ActivityAttribution = AssignedPractice | AssignedProgram;

export type ActivityConnection = Connection & {
  __typename?: 'ActivityConnection';
  count: Scalars['Int']['output'];
  edges: Array<ActivityEdge>;
  nodes: Array<Activity>;
  pageInfo: PageInfo;
};

export type ActivityEdge = Edge & {
  __typename?: 'ActivityEdge';
  cursor: Scalars['String']['output'];
  node: Activity;
};

export type ActivityFilter = {
  dateRange?: InputMaybe<DateRange>;
  includeIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  trendType?: InputMaybe<Array<InputMaybe<ActivityTrendType>>>;
  type?: InputMaybe<Array<InputMaybe<ActivityType>>>;
};

export type ActivityGenre = {
  __typename?: 'ActivityGenre';
  canBeAddedManually: Scalars['Boolean']['output'];
  canHaveDistance: Scalars['Boolean']['output'];
  defaultIntensity?: Maybe<IntensityLevel>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ActivityGenresFilter = {
  canBeAddedManually?: InputMaybe<Scalars['Boolean']['input']>;
  canHaveDistance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityPayload = {
  __typename?: 'ActivityPayload';
  activity: Activity;
  user: User;
};

export type ActivitySource =
  | Article
  | Audio
  | MboClass
  | PhysicalActivity
  | Survey
  | TrainingPlanWorkout
  | Video
  | WearableActivity;

export enum ActivityTrendType {
  Classes = 'classes',
  CustomTrainingPlan = 'custom_training_plan',
  GymArrival = 'gym_arrival',
  ManualEntry = 'manual_entry',
  Practice = 'practice',
  Program = 'program',
  Sleep = 'sleep',
  Tool = 'tool',
  /** @deprecated training plans have been retired */
  TrainingPlan = 'training_plan',
  Wearables = 'wearables',
}

export enum ActivityType {
  Aod = 'Aod',
  Article = 'Article',
  Encore = 'Encore',
  GymArrival = 'GymArrival',
  InPerson = 'InPerson',
  ManualEntry = 'ManualEntry',
  Tool = 'Tool',
  TrainingPlanWorkout = 'TrainingPlanWorkout',
  Virtual = 'Virtual',
  Vod = 'Vod',
  /** @deprecated use wearable sdk specific type */
  Wearable = 'Wearable',
  WearableGoogleFit = 'WearableGoogleFit',
  WearableHealthConnectActivity = 'WearableHealthConnectActivity',
  WearableHealthConnectSleep = 'WearableHealthConnectSleep',
  WearableHealthKit = 'WearableHealthKit',
  WearableHealthKitSleep = 'WearableHealthKitSleep',
}

export type AddGymArrivalPayload = {
  __typename?: 'AddGymArrivalPayload';
  classCheckIns: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddPerformanceQualityScoresPayload = {
  __typename?: 'AddPerformanceQualityScoresPayload';
  performanceQualityScores: Array<PerformanceQualityScore>;
};

export type AddReactionInput = {
  kind: ReactionKind;
  messageId: Scalars['ID']['input'];
};

export type AddUserToStudioPayload = {
  __typename?: 'AddUserToStudioPayload';
  studio: Studio;
  user: User;
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  addressLine4?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  localityOrCity?: Maybe<Scalars['String']['output']>;
  postalOrZipCode?: Maybe<Scalars['String']['output']>;
  stateOrDistrictOrProvince?: Maybe<Scalars['String']['output']>;
};

export type AdminAddGymArrivalInput = {
  /** Defaults to now. Must not be in the future. */
  arrivalTime?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  locationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type AdminBackfillAssessmentAttributionTypeInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminBackfillEligibilitySourceInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  source: EligibilitySource;
};

export type AdminChangeAuthProviderInput = {
  currentEmail: Scalars['String']['input'];
  idpUsername: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  removeOtherProviders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminDisableAuthProviderInput = {
  currentEmail: Scalars['String']['input'];
  idpUsername: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};

export type AdminTrainingPlanTemplatesFilter = {
  difficulty?: InputMaybe<Array<Scalars['String']['input']>>;
  durationMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  equipmentCategory?: InputMaybe<
    Array<InputMaybe<TrainingPlanEquipmentCategory>>
  >;
  frequency?: InputMaybe<Array<Scalars['Int']['input']>>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  phase?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<TrainingPlanType>>;
};

export type AdminUpdateUserInput = {
  createdAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  firstSignedInAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  setTestPassword?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Answer = EnumAnswer | NumberAnswer | PhotoAnswer | StringAnswer;

export type AnswerSurveyInput = {
  answers: Array<SurveyResponseInput>;
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dev-only: override the survey completion time (surveys.createdAt).
   * Rejected outside the dev environment.
   */
  createdAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  surveyIdentifier: Scalars['String']['input'];
  surveyName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ApmlJsonBackfillPayload = {
  __typename?: 'ApmlJsonBackfillPayload';
  rowCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export enum App {
  Heart = 'heart',
  Prince = 'prince',
}

export type AppointmentBookingsConnection = Connection & {
  __typename?: 'AppointmentBookingsConnection';
  count: Scalars['Int']['output'];
  edges: Array<AppointmentBookingsEdge>;
  nodes: Array<MboAppointment>;
  pageInfo: PageInfo;
};

export type AppointmentBookingsEdge = Edge & {
  __typename?: 'AppointmentBookingsEdge';
  cursor: Scalars['String']['output'];
  node: MboAppointment;
};

export type AppointmentPayload = {
  __typename?: 'AppointmentPayload';
  appointment: MboAppointment;
};

export type ArchiveAllPostOnboardingRecommendationForUser = {
  __typename?: 'ArchiveAllPostOnboardingRecommendationForUser';
  recommendations: Array<UserPostOnboardingRecommendation>;
};

export type ArchiveAllPostOnboardingRecommendationForUserInput = {
  userId: Scalars['ID']['input'];
};

export type ArchivePostOnboardingRecommendationPayload = {
  __typename?: 'ArchivePostOnboardingRecommendationPayload';
  recommendation: UserPostOnboardingRecommendation;
};

export type Article = Content &
  Node & {
    __typename?: 'Article';
    author?: Maybe<Scalars['String']['output']>;
    brand?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    /** @deprecated use contentEquipment */
    equipment: Array<Scalars['String']['output']>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    gameplanMetadata?: Maybe<GameplanMetadata>;
    heroPhoto?: Maybe<Photo>;
    html?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    intensity?: Maybe<Scalars['String']['output']>;
    isPublished: Scalars['Boolean']['output'];
    kind?: Maybe<Scalars['String']['output']>;
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    mediaType?: Maybe<Scalars['String']['output']>;
    mnmrType?: Maybe<Scalars['String']['output']>;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    share?: Maybe<Share>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    split?: Maybe<Split>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type ArticleRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ArticleActivity = Activity &
  CoachBasedActivity &
  Node &
  TimeBasedActivity & {
    __typename?: 'ArticleActivity';
    brand?: Maybe<Scalars['String']['output']>;
    coachAvatar?: Maybe<Photo>;
    coachFirstName?: Maybe<Scalars['String']['output']>;
    coachLastName?: Maybe<Scalars['String']['output']>;
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    source?: Maybe<Article>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type ArticlesConnection = Connection & {
  __typename?: 'ArticlesConnection';
  count: Scalars['Int']['output'];
  edges: Array<ArticlesEdge>;
  nodes: Array<Article>;
  pageInfo: PageInfo;
};

export type ArticlesEdge = Edge & {
  __typename?: 'ArticlesEdge';
  cursor: Scalars['String']['output'];
  node: Article;
};

export type AssessmentAssignment = Node & {
  __typename?: 'AssessmentAssignment';
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  context?: Maybe<AssessmentContext>;
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  survey?: Maybe<Survey>;
  surveyContent: InAppSurvey;
  template: SurveyTemplate;
  visibleOnDate?: Maybe<Scalars['LocalDate']['output']>;
};

export type AssessmentContext = {
  __typename?: 'AssessmentContext';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AssessmentSurvey = Node & {
  __typename?: 'AssessmentSurvey';
  id: Scalars['ID']['output'];
  /**
   * whether or not this survey is shown to members
   * these are not directly assignable and are completed by coaches
   * @deprecated Use type instead
   */
  isMemberFacing: Scalars['Boolean']['output'];
  mnmrType?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  template: SurveyTemplate;
  title?: Maybe<Scalars['String']['output']>;
  type: AssessmentType;
};

export type AssessmentSurveyEdge = Edge & {
  __typename?: 'AssessmentSurveyEdge';
  cursor: Scalars['String']['output'];
  node: AssessmentSurvey;
};

export type AssessmentSurveysConnection = Connection & {
  __typename?: 'AssessmentSurveysConnection';
  count: Scalars['Int']['output'];
  edges: Array<AssessmentSurveyEdge>;
  nodes: Array<AssessmentSurvey>;
  pageInfo: PageInfo;
};

export enum AssessmentType {
  Coach = 'Coach',
  Member = 'Member',
  NutritionSpecialist = 'NutritionSpecialist',
}

export type AssignAssessmentsInput = {
  createdAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  /** If true, will allow admin users in the dev environment to override assignment date */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['ID']['input'];
  surveyContentIds: Array<Scalars['ID']['input']>;
};

export type AssignAssessmentsPayload = {
  __typename?: 'AssignAssessmentsPayload';
  assessments: Array<AssessmentAssignment>;
};

export type AssignFitCoachPayload = {
  __typename?: 'AssignFitCoachPayload';
  coach: User;
  user: User;
};

export type AssignPracticePayload = {
  __typename?: 'AssignPracticePayload';
  assignedPractice: AssignedPractice;
};

export type AssignProgramPayload = {
  __typename?: 'AssignProgramPayload';
  assignedProgram: AssignedProgram;
};

export type AssignedPractice = {
  __typename?: 'AssignedPractice';
  assigningCoach?: Maybe<User>;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  completionNotified: Scalars['Boolean']['output'];
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  isUnenrolled: Scalars['Boolean']['output'];
  practiceProgram?: Maybe<PracticeProgram>;
  user: User;
};

export type AssignedProgram = Node & {
  __typename?: 'AssignedProgram';
  assigningCoach?: Maybe<User>;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  isUnenrolled: Scalars['Boolean']['output'];
  program?: Maybe<Program>;
  user: User;
};

export type Audio = Content &
  Node & {
    __typename?: 'Audio';
    audio: Scalars['String']['output'];
    author?: Maybe<Scalars['String']['output']>;
    brand?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    /** @deprecated use contentEquipment */
    equipment: Array<Scalars['String']['output']>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    gameplanMetadata?: Maybe<GameplanMetadata>;
    heroPhoto?: Maybe<Photo>;
    html?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    intensity?: Maybe<Scalars['String']['output']>;
    isPublished: Scalars['Boolean']['output'];
    kind?: Maybe<Scalars['String']['output']>;
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    movementProgressions: MovementProgressionsConnection;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    share?: Maybe<Share>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    split?: Maybe<Split>;
    subGenre?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
    transcript?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
  };

export type AudioMovementProgressionsArgs = {
  filter?: InputMaybe<MovementProgressionsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type AudioRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type AudioActivity = Activity &
  CoachBasedActivity &
  Node &
  TimeBasedActivity & {
    __typename?: 'AudioActivity';
    brand?: Maybe<Scalars['String']['output']>;
    coachAvatar?: Maybe<Photo>;
    coachFirstName?: Maybe<Scalars['String']['output']>;
    coachLastName?: Maybe<Scalars['String']['output']>;
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    source?: Maybe<Audio>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type AuditLog = Node & {
  __typename?: 'AuditLog';
  action: Scalars['String']['output'];
  createdAt: Scalars['ZonedDateTime']['output'];
  data?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  principal: Principal;
};

export enum AuditLogAction {
  AddEligibleEmail = 'add_eligible_email',
  ArchiveChats = 'archive_chats',
  AssignFitCoach = 'assign_fit_coach',
  BookServiceAppointment = 'book_service_appointment',
  CancelServiceAppointment = 'cancel_service_appointment',
  ChangeEmail = 'change_email',
  CreateChallenge = 'create_challenge',
  CreateClient = 'create_client',
  CreateCohort = 'create_cohort',
  CreateCustomPlan = 'create_custom_plan',
  CreateCustomPlanItem = 'create_custom_plan_item',
  CreateExercise = 'create_exercise',
  CreateExerciseBase = 'create_exercise_base',
  CreateExerciseType = 'create_exercise_type',
  CreateExerciseTypeCategory = 'create_exercise_type_category',
  CreateExerciseTypeCategoryGroup = 'create_exercise_type_category_group',
  CreateFeatureGrant = 'create_feature_grant',
  CreateLocation = 'create_location',
  CreateNote = 'create_note',
  CreateOffice = 'create_office',
  CreateStudio = 'create_studio',
  CreateUser = 'create_user',
  DeleteCustomPlan = 'delete_custom_plan',
  DeleteCustomPlanItem = 'delete_custom_plan_item',
  DeleteExercise = 'delete_exercise',
  DeleteFeatureGrant = 'delete_feature_grant',
  DeleteFitCoach = 'delete_fit_coach',
  DeleteUser = 'delete_user',
  ImportApmlCategories = 'import_apml_categories',
  ReassignCoachMembers = 'reassign_coach_members',
  RegisterUser = 'register_user',
  RemoveAllUserSurveys = 'remove_all_user_surveys',
  RemoveCoachMembers = 'remove_coach_members',
  RemoveCohort = 'remove_cohort',
  RemoveLocation = 'remove_location',
  RemoveOffice = 'remove_office',
  RemoveStudio = 'remove_studio',
  RemoveUserSurveys = 'remove_user_surveys',
  RescheduleServiceAppointment = 'reschedule_service_appointment',
  RestoreCognitoUser = 'restore_cognito_user',
  UpdateChallenge = 'update_challenge',
  UpdateChat = 'update_chat',
  UpdateClient = 'update_client',
  UpdateCoachData = 'update_coach_data',
  UpdateCohort = 'update_cohort',
  UpdateCustomPlan = 'update_custom_plan',
  UpdateCustomPlanItem = 'update_custom_plan_item',
  UpdateEligibleEmail = 'update_eligible_email',
  UpdateExercise = 'update_exercise',
  UpdateExerciseBase = 'update_exercise_base',
  UpdateExerciseType = 'update_exercise_type',
  UpdateExerciseTypeCategory = 'update_exercise_type_category',
  UpdateExerciseTypeCategoryGroup = 'update_exercise_type_category_group',
  UpdateFeatureGrant = 'update_feature_grant',
  UpdateHealthDataConsent = 'update_health_data_consent',
  UpdateLocation = 'update_location',
  UpdateNote = 'update_note',
  UpdateOffice = 'update_office',
  UpdateStudio = 'update_studio',
  UpdateUser = 'update_user',
}

export type AuditLogActionAttribute = {
  __typename?: 'AuditLogActionAttribute';
  name?: Maybe<Scalars['String']['output']>;
  value: AuditLogAction;
};

export enum AuditLogCategory {
  MovementLibrary = 'MovementLibrary',
}

export type AuditLogCategoryAttribute = {
  __typename?: 'AuditLogCategoryAttribute';
  name?: Maybe<Scalars['String']['output']>;
  value: AuditLogCategory;
};

export type AuditLogEdge = Edge & {
  __typename?: 'AuditLogEdge';
  cursor: Scalars['String']['output'];
  node: AuditLog;
};

export type AuditLogsConnection = Connection & {
  __typename?: 'AuditLogsConnection';
  count: Scalars['Int']['output'];
  edges: Array<AuditLogEdge>;
  nodes: Array<AuditLog>;
  pageInfo: PageInfo;
};

export type AuditLogsFilter = {
  action?: InputMaybe<Array<AuditLogAction>>;
  category?: InputMaybe<AuditLogCategory>;
  dataId?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthLogOutcome {
  Failed = 'failed',
  Success = 'success',
}

export enum AuthLogType {
  PostAuth = 'post_auth',
  PreAuth = 'pre_auth',
  PreSignup = 'pre_signup',
}

export enum AutopayStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Suspended = 'Suspended',
}

export type AvailableAssessmentsFilter = {
  type?: InputMaybe<Array<AssessmentType>>;
};

export type BackfillCustomPlanTemplatesPayload = {
  __typename?: 'BackfillCustomPlanTemplatesPayload';
  dryRun: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  templatesFound: Scalars['Int']['output'];
};

export type BackfillDeletedSessionCoachesInput = {
  coachId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BackfillExerciseApmlInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BackfillJpmcCustomPlanStateSessionIdsPayload = {
  __typename?: 'BackfillJpmcCustomPlanStateSessionIdsPayload';
  notFoundCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type BackfillPostOnboardingRecommendationsInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
};

export type BackfillPostOnboardingRecommendationsPayload = {
  __typename?: 'BackfillPostOnboardingRecommendationsPayload';
  count: Scalars['Int']['output'];
};

export type Banner = Content &
  Node & {
    __typename?: 'Banner';
    author?: Maybe<Scalars['String']['output']>;
    bannerPhoto?: Maybe<Photo>;
    buttonText?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    html?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isPublished: Scalars['Boolean']['output'];
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    link: Scalars['String']['output'];
    logoPhoto?: Maybe<Photo>;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    snackbarText?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type BannerRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export enum BlockTrainingComponent {
  Ballistics = 'Ballistics',
  /** @deprecated Use ESD1 */
  Esd = 'ESD',
  Esd1 = 'ESD1',
  Esd2 = 'ESD2',
  Esd3 = 'ESD3',
  EsdCardio = 'ESDCardio',
  EsdFinisher = 'ESDFinisher',
  MovementPrep = 'MovementPrep',
  MovementSkills = 'MovementSkills',
  PillarPrep = 'PillarPrep',
  Regeneration = 'Regeneration',
  StrengthPower1 = 'StrengthPower1',
  StrengthPower2 = 'StrengthPower2',
  StrengthPower3 = 'StrengthPower3',
  StrengthPower4 = 'StrengthPower4',
  StrengthPower5 = 'StrengthPower5',
  StrengthPower6 = 'StrengthPower6',
}

export type BlockTrainingComponentAttribute = {
  __typename?: 'BlockTrainingComponentAttribute';
  name: Scalars['String']['output'];
  value: BlockTrainingComponent;
};

export type BlockUserInput = {
  isBlocked: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type BlockUserPayload = {
  __typename?: 'BlockUserPayload';
  user?: Maybe<User>;
};

export type BookClassPayload = {
  __typename?: 'BookClassPayload';
  mboClass: MboClass;
};

export type BookServiceAppointmentInput = {
  endTime: Scalars['ZonedDateTime']['input'];
  locationId: Scalars['ID']['input'];
  mboSessionTypeId: Scalars['Int']['input'];
  mboStaffId: Scalars['Int']['input'];
  pricingOptionId?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['ZonedDateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type BookSessionInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  calendlyId?: InputMaybe<Scalars['ID']['input']>;
  chatRoomId?: InputMaybe<Scalars['ID']['input']>;
  coachId: Scalars['ID']['input'];
  duration: Scalars['Int']['input'];
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  joinURL?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sessionStyle?: InputMaybe<CoachSessionStyle>;
  sessionSubtype?: InputMaybe<CoachSessionSubtype>;
  sessionType?: InputMaybe<CoachSessionType>;
  start: Scalars['ZonedDateTime']['input'];
  useCronofy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookSessionPayload = {
  __typename?: 'BookSessionPayload';
  session: CoachSession;
};

export enum BotKind {
  App = 'app',
  Automessages = 'automessages',
  DeletedCoach = 'deletedCoach',
  Methodology = 'methodology',
}

export type BulkMessageDestinationInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

/** Provide either an explicit list of destinations or a segment, not both. */
export type BulkMessageInput = {
  destinations?: InputMaybe<Array<BulkMessageDestinationInput>>;
  segment?: InputMaybe<BulkMessageSegment>;
  text: Scalars['String']['input'];
};

/** Recipient segment resolved on the backend for the requesting coach. */
export enum BulkMessageSegment {
  AllMembers = 'AllMembers',
  AssignedMembers = 'AssignedMembers',
}

export type BulkReassignCoachMembersPayload = {
  __typename?: 'BulkReassignCoachMembersPayload';
  userCountReassigned: Scalars['Int']['output'];
  userIdsNotReassigned: Array<Scalars['String']['output']>;
};

export type BulkUpdateExercisesExercisePayload = {
  __typename?: 'BulkUpdateExercisesExercisePayload';
  count: Scalars['Int']['output'];
};

export type BulkUpdateExercisesInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Calendar = Node & {
  __typename?: 'Calendar';
  duration: Scalars['Int']['output'];
  end: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['ZonedDateTime']['output'];
};

export type CalendarBuffer = {
  __typename?: 'CalendarBuffer';
  afterInMinutes: Scalars['Int']['output'];
  beforeInMinutes: Scalars['Int']['output'];
};

export type CalendarProfile = {
  __typename?: 'CalendarProfile';
  platform?: Maybe<ClientCalendarPlatform>;
  profileConnected: Scalars['Boolean']['output'];
  profileId: Scalars['String']['output'];
  profileInitialSyncRequired: Scalars['Boolean']['output'];
  profileName: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  providerService?: Maybe<Scalars['String']['output']>;
};

export type CancelClassPayload = {
  __typename?: 'CancelClassPayload';
  mboClass: MboClass;
};

export type CancelServiceAppointmentPayload = {
  __typename?: 'CancelServiceAppointmentPayload';
  success: Scalars['Boolean']['output'];
};

export type CardProvider = {
  __typename?: 'CardProvider';
  displayName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Challenge = Node & {
  __typename?: 'Challenge';
  activity: ChallengesActivityConnection;
  auditLogs: AuditLogsConnection;
  background?: Maybe<Photo>;
  badge?: Maybe<Photo>;
  challengeType: ChallengeType;
  challenger?: Maybe<User>;
  clientSpecific: Scalars['Boolean']['output'];
  clients: ChallengeClientsConnection;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  dailySteps: Array<DailySteps>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** @deprecated Use endDateTime */
  endDate: Scalars['LocalDate']['output'];
  endDateTime: Scalars['ZonedDateTime']['output'];
  enrolled: Scalars['Boolean']['output'];
  featured: Scalars['Boolean']['output'];
  feedback?: Maybe<FeedbackKind>;
  goal: Scalars['Float']['output'];
  hasSeenEarnedBadge: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isChallenger: Scalars['Boolean']['output'];
  participants: ChallengeParticipantConnection;
  place: Scalars['String']['output'];
  qualifyingContentGenres: Array<Genre>;
  /** @deprecated Use qualifyingContentGenres */
  qualifyingGenres: Array<Scalars['String']['output']>;
  score: Scalars['Float']['output'];
  scoreUnit: ScoreUnit;
  share?: Maybe<Share>;
  /** @deprecated Use startDateTime */
  startDate: Scalars['LocalDate']['output'];
  startDateTime: Scalars['ZonedDateTime']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  team: Scalars['Boolean']['output'];
  teamScore: Scalars['Float']['output'];
  teams: ChallengeTeamConnection;
  timeUnit?: Maybe<ChallengeTimeUnit>;
  title: Scalars['String']['output'];
  /** @deprecated Use scoreUnit */
  unit: Scalars['String']['output'];
};

export type ChallengeActivityArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ChallengeAuditLogsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ChallengeClientsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ChallengeParticipantsArgs = {
  filter?: InputMaybe<ParticipantsFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ParticipantsOrderBy>>;
};

export type ChallengeTeamsArgs = {
  filter?: InputMaybe<ChallengeTeamsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type ChallengeClientsConnection = Connection & {
  __typename?: 'ChallengeClientsConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChallengeClientsEdge>;
  nodes: Array<Client>;
  pageInfo: PageInfo;
};

export type ChallengeClientsEdge = Edge & {
  __typename?: 'ChallengeClientsEdge';
  cursor: Scalars['String']['output'];
  node: Client;
};

export type ChallengeEdge = Edge & {
  __typename?: 'ChallengeEdge';
  cursor: Scalars['String']['output'];
  node: Challenge;
};

export type ChallengeFilter = {
  excludeCustomChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  excludeExosChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum ChallengeOrder {
  Enabled = 'enabled',
  EndDate = 'endDate',
  Featured = 'featured',
  StartDate = 'startDate',
  Title = 'title',
}

export type ChallengeParticipantConnection = Connection & {
  __typename?: 'ChallengeParticipantConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChallengeParticipantsEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type ChallengeParticipantsEdge = Edge & {
  __typename?: 'ChallengeParticipantsEdge';
  challengeTeam?: Maybe<ChallengeTeam>;
  completed: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  node: User;
  place: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type ChallengeSort = {
  field: ChallengeOrder;
  order: OrderDirection;
};

export type ChallengeTeam = Node & {
  __typename?: 'ChallengeTeam';
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  joined: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  participants: ChallengeParticipantConnection;
};

export type ChallengeTeamParticipantsArgs = {
  filter?: InputMaybe<ParticipantsFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ParticipantsOrderBy>>;
};

export type ChallengeTeamConnection = Connection & {
  __typename?: 'ChallengeTeamConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChallengeTeamsEdge>;
  nodes: Array<ChallengeTeam>;
  pageInfo: PageInfo;
};

export type ChallengeTeamsEdge = Edge & {
  __typename?: 'ChallengeTeamsEdge';
  completed: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  node: ChallengeTeam;
  place: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type ChallengeTeamsFilter = {
  appendSelf?: InputMaybe<Scalars['Boolean']['input']>;
  excludeTeamsWithoutScore?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChallengeTemplate = Node & {
  __typename?: 'ChallengeTemplate';
  background: Photo;
  badge: Photo;
  challengeType?: Maybe<ChallengeType>;
  endDate?: Maybe<Scalars['LocalDate']['output']>;
  goal?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  qualifyingGenres?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startDate?: Maybe<Scalars['LocalDate']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  timeUnit?: Maybe<ChallengeTimeUnit>;
  title: Scalars['String']['output'];
  unit?: Maybe<UnitsPreference>;
};

export type ChallengeTemplateEdge = Edge & {
  __typename?: 'ChallengeTemplateEdge';
  cursor: Scalars['String']['output'];
  node: ChallengeTemplate;
};

export enum ChallengeTimeUnit {
  Hours = 'Hours',
  Minutes = 'Minutes',
}

export enum ChallengeType {
  ClassCount = 'ClassCount',
  Distance = 'Distance',
  GymArrival = 'GymArrival',
  StepCount = 'StepCount',
  Time = 'Time',
}

export type ChallengesActivityConnection = Connection & {
  __typename?: 'ChallengesActivityConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChallengesActivityEdge>;
  nodes: Array<Activity>;
  pageInfo: PageInfo;
};

export type ChallengesActivityEdge = Edge & {
  __typename?: 'ChallengesActivityEdge';
  cursor: Scalars['String']['output'];
  node: Activity;
};

export type ChallengesFilter = {
  excludeActiveChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  excludeArrivalChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  excludeEarnedBadgesSeen?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFutureChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIncompleteChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  excludeNotFinishedAndNotCompletedChallenges?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  excludePastChallenges?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatRoom = Node & {
  __typename?: 'ChatRoom';
  app?: Maybe<App>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  isStarred: Scalars['Boolean']['output'];
  kind: ChatRoomKind;
  lastMessageRead?: Maybe<Scalars['ZonedDateTime']['output']>;
  lastMessageReceivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  messages: ChatRoomMessagesConnection;
  name?: Maybe<Scalars['String']['output']>;
  users: ChatRoomUsersConnection;
};

export type ChatRoomMessagesArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export enum ChatRoomKind {
  Bot = 'bot',
  Direct = 'direct',
  Generic = 'generic',
  /** @deprecated No longer supported */
  Team = 'team',
}

export type ChatRoomMessagesConnection = Connection & {
  __typename?: 'ChatRoomMessagesConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChatRoomMessagesEdge>;
  nodes: Array<Message>;
  pageInfo: PageInfo;
  unreadMessageCount: Scalars['Int']['output'];
};

export type ChatRoomMessagesEdge = Edge & {
  __typename?: 'ChatRoomMessagesEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type ChatRoomUsersConnection = Connection & {
  __typename?: 'ChatRoomUsersConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChatRoomUsersEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type ChatRoomUsersEdge = Edge & {
  __typename?: 'ChatRoomUsersEdge';
  cursor: Scalars['String']['output'];
  lastMessageRead?: Maybe<Scalars['ZonedDateTime']['output']>;
  node: User;
};

export type ChatRoomsFilter = {
  apps?: InputMaybe<Array<App>>;
  /** Restricts results to bot chats with the given bot. Implies kinds: [bot]. */
  botKind?: InputMaybe<BotKind>;
  coachingExperienceType?: InputMaybe<
    Array<CoachUserCoachingExperienceTypeFilter>
  >;
  createdAtDateRange?: InputMaybe<DateRange>;
  hasUnreadMessages?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<ChatRoomKind>>;
  memberHasSignedIn?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export enum ChatRoomsOrder {
  LastFitActivity = 'lastFitActivity',
  LastMessageReceivedAt = 'lastMessageReceivedAt',
  LastPerformActivity = 'lastPerformActivity',
  UserJoinedAt = 'userJoinedAt',
  /** @deprecated use lastFitActivity or lastPerformActivity */
  UserLastActivity = 'userLastActivity',
}

export type ChatRoomsOrderBy = {
  direction: OrderDirection;
  order: ChatRoomsOrder;
};

export type CheckInPayload = {
  __typename?: 'CheckInPayload';
  mboClass: MboClass;
};

export type ClassSchedulesEndDatesInput = {
  classIds: Array<Scalars['Int']['input']>;
  mboStudioId: Scalars['Int']['input'];
  newEndDate: Scalars['LocalDate']['input'];
  programId: Scalars['Int']['input'];
  searchEndDate: Scalars['LocalDate']['input'];
};

export type ClassSchedulesEndDatesResult = {
  __typename?: 'ClassSchedulesEndDatesResult';
  schedulesToUpdate: Scalars['Int']['output'];
  totalSchedules: Scalars['Int']['output'];
  uniqueClassNamesToUpdate: Array<Scalars['String']['output']>;
};

export type ClickThroughMedia = Content &
  Node & {
    __typename?: 'ClickThroughMedia';
    author?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    icon?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    isPublished: Scalars['Boolean']['output'];
    kind?: Maybe<Scalars['String']['output']>;
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    pages: ContentConnection;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type ClickThroughMediaPagesArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ClickThroughMediaRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type Client = Node & {
  __typename?: 'Client';
  allowsCoachesToCreateMembers: Scalars['Boolean']['output'];
  appRegistrationEnabled: Scalars['Boolean']['output'];
  auditLogs: AuditLogsConnection;
  /** Duration in days after which a user is forced to sign out even when using biometric authentication */
  biometricHardSignOutDuration?: Maybe<Scalars['Int']['output']>;
  /** Duration in minutes of inactivity after which a user must re-authenticate with biometrics */
  biometricInactivityTimeout?: Maybe<Scalars['Int']['output']>;
  biometricsEnabled: Scalars['Boolean']['output'];
  calendarPlatform?: Maybe<ClientCalendarPlatform>;
  coaches: ClientUsersConnection;
  collectsMemberData: Scalars['Boolean']['output'];
  collectsMemberDataForEEP: Scalars['Boolean']['output'];
  /** Used by admin to diagnose configuration issues */
  configurationIssues: Array<ConfigurationIssue>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  cronofyConferencingUrl?: Maybe<Scalars['String']['output']>;
  cronofyExternalCalendarUrl?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  domains: DomainConnection;
  id: Scalars['ID']['output'];
  inactivityDuration?: Maybe<Scalars['Duration']['output']>;
  isArchived: Scalars['Boolean']['output'];
  isFcmOnly: Scalars['Boolean']['output'];
  /** Latest `updatedAt` on non-archived eligible emails with `source` = file. */
  lastFileImportAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  /** Latest `updatedAt` on non-archived eligible emails with `source` = mbo. */
  lastMboImportAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  logo?: Maybe<Photo>;
  maxFamilyMembers: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  needsUsToFixTheirUserNames: Scalars['Boolean']['output'];
  requiresEligibleEmailForGym: Scalars['Boolean']['output'];
  /** How often service appointment start times are offered. session_default uses fixed blocks of the session duration. */
  serviceSlotIncrement: ServiceSlotIncrement;
  ssoIdentity?: Maybe<SsoIdentity>;
  /** if true, members from this client will be subject to stricter app check enforcement than other clients */
  strictAppCheck: Scalars['Boolean']['output'];
  studios: Array<Studio>;
  users: ClientUsersConnection;
  usesCustomChallenges: Scalars['Boolean']['output'];
  usesEligibility: Scalars['Boolean']['output'];
  usesEligibilityServiceType: Scalars['Boolean']['output'];
  usesFitnessCenterForEligibility: Scalars['Boolean']['output'];
  usesGlobalSignOut: Scalars['Boolean']['output'];
  usesHighPerformanceCoaching: Scalars['Boolean']['output'];
  usesMboSso: Scalars['Boolean']['output'];
  usesPersonalTraining: Scalars['Boolean']['output'];
  usesSSO: Scalars['Boolean']['output'];
  /** validLocations are locations with coach assignments */
  validLocations: CoachLocationsConnection;
  videoPlatform?: Maybe<ClientVideoPlatform>;
};

export type ClientAuditLogsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ClientCoachesArgs = {
  coachName?: InputMaybe<Scalars['String']['input']>;
  excludeInvalidCoaches?: InputMaybe<Scalars['Boolean']['input']>;
  includeHighPerformance?: InputMaybe<Scalars['Boolean']['input']>;
  includeWellbeing?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<ConnectionInput>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CoachType>;
  types?: InputMaybe<Array<CoachType>>;
};

export type ClientCronofyConferencingUrlArgs = {
  returnUrl: Scalars['String']['input'];
};

export type ClientCronofyExternalCalendarUrlArgs = {
  returnUrl: Scalars['String']['input'];
};

export type ClientDomainsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ClientStudiosArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeCentralStudio?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type ClientValidLocationsArgs = {
  filter?: InputMaybe<LocationsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export enum ClientCalendarPlatform {
  Apple = 'apple',
  Exchange = 'exchange',
  ExosOnly = 'exos_only',
  Google = 'google',
  LiveConnect = 'live_connect',
  Office365 = 'office365',
}

export type ClientUsersConnection = Connection & {
  __typename?: 'ClientUsersConnection';
  count: Scalars['Int']['output'];
  edges: Array<ClientUsersEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type ClientUsersEdge = Edge & {
  __typename?: 'ClientUsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export enum ClientVideoPlatform {
  EightByEight = 'eight_by_eight',
  GoTo = 'go_to',
  Indeed = 'indeed',
  Integrated = 'integrated',
  MsTeams = 'ms_teams',
  Zoom = 'zoom',
}

export type ClientsFilter = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CoachAppointmentsFilter = {
  dates: DateRange;
};

export type CoachBasedActivity = {
  coachAvatar?: Maybe<Photo>;
  coachFirstName?: Maybe<Scalars['String']['output']>;
  coachLastName?: Maybe<Scalars['String']['output']>;
};

export type CoachClientsConnection = Connection & {
  __typename?: 'CoachClientsConnection';
  count: Scalars['Int']['output'];
  edges: Array<CoachClientsEdge>;
  nodes: Array<Client>;
  pageInfo: PageInfo;
};

export type CoachClientsEdge = Edge & {
  __typename?: 'CoachClientsEdge';
  availableForAssignment: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  node: Client;
  supportsHighPerformanceCoaching: Scalars['Boolean']['output'];
  supportsWellbeingCoaching: Scalars['Boolean']['output'];
};

export type CoachClientsInput = {
  availableForAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['ID']['input'];
  supportsHighPerformanceCoaching?: InputMaybe<Scalars['Boolean']['input']>;
  supportsWellbeingCoaching?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoachCreateUserInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  coachId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CoachData = {
  __typename?: 'CoachData';
  appointments: AppointmentBookingsConnection;
  availability: UserAvailabilityConnection;
  bio: Scalars['String']['output'];
  bodyPhoto?: Maybe<Photo>;
  calendarBuffer: CalendarBuffer;
  calendarConnected: Scalars['Boolean']['output'];
  calendarProfiles: Array<CalendarProfile>;
  calendlyUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated use coachClients instead */
  clients: RootClientsConnection;
  coachClients: CoachClientsConnection;
  coachUsers: CoachUsersConnection;
  coachingStyle?: Maybe<CoachingStyle>;
  conferencingProfiles: Array<ConferencingProfile>;
  cronofyAuthUrl?: Maybe<Scalars['String']['output']>;
  cronofyConferencingUrl?: Maybe<Scalars['String']['output']>;
  cronofyElementToken?: Maybe<Scalars['String']['output']>;
  cronofyExternalCalendarUrl?: Maybe<Scalars['String']['output']>;
  cronofySub?: Maybe<Scalars['String']['output']>;
  cronofyTimezone?: Maybe<Scalars['ZoneId']['output']>;
  dailySessionLimit?: Maybe<Scalars['Int']['output']>;
  degrees: Array<Scalars['String']['output']>;
  externalCalendarConnected?: Maybe<ClientCalendarPlatform>;
  fitCoachId?: Maybe<Scalars['String']['output']>;
  hasHpcMembers: Scalars['Boolean']['output'];
  headshot?: Maybe<Photo>;
  id: Scalars['ID']['output'];
  inOfficeDays: Array<Scalars['Int']['output']>;
  /** @deprecated Use calendlyUrl instead */
  inPersonCalendlyUrl?: Maybe<Scalars['String']['output']>;
  locations: CoachLocationsConnection;
  mboStaffId?: Maybe<Scalars['String']['output']>;
  passions: Array<Scalars['String']['output']>;
  sessions: UserCoachSessionsConnection;
  supportedCountries: Array<Country>;
  supportedGoals: Array<Goal>;
  titles: Array<Scalars['String']['output']>;
  totalUnreadMessageCount: Scalars['Int']['output'];
  touchPoints: CoachTouchPointConnection;
  type?: Maybe<CoachType>;
  videoPlatformConnected?: Maybe<ClientVideoPlatform>;
  /** @deprecated We do not use Zoom API directly anymore */
  zoomId?: Maybe<Scalars['String']['output']>;
};

export type CoachDataAppointmentsArgs = {
  filter: CoachAppointmentsFilter;
  input?: InputMaybe<ConnectionInput>;
};

export type CoachDataAvailabilityArgs = {
  bypassOneDayDelay?: InputMaybe<Scalars['Boolean']['input']>;
  duration: Scalars['Int']['input'];
  interval: Scalars['Int']['input'];
  sessionStyle?: InputMaybe<CoachSessionStyle>;
  start: Scalars['ZonedDateTime']['input'];
};

export type CoachDataClientsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CoachDataCoachClientsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CoachDataCoachUsersArgs = {
  filter?: InputMaybe<CoachUsersFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<CoachUsersOrderBy>>;
};

export type CoachDataCronofyAuthUrlArgs = {
  returnUrl: Scalars['String']['input'];
};

export type CoachDataCronofyConferencingUrlArgs = {
  returnUrl: Scalars['String']['input'];
  videoPlatform?: InputMaybe<ClientVideoPlatform>;
};

export type CoachDataCronofyElementTokenArgs = {
  permissions?: InputMaybe<Array<CronofyElementPermission>>;
};

export type CoachDataCronofyExternalCalendarUrlArgs = {
  calendarPlatform?: InputMaybe<ClientCalendarPlatform>;
  returnUrl: Scalars['String']['input'];
};

export type CoachDataLocationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CoachDataSessionsArgs = {
  filter?: InputMaybe<CoachSessionFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<CoachSessionOrderBy>>;
};

export type CoachDataTouchPointsArgs = {
  filter?: InputMaybe<TouchPointFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<TouchPointsOrderBy>>;
};

export type CoachLocation = Node & {
  __typename?: 'CoachLocation';
  auditLogs: AuditLogsConnection;
  coaches: LocationCoachesConnection;
  contactEmail?: Maybe<Scalars['String']['output']>;
  defaultPostConnectionInstructions: Scalars['String']['output'];
  gymImage?: Maybe<Photo>;
  id: Scalars['ID']['output'];
  isHeadquarters: Scalars['Boolean']['output'];
  joinGymInstructions?: Maybe<Scalars['String']['output']>;
  mboLocationId?: Maybe<Scalars['String']['output']>;
  membershipAgreementConsentText?: Maybe<Scalars['String']['output']>;
  membershipAgreementLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postConnectionInstructions?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  studio?: Maybe<Studio>;
};

export type CoachLocationAuditLogsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CoachLocationCoachesArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CoachLocationsConnection = Connection & {
  __typename?: 'CoachLocationsConnection';
  count: Scalars['Int']['output'];
  edges: Array<CoachLocationsEdge>;
  nodes: Array<CoachLocation>;
  pageInfo: PageInfo;
};

export type CoachLocationsEdge = Edge & {
  __typename?: 'CoachLocationsEdge';
  cursor: Scalars['String']['output'];
  node: CoachLocation;
};

export type CoachLocationsFilter = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  studioIsArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoachMboClassFilter = {
  dates: DateRange;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  studioIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CoachSession = Node & {
  __typename?: 'CoachSession';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  attendance?: Maybe<CoachSessionAttendance>;
  attended?: Maybe<Scalars['Boolean']['output']>;
  calendar?: Maybe<Calendar>;
  cancelUrl?: Maybe<Scalars['String']['output']>;
  cancellableUntil: Scalars['ZonedDateTime']['output'];
  chatRoom?: Maybe<ChatRoom>;
  coach: User;
  id: Scalars['ID']['output'];
  joinableTime: Scalars['ZonedDateTime']['output'];
  location?: Maybe<CoachLocation>;
  meetingUrl?: Maybe<Scalars['String']['output']>;
  member: User;
  reason?: Maybe<Scalars['String']['output']>;
  rescheduleUrl?: Maybe<Scalars['String']['output']>;
  sessionStyle: CoachSessionStyle;
  sessionSubtype?: Maybe<CoachSessionSubtype>;
  sessionType?: Maybe<CoachSessionType>;
  /** @deprecated Use sessionType instead */
  type: Scalars['String']['output'];
};

export enum CoachSessionAttendance {
  Attended = 'Attended',
  Excused = 'Excused',
  NoShow = 'NoShow',
}

export type CoachSessionCredits = {
  __typename?: 'CoachSessionCredits';
  count: Scalars['Int']['output'];
  rowVersion: Scalars['Int']['output'];
};

export type CoachSessionFilter = {
  attendance?: InputMaybe<CoachSessionAttendance>;
  attendances?: InputMaybe<Array<InputMaybe<CoachSessionAttendance>>>;
  coachId?: InputMaybe<Scalars['ID']['input']>;
  coachSessionStyle?: InputMaybe<Array<CoachSessionStyle>>;
  coachingExperienceType?: InputMaybe<
    Array<CoachUserCoachingExperienceTypeFilter>
  >;
  dateRange?: InputMaybe<DateRange>;
  memberName?: InputMaybe<Scalars['String']['input']>;
  sessionType?: InputMaybe<CoachSessionType>;
  sessionTypes?: InputMaybe<Array<CoachSessionType>>;
};

export enum CoachSessionOrder {
  SessionTime = 'sessionTime',
}

export type CoachSessionOrderBy = {
  direction: OrderDirection;
  order: CoachSessionOrder;
};

export enum CoachSessionStyle {
  InPerson = 'InPerson',
  Virtual = 'Virtual',
}

export enum CoachSessionSubtype {
  BodyCompositionAssessment = 'BodyCompositionAssessment',
  ErgonomicEvaluation = 'ErgonomicEvaluation',
  MovementAssessment = 'MovementAssessment',
  NewMemberOrientation = 'NewMemberOrientation',
}

export enum CoachSessionType {
  CoachingSession = 'CoachingSession',
  PersonalTraining = 'PersonalTraining',
  UserCoachingConsult = 'UserCoachingConsult',
  UserNutritionConsult = 'UserNutritionConsult',
}

export type CoachTouchPoint = Node & {
  __typename?: 'CoachTouchPoint';
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  description: Scalars['String']['output'];
  due: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  member: User;
  metadata?: Maybe<CoachTouchPointMetadata>;
  status: CoachTouchPointStatus;
  title: Scalars['String']['output'];
  type: CoachTouchPointType;
};

export type CoachTouchPointConnection = Connection & {
  __typename?: 'CoachTouchPointConnection';
  count: Scalars['Int']['output'];
  edges: Array<CoachTouchPointEdge>;
  nodes: Array<CoachTouchPoint>;
  pageInfo: PageInfo;
};

export type CoachTouchPointEdge = Edge & {
  __typename?: 'CoachTouchPointEdge';
  cursor: Scalars['String']['output'];
  node: CoachTouchPoint;
};

export type CoachTouchPointMetadata = CoachTouchPointSessionMetadata;

export enum CoachTouchPointOrder {
  Due = 'due',
}

export type CoachTouchPointSessionMetadata = {
  __typename?: 'CoachTouchPointSessionMetadata';
  isCancelled: Scalars['Boolean']['output'];
  isRebooked: Scalars['Boolean']['output'];
  session?: Maybe<CoachSession>;
};

export enum CoachTouchPointStatus {
  Completed = 'Completed',
  Incomplete = 'Incomplete',
}

export enum CoachTouchPointType {
  AssessmentNotCompleted = 'AssessmentNotCompleted',
  CoachLedAssessmentsCompleted = 'CoachLedAssessmentsCompleted',
  CoachLedSessionEntryPoint = 'CoachLedSessionEntryPoint',
  CompleteFirstDailyCheckIn = 'CompleteFirstDailyCheckIn',
  Custom = 'Custom',
  CustomPlanAdherence = 'CustomPlanAdherence',
  CustomPlanCheckInNote = 'CustomPlanCheckInNote',
  CustomPlanExpired = 'CustomPlanExpired',
  CustomPlanExpiring = 'CustomPlanExpiring',
  DailyCheckInNotCompleted = 'DailyCheckInNotCompleted',
  GameplanFinalWeekCheckIn = 'GameplanFinalWeekCheckIn',
  GameplanWeeklyCheckIn = 'GameplanWeeklyCheckIn',
  NewMemberActivationAtRisk = 'NewMemberActivationAtRisk',
  OneWeekPostSessionCheckIn = 'OneWeekPostSessionCheckIn',
  ReassessmentReminder = 'ReassessmentReminder',
  SendMessageReminder = 'SendMessageReminder',
  SessionReminder = 'SessionReminder',
  TrackAttendance = 'TrackAttendance',
  TrainingPlanAutoAssigned = 'TrainingPlanAutoAssigned',
  TrainingPlanEndingReminder = 'TrainingPlanEndingReminder',
  TrainingPlanMemberFeedback = 'TrainingPlanMemberFeedback',
  TrainingPlanMissedWorkout = 'TrainingPlanMissedWorkout',
}

export enum CoachType {
  CalendarOnly = 'CalendarOnly',
  Coach = 'Coach',
  Dietitian = 'Dietitian',
  PerformCoach = 'PerformCoach',
}

export enum CoachUserCoachingExperienceTypeFilter {
  CoachLed = 'coachLed',
  HighPerformance = 'highPerformance',
  SelfLed = 'selfLed',
  Wellbeing = 'wellbeing',
}

export enum CoachUserFeatureStatusFilter {
  HasChallenge = 'hasChallenge',
  HasTrainingPlan = 'hasTrainingPlan',
}

export enum CoachUserGeneralFilter {
  HasUnreadMessages = 'hasUnreadMessages',
  IsStarred = 'isStarred',
}

export enum CoachUserMboMembershipTypeFilter {
  Hybrid = 'hybrid',
  Virtual = 'virtual',
}

export enum CoachUserSessionFilter {
  HasAttendedSession = 'hasAttendedSession',
  HasUpcomingSession = 'hasUpcomingSession',
  NoAttendedSession = 'noAttendedSession',
  NoUpcomingSession = 'noUpcomingSession',
}

export enum CoachUserStatusFilter {
  IsActive = 'isActive',
  IsInactive = 'isInactive',
  IsNew = 'isNew',
}

export type CoachUsersConnection = Connection & {
  __typename?: 'CoachUsersConnection';
  count: Scalars['Int']['output'];
  edges: Array<CoachUsersEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type CoachUsersEdge = Edge & {
  __typename?: 'CoachUsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type CoachUsersFilter = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  coachingExperienceType?: InputMaybe<
    Array<CoachUserCoachingExperienceTypeFilter>
  >;
  createdAtDateRange?: InputMaybe<DateRange>;
  featureStatus?: InputMaybe<Array<CoachUserFeatureStatusFilter>>;
  general?: InputMaybe<Array<CoachUserGeneralFilter>>;
  hasUnreadMessages?: InputMaybe<Scalars['Boolean']['input']>;
  isStarred?: InputMaybe<Scalars['Boolean']['input']>;
  isStubUser?: InputMaybe<Scalars['Boolean']['input']>;
  mboMembershipType?: InputMaybe<Array<CoachUserMboMembershipTypeFilter>>;
  recentActivityDateRange?: InputMaybe<DateRange>;
  session?: InputMaybe<Array<CoachUserSessionFilter>>;
  status?: InputMaybe<Array<CoachUserStatusFilter>>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export enum CoachUsersOrder {
  /** @deprecated No longer supported */
  LastFitActivity = 'lastFitActivity',
  LastMessageReceivedAt = 'lastMessageReceivedAt',
  LatestUserActivityStartTime = 'latestUserActivityStartTime',
}

export type CoachUsersOrderBy = {
  direction: OrderDirection;
  order: CoachUsersOrder;
};

export enum CoachingStyle {
  Hybrid = 'Hybrid',
  Virtual = 'Virtual',
}

export type Cohort = Node & {
  __typename?: 'Cohort';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  coaches: CohortCoachesConnection;
  createdAt: Scalars['ZonedDateTime']['output'];
  endDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  members: RootEligibleEmailAddressesConnection;
  name: Scalars['String']['output'];
  startDate: Scalars['ZonedDateTime']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export type CohortCoachesArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CohortMembersArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type CohortCoachesConnection = Connection & {
  __typename?: 'CohortCoachesConnection';
  count: Scalars['Int']['output'];
  edges: Array<CohortCoachesEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type CohortCoachesEdge = Edge & {
  __typename?: 'CohortCoachesEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type CohortsConnection = Connection & {
  __typename?: 'CohortsConnection';
  count: Scalars['Int']['output'];
  edges: Array<CohortsEdge>;
  nodes: Array<Cohort>;
  pageInfo: PageInfo;
};

export type CohortsEdge = Edge & {
  __typename?: 'CohortsEdge';
  cursor: Scalars['String']['output'];
  node: Cohort;
};

export type CohortsFilter = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ConferencingProfile = {
  __typename?: 'ConferencingProfile';
  platform?: Maybe<ClientVideoPlatform>;
  profileConnected: Scalars['Boolean']['output'];
  profileId: Scalars['String']['output'];
  profileName: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
};

export type ConfigurationIssue = {
  __typename?: 'ConfigurationIssue';
  description: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Connection = {
  count: Scalars['Int']['output'];
  edges: Array<Edge>;
  nodes: Array<Node>;
  pageInfo: PageInfo;
};

export type ConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Content = {
  author?: Maybe<Scalars['String']['output']>;
  contentEquipment: Array<Equipment>;
  contentGenre?: Maybe<Genre>;
  contentLevel?: Maybe<Level>;
  contentSplit?: Maybe<Split>;
  contentTime?: Maybe<ContentTime>;
  feedback?: Maybe<FeedbackKind>;
  firstPublishedAt?: Maybe<Scalars['String']['output']>;
  heroPhoto?: Maybe<Photo>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  lastPublishedAt?: Maybe<Scalars['String']['output']>;
  /** @deprecated use contentLevel */
  level?: Maybe<Scalars['String']['output']>;
  logoPhoto?: Maybe<Photo>;
  /** @deprecated use firstPublishedAt */
  publishedAt?: Maybe<Scalars['String']['output']>;
  recommendations: ContentRecommendationsConnection;
  saved?: Maybe<Scalars['Boolean']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  /** @deprecated use contentTime */
  time?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trackingData?: Maybe<ContentTrackingData>;
  trainingCommitment?: Maybe<Scalars['String']['output']>;
};

export type ContentRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ContentAttribute = {
  __typename?: 'ContentAttribute';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContentCollection = {
  __typename?: 'ContentCollection';
  id: Scalars['ID']['output'];
  sections: ContentCollectionSectionsConnection;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ContentCollectionSectionsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ContentCollectionSectionsConnection = Connection & {
  __typename?: 'ContentCollectionSectionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContentCollectionSectionsEdge>;
  nodes: Array<ContentSection>;
  pageInfo: PageInfo;
};

export type ContentCollectionSectionsEdge = Edge & {
  __typename?: 'ContentCollectionSectionsEdge';
  cursor: Scalars['String']['output'];
  node: ContentSection;
};

export type ContentConnection = SimpleContentConnection & {
  __typename?: 'ContentConnection';
  completedCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  edges: Array<ContentEdge>;
  nodes: Array<Content>;
  pageInfo: PageInfo;
};

export type ContentEdge = SimpleContentEdge & {
  __typename?: 'ContentEdge';
  completed: Scalars['Boolean']['output'];
  cursor: Scalars['String']['output'];
  locked: Scalars['Boolean']['output'];
  node: Content;
  progress?: Maybe<Scalars['Float']['output']>;
};

export type ContentFeedbackPayload = {
  __typename?: 'ContentFeedbackPayload';
  content: Content;
};

export type ContentFilter = {
  associatedProject?: InputMaybe<Array<Scalars['String']['input']>>;
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  component?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Array<Scalars['Int']['input']>>;
  equipment?: InputMaybe<Array<Scalars['String']['input']>>;
  gameplanPrimaryComponent?: InputMaybe<Array<Scalars['String']['input']>>;
  gameplanPrimarySubcomponents?: InputMaybe<Array<Scalars['String']['input']>>;
  gameplanSecondaryComponent?: InputMaybe<Array<Scalars['String']['input']>>;
  gameplanSecondarySubcomponents?: InputMaybe<
    Array<Scalars['String']['input']>
  >;
  genre?: InputMaybe<Array<Scalars['String']['input']>>;
  intensity?: InputMaybe<Array<Scalars['String']['input']>>;
  isExperiential?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Array<Scalars['String']['input']>>;
  performanceQuality?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  split?: InputMaybe<Array<Scalars['String']['input']>>;
  subGenre?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ContentGenreFilter = {
  includeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ContentKind {
  Article = 'article',
  Inappsurvey = 'inappsurvey',
  Link = 'link',
  Video = 'video',
}

export enum ContentOrder {
  FirstPublishedAt = 'first_published_at',
  LastPublishedAt = 'last_published_at',
  /** @deprecated use first_published_at */
  PublishedAt = 'published_at',
  Title = 'title',
}

export type ContentOrderBy = {
  direction: OrderDirection;
  order?: InputMaybe<ContentOrder>;
};

export type ContentRecommendationsConnection = SimpleContentConnection & {
  __typename?: 'ContentRecommendationsConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContentRecommendationsEdge>;
  nodes: Array<Content>;
  pageInfo: PageInfo;
};

export type ContentRecommendationsEdge = SimpleContentEdge & {
  __typename?: 'ContentRecommendationsEdge';
  cursor: Scalars['String']['output'];
  node: Content;
};

export type ContentSavedConnection = SimpleContentConnection & {
  __typename?: 'ContentSavedConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContentSavedEdge>;
  nodes: Array<Content>;
  pageInfo: PageInfo;
};

export type ContentSavedEdge = SimpleContentEdge & {
  __typename?: 'ContentSavedEdge';
  cursor: Scalars['String']['output'];
  node: Content;
};

export type ContentSection = Content &
  Node & {
    __typename?: 'ContentSection';
    author?: Maybe<Scalars['String']['output']>;
    bannerPhoto?: Maybe<Photo>;
    brand?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    contents: ContentConnection;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    isPublished: Scalars['Boolean']['output'];
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type ContentSectionContentsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ContentSectionRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ContentTime = {
  __typename?: 'ContentTime';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ContentTrackingData = {
  __typename?: 'ContentTrackingData';
  class_id?: Maybe<Scalars['String']['output']>;
  event_category?: Maybe<Scalars['String']['output']>;
  event_label?: Maybe<Scalars['String']['output']>;
  event_location?: Maybe<Scalars['String']['output']>;
  event_name?: Maybe<Scalars['String']['output']>;
  event_subcategory?: Maybe<Scalars['String']['output']>;
  event_type?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  studio_id?: Maybe<Scalars['String']['output']>;
};

export type ContractOptionsInput = {
  locationId: Scalars['ID']['input'];
  mboSessionTypeId: Scalars['Int']['input'];
};

export type Country = {
  __typename?: 'Country';
  alpha2: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CreateAuthLogInput = {
  awsRequestId?: InputMaybe<Scalars['String']['input']>;
  cognitoSub?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorStack?: InputMaybe<Scalars['String']['input']>;
  outcome: AuthLogOutcome;
  provider?: InputMaybe<Scalars['String']['input']>;
  type: AuthLogType;
};

export type CreateChallengeInput = {
  backgroundId?: InputMaybe<Scalars['String']['input']>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  challengeType: ChallengeType;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  clientSpecific?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  distanceUnit?: InputMaybe<DistanceUnit>;
  enabled: Scalars['Boolean']['input'];
  endDate: Scalars['LocalDate']['input'];
  featured: Scalars['Boolean']['input'];
  goal: Scalars['Float']['input'];
  qualifyingGenres: Array<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Boolean']['input']>;
  teams?: InputMaybe<Array<CreateChallengeTeamInput>>;
  timeUnit?: InputMaybe<ChallengeTimeUnit>;
  title: Scalars['String']['input'];
};

export type CreateChallengePayload = {
  __typename?: 'CreateChallengePayload';
  challenge: Challenge;
};

export type CreateChallengeTeamInput = {
  name: Scalars['String']['input'];
};

export type CreateChatRoomInput = {
  app?: InputMaybe<App>;
  initialMessage?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ChatRoomKind>;
  name: Scalars['String']['input'];
  users: Array<Scalars['String']['input']>;
};

export type CreateClientInput = {
  allowsCoachesToCreateMembers?: InputMaybe<Scalars['Boolean']['input']>;
  biometricHardSignOutDuration?: InputMaybe<Scalars['Int']['input']>;
  biometricInactivityTimeout?: InputMaybe<Scalars['Int']['input']>;
  biometricsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPlatform?: InputMaybe<ClientCalendarPlatform>;
  collectsMemberData?: InputMaybe<Scalars['Boolean']['input']>;
  collectsMemberDataForEEP?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  domainIds?: InputMaybe<Array<Scalars['String']['input']>>;
  inactivityDuration?: InputMaybe<Scalars['Duration']['input']>;
  isFcmOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  maxFamilyMembers?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsUsToFixTheirUserNames?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEligibleEmailForGym?: InputMaybe<Scalars['Boolean']['input']>;
  serviceSlotIncrement?: InputMaybe<ServiceSlotIncrement>;
  ssoConnection?: InputMaybe<Scalars['String']['input']>;
  strictAppCheck?: InputMaybe<Scalars['Boolean']['input']>;
  usesCustomChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  usesEligibilityServiceType?: InputMaybe<Scalars['Boolean']['input']>;
  usesFitnessCenterForEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  usesGlobalSignOut?: InputMaybe<Scalars['Boolean']['input']>;
  usesMboSso?: InputMaybe<Scalars['Boolean']['input']>;
  videoPlatform?: InputMaybe<ClientVideoPlatform>;
};

export type CreateCoachLocationInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  gymImageId?: InputMaybe<Scalars['String']['input']>;
  isHeadquarters: Scalars['Boolean']['input'];
  joinGymInstructions?: InputMaybe<Scalars['String']['input']>;
  mboLocationId: Scalars['String']['input'];
  membershipAgreementConsentText?: InputMaybe<Scalars['String']['input']>;
  membershipAgreementLink?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postConnectionInstructions?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['String']['input'];
  studioId: Scalars['String']['input'];
};

export type CreateCoachTouchPointInput = {
  coachId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  due?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  memberId: Scalars['ID']['input'];
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  sessionTime?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: CoachTouchPointType;
};

export type CreateCohortInput = {
  endDate: Scalars['ZonedDateTime']['input'];
  name: Scalars['String']['input'];
  startDate: Scalars['ZonedDateTime']['input'];
};

export type CreateContentGenreInput = {
  hideChildren?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  value: Scalars['String']['input'];
};

export type CreateCustomChallengeInput = {
  challengeType: ChallengeType;
  distanceUnit?: InputMaybe<DistanceUnit>;
  endDate: Scalars['LocalDate']['input'];
  goal: Scalars['Int']['input'];
  qualifyingGenres: Array<Scalars['String']['input']>;
  startDate: Scalars['LocalDate']['input'];
  timeUnit?: InputMaybe<ChallengeTimeUnit>;
};

export type CreateDomainInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
};

export type CreateEligibleEmailAddressInput = {
  clientId: Scalars['String']['input'];
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  employeeType?: InputMaybe<Scalars['String']['input']>;
  hpcEligibilityEnd?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  hpcEligibilityStart?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  isAppEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFcmEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  officeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExerciseBaseInput = {
  exerciseTypeId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  progression?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateExerciseInput = {
  bodyParts?: InputMaybe<Array<Scalars['String']['input']>>;
  canTrackWeight?: InputMaybe<Scalars['Boolean']['input']>;
  coachNotes?: InputMaybe<Scalars['String']['input']>;
  coachingKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultUnit?: InputMaybe<ExerciseUnit>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Array<Scalars['String']['input']>>;
  exerciseBaseId?: InputMaybe<Scalars['ID']['input']>;
  modifications?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oneRepMax?: InputMaybe<Array<Scalars['Float']['input']>>;
  progression?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CreateExercisePayload = {
  __typename?: 'CreateExercisePayload';
  exercise: Exercise;
};

export type CreateExerciseTypeCategoryGroupInput = {
  name: Scalars['String']['input'];
};

export type CreateExerciseTypeCategoryInput = {
  exerciseTypeCategoryGroupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateExerciseTypeInput = {
  exerciseTypeCategoryId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateFeatureGrantInput = {
  clientId: Scalars['ID']['input'];
  featureId: Scalars['ID']['input'];
  /** Ignored for scopeType `client` (forced to clientId). */
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType: FeatureGrantScopeType;
  state: FeatureState;
};

export type CreateFeatureInput = {
  defaultState: FeatureState;
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  requiresFeatureFlagKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMboContractMappingInput = {
  employeeType: Scalars['String']['input'];
  mboServiceId: Scalars['String']['input'];
  studioId: Scalars['ID']['input'];
};

export type CreateMboMembershipPayload = {
  __typename?: 'CreateMboMembershipPayload';
  user: User;
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type CreateNotificationOptionInput = {
  app: App;
  description: Scalars['String']['input'];
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  iterableId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  value?: InputMaybe<NotificationOptionValue>;
  visible: Scalars['Boolean']['input'];
};

export type CreateOfficeInput = {
  clientId: Scalars['ID']['input'];
  clientOfficeId: Scalars['String']['input'];
  isAppEligible: Scalars['Boolean']['input'];
  isFcmEligible: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePerformanceQualityScoreInput = {
  component: Scalars['String']['input'];
  performanceQuality: Scalars['String']['input'];
  score: Scalars['Int']['input'];
  subComponent: Scalars['String']['input'];
};

export type CreatePlanInput = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** If true, will allow admin users in the dev environment to override start date restrictions */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  planItems?: InputMaybe<Array<CreatePlanItemInput>>;
  startDate: Scalars['LocalDate']['input'];
  targetedPerformanceQualities?: InputMaybe<Array<PerformanceQuality>>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreatePlanItemInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['LocalDate']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: PlanItemType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlanPayload = {
  __typename?: 'CreatePlanPayload';
  plan: Plan;
};

export type CreateStubUsersInput = {
  clientId: Scalars['ID']['input'];
  coachId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
};

export type CreateStubUsersPayload = {
  __typename?: 'CreateStubUsersPayload';
  createdCount: Scalars['Int']['output'];
  users: Array<User>;
};

export type CreateStudioInput = {
  canGrantEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCentral?: InputMaybe<Scalars['Boolean']['input']>;
  isVirtual: Scalars['Boolean']['input'];
  mboProgramId?: InputMaybe<Scalars['String']['input']>;
  mboServiceId: Scalars['String']['input'];
  mboStudioId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type CreateTestUserInput = {
  clientId: Scalars['ID']['input'];
  /** Absolute expiry timestamp; must be in the future. */
  expiresAt: Scalars['ZonedDateTime']['input'];
  /** Features to enable for the new user, written as user-scope grants. */
  featureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateTestUserPayload = {
  __typename?: 'CreateTestUserPayload';
  email: Scalars['String']['output'];
  expiresAt: Scalars['ZonedDateTime']['output'];
  /** Plaintext password, returned exactly once. Never persisted or logged. */
  password: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type CreateTrainingPlanInput = {
  coachId: Scalars['ID']['input'];
  /**
   * Dev-only override for the plan's creation date, used by the test-data seeder
   * to make demo plans read as already underway (the member-profile UI shows this
   * as the "Published" date). Ignored outside dev environments.
   */
  createdAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  difficulty: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  equipmentCategory?: InputMaybe<TrainingPlanEquipmentCategory>;
  frequency: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phase: Scalars['Int']['input'];
  templateId: Scalars['ID']['input'];
  type?: InputMaybe<TrainingPlanType>;
  userId: Scalars['ID']['input'];
  weeks: Array<TrainingPlanWeekInput>;
};

export type CreateTrainingPlanTemplateInput = {
  difficulty: Scalars['String']['input'];
  durationMinutes: Scalars['Int']['input'];
  equipmentCategory?: InputMaybe<TrainingPlanEquipmentCategory>;
  frequency: Scalars['Int']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phase: Scalars['Int']['input'];
  type?: InputMaybe<TrainingPlanType>;
  weeks: Array<TrainingPlanWeekInput>;
};

export type CreateUserGoalInput = {
  coachId?: InputMaybe<Scalars['ID']['input']>;
  coachNote?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['ID']['input']>;
  type: UserGoalType;
};

export type CreateUserGoalPayload = {
  __typename?: 'CreateUserGoalPayload';
  user: User;
};

export type CreateUserInput = {
  adminCreate?: InputMaybe<Scalars['Boolean']['input']>;
  app?: InputMaybe<App>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  isCoach?: InputMaybe<Scalars['Boolean']['input']>;
  isE2E?: InputMaybe<Scalars['Boolean']['input']>;
  isTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  shareDataWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  shareEEPData?: InputMaybe<Scalars['Boolean']['input']>;
  skipIterableRegistration?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  user: User;
};

export type CreateUsersInput = {
  users: Array<CreateUserInput>;
};

export type CreateUsersPayload = {
  __typename?: 'CreateUsersPayload';
  users: Array<User>;
};

export enum CronofyElementPermission {
  Agenda = 'agenda',
  Availability = 'availability',
  ManagedAvailability = 'managed_availability',
}

export type CustomChallengeDefaults = {
  __typename?: 'CustomChallengeDefaults';
  background: Photo;
  badge: Photo;
};

export type CustomPlanActiveDaysFilter = {
  localDateRange: RequiredLocalDateRange;
};

export type CustomPlanState = Node & {
  __typename?: 'CustomPlanState';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  assessments: Array<AssessmentAssignment>;
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  iterationId: Scalars['Int']['output'];
  phase: CustomPlanStatePhase;
};

export type CustomPlanStateConnection = Connection & {
  __typename?: 'CustomPlanStateConnection';
  count: Scalars['Int']['output'];
  edges: Array<CustomPlanStateEdge>;
  nodes: Array<CustomPlanState>;
  pageInfo: PageInfo;
};

export type CustomPlanStateEdge = Edge & {
  __typename?: 'CustomPlanStateEdge';
  cursor: Scalars['String']['output'];
  node: CustomPlanState;
};

export enum CustomPlanStateOrder {
  CreatedAt = 'createdAt',
  IterationId = 'iterationId',
}

export type CustomPlanStateOrderBy = {
  direction: OrderDirection;
  order: CustomPlanStateOrder;
};

export enum CustomPlanStatePhase {
  GameplanPhase = 'gameplan_phase',
  InitialAssessment = 'initial_assessment',
}

export type CustomPlanTemplatesConnection = Connection & {
  __typename?: 'CustomPlanTemplatesConnection';
  count: Scalars['Int']['output'];
  edges: Array<PlanTemplateEdge>;
  nodes: Array<Plan>;
  pageInfo: PageInfo;
};

export type CustomPlanTemplatesFilter = {
  commitmentLevel?: InputMaybe<Array<PlanCommitmentLevel>>;
  focusArea?: InputMaybe<Array<Scalars['String']['input']>>;
  phase?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  targetedPerformanceQualities?: InputMaybe<Array<PerformanceQuality>>;
  trainingMode?: InputMaybe<Array<PlanTrainingMode>>;
};

export type CustomPlansFilter = {
  isArchived?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  localDateRange?: InputMaybe<LocalDateRange>;
};

export type CustomTaskPlanItem = Node &
  PlanItem & {
    __typename?: 'CustomTaskPlanItem';
    archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated Use contentComponent instead */
    component?: Maybe<Scalars['String']['output']>;
    contentComponent?: Maybe<ContentAttribute>;
    date: Scalars['LocalDate']['output'];
    deletedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    description: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    isLocked: Scalars['Boolean']['output'];
    order: Scalars['Int']['output'];
    title: Scalars['String']['output'];
    type: PlanItemType;
    url?: Maybe<Scalars['String']['output']>;
  };

export type DailyActivityAggregate = {
  __typename?: 'DailyActivityAggregate';
  /** count of activities completed that day, excluding sleep */
  activities: Scalars['Int']['output'];
  date: Scalars['LocalDate']['output'];
  /** count of real activity minutes that day, excluding sleep */
  minutes: Scalars['Int']['output'];
  /** null when no sleep activity was recorded that day */
  minutesAsleep?: Maybe<Scalars['Int']['output']>;
  /** null when no sleep activity with a heart rate reading was recorded that day */
  restingHeartRate?: Maybe<Scalars['Int']['output']>;
};

export type DailyInsightScores = {
  __typename?: 'DailyInsightScores';
  date: Scalars['LocalDate']['output'];
  movement: MovementInsightScores;
};

export type DailyStepEntry = {
  date: Scalars['LocalDate']['input'];
  steps: Scalars['Int']['input'];
};

export type DailySteps = {
  __typename?: 'DailySteps';
  date: Scalars['LocalDate']['output'];
  steps: Scalars['Int']['output'];
};

/** A single error-level log event recorded in Datadog. */
export type DatadogErrorLog = {
  __typename?: 'DatadogErrorLog';
  /** The structured attributes attached to the log line. */
  attributes?: Maybe<Scalars['JSONObject']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  /** Datadog's own identifier for the log event. */
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  service?: Maybe<Scalars['String']['output']>;
  /** Datadog log status, e.g. `error` or `critical`. */
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  timestamp: Scalars['ZonedDateTime']['output'];
  /** Deep link that opens this event in the Datadog log explorer. */
  url: Scalars['String']['output'];
};

export type DatadogErrors = {
  __typename?: 'DatadogErrors';
  logs: Array<DatadogErrorLog>;
  /** Link that opens the underlying search in the Datadog log explorer. */
  searchUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Populated when the search could not be performed — for example when Datadog
   * credentials are not configured for this environment, or when Datadog rejected
   * the request. `logs` is empty whenever this is set.
   */
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export enum DateFilter {
  Future = 'Future',
  Past = 'Past',
}

export type DateRange = {
  end?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  start?: InputMaybe<Scalars['ZonedDateTime']['input']>;
};

export type DeleteFitCoachPayload = {
  __typename?: 'DeleteFitCoachPayload';
  user: User;
};

export type DeleteMboMembershipsPayload = {
  __typename?: 'DeleteMboMembershipsPayload';
  user: User;
};

export type DeletePlanPayload = {
  __typename?: 'DeletePlanPayload';
  plan: Plan;
};

export type DeleteUserGoalPayload = {
  __typename?: 'DeleteUserGoalPayload';
  user: User;
};

export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  userId: Scalars['ID']['output'];
};

export type DeleteUserPostOnboardingRecommendationsInput = {
  userId: Scalars['ID']['input'];
};

export type DeleteUserPostOnboardingRecommendationsPayload = {
  __typename?: 'DeleteUserPostOnboardingRecommendationsPayload';
  count: Scalars['Int']['output'];
};

export type DeleteUsersPayload = {
  __typename?: 'DeleteUsersPayload';
  userIds: Array<Scalars['ID']['output']>;
};

export type Device = {
  __typename?: 'Device';
  app?: Maybe<App>;
  createdAt: Scalars['ZonedDateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  token: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
  user: User;
};

export type DismissPostOnboardingRecommendationInput = {
  id: Scalars['ID']['input'];
};

export type DismissPostOnboardingRecommendationPayload = {
  __typename?: 'DismissPostOnboardingRecommendationPayload';
  recommendation: UserPostOnboardingRecommendation;
};

export enum DisplayConditionCombinator {
  And = 'And',
  Or = 'Or',
}

export type Distance = {
  __typename?: 'Distance';
  unit?: Maybe<DistanceUnit>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DistanceInput = {
  unit: DistanceUnit;
  value: Scalars['Float']['input'];
};

export enum DistanceUnit {
  Kilometers = 'Kilometers',
  Meters = 'Meters',
  Miles = 'Miles',
  Yards = 'Yards',
}

export type Domain = Node & {
  __typename?: 'Domain';
  client?: Maybe<Client>;
  createdAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  domain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DomainConnection = {
  __typename?: 'DomainConnection';
  count: Scalars['Int']['output'];
  edges: Array<DomainEdge>;
  nodes: Array<Domain>;
  pageInfo: PageInfo;
};

export type DomainEdge = Edge & {
  __typename?: 'DomainEdge';
  cursor: Scalars['String']['output'];
  node: Domain;
};

export type DomainsFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type EditActivityInput = {
  distance?: InputMaybe<DistanceInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  heartRate?: InputMaybe<HeartRateInput>;
  id: Scalars['ID']['input'];
  intensity?: InputMaybe<IntensityLevel>;
  startTime?: InputMaybe<Scalars['ZonedDateTime']['input']>;
};

export enum EligibilitySource {
  Admin = 'admin',
  File = 'file',
  Invitation = 'invitation',
  Mbo = 'mbo',
}

export type EligibleEmailAddress = Node & {
  __typename?: 'EligibleEmailAddress';
  addedManually: Scalars['Boolean']['output'];
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  auditLogs: AuditLogsConnection;
  client?: Maybe<Client>;
  cohort?: Maybe<Cohort>;
  createdAt: Scalars['ZonedDateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeType?: Maybe<Scalars['String']['output']>;
  /** @deprecated firstName is no longer required */
  firstName?: Maybe<Scalars['String']['output']>;
  hasHpcEligibility: Scalars['Boolean']['output'];
  hpcEligibilityEnd?: Maybe<Scalars['ZonedDateTime']['output']>;
  hpcEligibilityStart?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  invitingRelationship?: Maybe<FamilyRelationship>;
  invitingUser?: Maybe<User>;
  isAppEligible: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isFcmEligible: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  office?: Maybe<Office>;
  shareInvitation?: Maybe<Share>;
  source?: Maybe<EligibilitySource>;
  updatedAt: Scalars['ZonedDateTime']['output'];
  user?: Maybe<User>;
};

export type EligibleEmailAddressAuditLogsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type EligibleEmailAddressDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type EligibleEmailAddressesFilter = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  hasHpcEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  officeId?: InputMaybe<Scalars['String']['input']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EmergencyContactDetails = {
  __typename?: 'EmergencyContactDetails';
  address?: Maybe<Address>;
  emergencyContact?: Maybe<EmergencyContact>;
  updatedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type EnablePerformanceCoachingForMembersInput = {
  clientId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  earliestSessionStartTime: Scalars['ZonedDateTime']['input'];
  limit: Scalars['Int']['input'];
};

export type EnablePerformanceCoachingForMembersPayload = {
  __typename?: 'EnablePerformanceCoachingForMembersPayload';
  memberIds: Array<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EnumAnswer = {
  __typename?: 'EnumAnswer';
  choices: Array<Scalars['String']['output']>;
  enumValue: Array<Scalars['Int']['output']>;
};

export type Equipment = {
  __typename?: 'Equipment';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Exercise = Node & {
  __typename?: 'Exercise';
  apmlId?: Maybe<Scalars['Int']['output']>;
  bodyParts: Array<Scalars['String']['output']>;
  canTrackWeight: Scalars['Boolean']['output'];
  coachNotes?: Maybe<Scalars['String']['output']>;
  coachingKeys: Array<Scalars['String']['output']>;
  defaultUnit?: Maybe<ExerciseUnitAttribute>;
  displayName?: Maybe<Scalars['String']['output']>;
  equipment: Array<Scalars['String']['output']>;
  exerciseBase?: Maybe<ExerciseBase>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  modifications?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oneRepMax: Array<Scalars['Float']['output']>;
  progression?: Maybe<Scalars['Int']['output']>;
  /**
   * Nearest-sibling exercises by progression. Returns direct siblings first, then
   * exercises from neighbouring bases in the same movement type.
   */
  similarExercises: Array<Exercise>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};

export type ExerciseSimilarExercisesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ExerciseBase = Node & {
  __typename?: 'ExerciseBase';
  apmlId?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  exerciseType: ExerciseType;
  exercises: ExerciseConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  progression?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export type ExerciseBaseExercisesArgs = {
  filter?: InputMaybe<ExercisesFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseOrderBy>>;
};

export type ExerciseBaseConnection = Connection & {
  __typename?: 'ExerciseBaseConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExerciseBaseEdge>;
  nodes: Array<ExerciseBase>;
  pageInfo: PageInfo;
};

export type ExerciseBaseEdge = Edge & {
  __typename?: 'ExerciseBaseEdge';
  cursor: Scalars['String']['output'];
  node: ExerciseBase;
};

export type ExerciseBaseFilter = {
  exerciseTypeCategoryGroupId?: InputMaybe<Scalars['ID']['input']>;
  exerciseTypeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  exerciseTypeId?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  progression?: InputMaybe<Scalars['Int']['input']>;
};

export enum ExerciseBaseOrder {
  CreatedAt = 'createdAt',
  Name = 'name',
  Progression = 'progression',
}

export type ExerciseBaseOrderBy = {
  direction: OrderDirection;
  order: ExerciseBaseOrder;
};

export type ExerciseBasePayload = {
  __typename?: 'ExerciseBasePayload';
  exerciseBase: ExerciseBase;
};

export type ExerciseConnection = Connection & {
  __typename?: 'ExerciseConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExerciseEdge>;
  nodes: Array<Exercise>;
  pageInfo: PageInfo;
};

export type ExerciseEdge = Edge & {
  __typename?: 'ExerciseEdge';
  cursor: Scalars['String']['output'];
  node: Exercise;
};

export enum ExerciseOrder {
  CreatedAt = 'createdAt',
  Name = 'name',
  Progression = 'progression',
}

export type ExerciseOrderBy = {
  direction: OrderDirection;
  order: ExerciseOrder;
};

export type ExerciseType = Node & {
  __typename?: 'ExerciseType';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  exerciseBases: ExerciseBaseConnection;
  exerciseTypeCategory: ExerciseTypeCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export type ExerciseTypeExerciseBasesArgs = {
  filter?: InputMaybe<ExerciseBaseFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseBaseOrderBy>>;
};

export type ExerciseTypeCategory = Node & {
  __typename?: 'ExerciseTypeCategory';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  exerciseTypeCategoryGroup: ExerciseTypeCategoryGroup;
  exerciseTypes: ExerciseTypeConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export type ExerciseTypeCategoryExerciseTypesArgs = {
  filter?: InputMaybe<ExerciseTypeFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseTypeOrderBy>>;
};

export type ExerciseTypeCategoryConnection = Connection & {
  __typename?: 'ExerciseTypeCategoryConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExerciseTypeCategoryEdge>;
  nodes: Array<ExerciseTypeCategory>;
  pageInfo: PageInfo;
};

export type ExerciseTypeCategoryEdge = Edge & {
  __typename?: 'ExerciseTypeCategoryEdge';
  cursor: Scalars['String']['output'];
  node: ExerciseTypeCategory;
};

export type ExerciseTypeCategoryFilter = {
  exerciseTypeCategoryGroupId?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ExerciseTypeCategoryGroup = Node & {
  __typename?: 'ExerciseTypeCategoryGroup';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  exerciseTypeCategories: ExerciseTypeCategoryConnection;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export type ExerciseTypeCategoryGroupExerciseTypeCategoriesArgs = {
  filter?: InputMaybe<ExerciseTypeCategoryFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseTypeCategoryOrderBy>>;
};

export type ExerciseTypeCategoryGroupConnection = Connection & {
  __typename?: 'ExerciseTypeCategoryGroupConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExerciseTypeCategoryGroupEdge>;
  nodes: Array<ExerciseTypeCategoryGroup>;
  pageInfo: PageInfo;
};

export type ExerciseTypeCategoryGroupEdge = Edge & {
  __typename?: 'ExerciseTypeCategoryGroupEdge';
  cursor: Scalars['String']['output'];
  node: ExerciseTypeCategoryGroup;
};

export type ExerciseTypeCategoryGroupFilter = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ExerciseTypeCategoryGroupOrder {
  CreatedAt = 'createdAt',
  Name = 'name',
}

export type ExerciseTypeCategoryGroupOrderBy = {
  direction: OrderDirection;
  order: ExerciseTypeCategoryGroupOrder;
};

export type ExerciseTypeCategoryGroupPayload = {
  __typename?: 'ExerciseTypeCategoryGroupPayload';
  exerciseTypeCategoryGroup: ExerciseTypeCategoryGroup;
};

export enum ExerciseTypeCategoryOrder {
  CreatedAt = 'createdAt',
  Name = 'name',
}

export type ExerciseTypeCategoryOrderBy = {
  direction: OrderDirection;
  order: ExerciseTypeCategoryOrder;
};

export type ExerciseTypeCategoryPayload = {
  __typename?: 'ExerciseTypeCategoryPayload';
  exerciseTypeCategory: ExerciseTypeCategory;
};

export type ExerciseTypeConnection = Connection & {
  __typename?: 'ExerciseTypeConnection';
  count: Scalars['Int']['output'];
  edges: Array<ExerciseTypeEdge>;
  nodes: Array<ExerciseType>;
  pageInfo: PageInfo;
};

export type ExerciseTypeEdge = Edge & {
  __typename?: 'ExerciseTypeEdge';
  cursor: Scalars['String']['output'];
  node: ExerciseType;
};

export type ExerciseTypeFilter = {
  exerciseTypeCategoryGroupId?: InputMaybe<Scalars['ID']['input']>;
  exerciseTypeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ExerciseTypeOrder {
  CreatedAt = 'createdAt',
  Name = 'name',
}

export type ExerciseTypeOrderBy = {
  direction: OrderDirection;
  order: ExerciseTypeOrder;
};

export type ExerciseTypePayload = {
  __typename?: 'ExerciseTypePayload';
  exerciseType: ExerciseType;
};

export enum ExerciseUnit {
  Reps = 'Reps',
  RepsEach = 'RepsEach',
  RepsMax = 'RepsMax',
  Seconds = 'Seconds',
  SecondsEach = 'SecondsEach',
  TimeMax = 'TimeMax',
  Yards = 'Yards',
}

export type ExerciseUnitAttribute = {
  __typename?: 'ExerciseUnitAttribute';
  name: Scalars['String']['output'];
  value: ExerciseUnit;
};

export type ExercisesFilter = {
  bodyPartName?: InputMaybe<Scalars['String']['input']>;
  equipmentName?: InputMaybe<Scalars['String']['input']>;
  exerciseBaseId?: InputMaybe<Scalars['ID']['input']>;
  exerciseTypeCategoryGroupId?: InputMaybe<Scalars['ID']['input']>;
  exerciseTypeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  exerciseTypeId?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  progression?: InputMaybe<Scalars['Int']['input']>;
};

export type ExosContentPlanItem = Node &
  PlanItem & {
    __typename?: 'ExosContentPlanItem';
    archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated Use contentComponent instead */
    component?: Maybe<Scalars['String']['output']>;
    content: Content;
    contentComponent?: Maybe<ContentAttribute>;
    date: Scalars['LocalDate']['output'];
    deletedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    id: Scalars['ID']['output'];
    isLocked: Scalars['Boolean']['output'];
    order: Scalars['Int']['output'];
    type: PlanItemType;
  };

export enum FamilyRelationship {
  Dependent = 'dependent',
  Spouse = 'spouse',
}

/**
 * An admin-managed feature. The catalog entry only; per-entity access
 * is expressed separately via grants.
 */
export type Feature = Node & {
  __typename?: 'Feature';
  createdAt: Scalars['ZonedDateTime']['output'];
  defaultState: FeatureState;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** Stable, code-referenced identifier (e.g. "in_app_registration"). */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Optional split.io/Harness flag acting as a hard kill-switch: when set and off,
   * the feature resolves disabled regardless of grants.
   */
  requiresFeatureFlagKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ZonedDateTime']['output'];
};

/** A feature's resolved on/off state. */
export type FeatureAccess = {
  __typename?: 'FeatureAccess';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  /** Trace of what decided `enabled`. Admin-only. */
  reason?: Maybe<Scalars['String']['output']>;
};

export type FeatureFilter = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FeatureFlagState = {
  __typename?: 'FeatureFlagState';
  attributes?: Maybe<Scalars['JSONObject']['output']>;
  enabled: Scalars['Boolean']['output'];
  treatment: Scalars['String']['output'];
  value?: Maybe<Scalars['JSONObject']['output']>;
};

/** A per-scope grant of a feature within one client instance. */
export type FeatureGrant = Node & {
  __typename?: 'FeatureGrant';
  client: Client;
  createdAt: Scalars['ZonedDateTime']['output'];
  createdBy?: Maybe<User>;
  feature: Feature;
  id: Scalars['ID']['output'];
  /** A UUID, a country code, or the clientId for scopeType `client`. */
  scopeId: Scalars['String']['output'];
  scopeType: FeatureGrantScopeType;
  state: FeatureState;
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export type FeatureGrantFilter = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  featureId?: InputMaybe<Scalars['ID']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<FeatureGrantScopeType>;
};

export enum FeatureGrantScopeType {
  Client = 'client',
  Country = 'country',
  Location = 'location',
  Studio = 'studio',
  User = 'user',
}

export type FeatureGrantsConnection = Connection & {
  __typename?: 'FeatureGrantsConnection';
  count: Scalars['Int']['output'];
  edges: Array<FeatureGrantsEdge>;
  nodes: Array<FeatureGrant>;
  pageInfo: PageInfo;
};

export type FeatureGrantsEdge = Edge & {
  __typename?: 'FeatureGrantsEdge';
  cursor: Scalars['String']['output'];
  node: FeatureGrant;
};

export enum FeatureState {
  Disabled = 'disabled',
  Enabled = 'enabled',
}

export type FeaturesConnection = Connection & {
  __typename?: 'FeaturesConnection';
  count: Scalars['Int']['output'];
  edges: Array<FeaturesEdge>;
  nodes: Array<Feature>;
  pageInfo: PageInfo;
};

export type FeaturesEdge = Edge & {
  __typename?: 'FeaturesEdge';
  cursor: Scalars['String']['output'];
  node: Feature;
};

export enum FeedbackContextKind {
  Application = 'application',
  Challenge = 'challenge',
  Content = 'content',
  MboClass = 'mboClass',
  Practice = 'practice',
  PracticeProgram = 'practiceProgram',
  Program = 'program',
}

export enum FeedbackKind {
  Needed = 'needed',
  Negative = 'negative',
  Positive = 'positive',
  Undecided = 'undecided',
}

export type FeedbackPayload = {
  __typename?: 'FeedbackPayload';
  challenge?: Maybe<Challenge>;
  content?: Maybe<Content>;
  mboClass?: Maybe<MboClass>;
};

export type FitnessCenterContract = {
  __typename?: 'FitnessCenterContract';
  /** The text of the liability waiver and contract agreement terms. */
  agreementTerms: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPaidContract: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Open-ended text used to display how the contract is priced. This could be something like "$19.99/month" or "£100 per 3 months". */
  priceLabel?: Maybe<Scalars['String']['output']>;
  /** The services/items included in this contract bundle. */
  services: Array<FitnessCenterContractService>;
  /** Text to be displayed near the Accept Waiver CTA. May include renewal terms for paid contracts */
  waiverAcceptanceTerms: Scalars['String']['output'];
};

export type FitnessCenterContractService = {
  __typename?: 'FitnessCenterContractService';
  id: Scalars['String']['output'];
  isMembership: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type FitnessCenterMembership = {
  __typename?: 'FitnessCenterMembership';
  activeContracts: Array<MboClientContract>;
  canConnectGym: Scalars['Boolean']['output'];
  cardOnFile?: Maybe<PaymentCard>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<FitnessCenterContract>;
  gymImage?: Maybe<Photo>;
  hasConnectedGym: Scalars['Boolean']['output'];
  joinGymInstructions?: Maybe<Scalars['String']['output']>;
  membershipAgreementConsentText?: Maybe<Scalars['String']['output']>;
  membershipAgreementLink?: Maybe<Scalars['String']['output']>;
  mustJoinGym: Scalars['Boolean']['output'];
  postConnectionInstructions: Scalars['String']['output'];
  purchasableContracts: Array<FitnessCenterContract>;
  purchasedPricingOptions: Array<MboPurchasedPricingOption>;
  shouldShowPostConnectionInstructions: Scalars['Boolean']['output'];
  transactionHistory: MboTransactionConnection;
};

export type FitnessCenterMembershipActiveContractsArgs = {
  filter?: InputMaybe<MboClientContractsFilter>;
};

export type FitnessCenterMembershipContractArgs = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
};

export type FitnessCenterMembershipTransactionHistoryArgs = {
  filters: TransactionHistoryFilter;
};

export type FitnessCenterMembershipLocation = {
  __typename?: 'FitnessCenterMembershipLocation';
  isArchived: Scalars['Boolean']['output'];
  location: CoachLocation;
  mboUserId: Scalars['String']['output'];
};

export enum FocusArea {
  BasicHealth = 'BasicHealth',
  FemaleWellBeing = 'FemaleWellBeing',
  Fitness = 'Fitness',
  LongevityHealthyAging = 'LongevityHealthyAging',
  MentalEmotionalWellBeing = 'MentalEmotionalWellBeing',
  MuscleGrowth = 'MuscleGrowth',
  Sharpness = 'Sharpness',
  WeightLoss = 'WeightLoss',
}

export type GameplanMetadata = {
  __typename?: 'GameplanMetadata';
  associatedProject?: Maybe<ContentAttribute>;
  isExperiential?: Maybe<Scalars['Boolean']['output']>;
  primaryComponent?: Maybe<ContentAttribute>;
  primarySubcomponents: Array<Maybe<ContentAttribute>>;
  secondaryComponent?: Maybe<ContentAttribute>;
  secondarySubcomponents: Array<Maybe<ContentAttribute>>;
};

export type GameplanReminder = {
  __typename?: 'GameplanReminder';
  offset?: Maybe<Scalars['Duration']['output']>;
};

export type Genre = {
  __typename?: 'Genre';
  children: Array<Genre>;
  hideChildren: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Genre>;
  value: Scalars['String']['output'];
};

export type GenreChildrenArgs = {
  filter?: InputMaybe<ContentGenreFilter>;
};

export type Goal = {
  __typename?: 'Goal';
  description: Scalars['String']['output'];
  type: UserGoalType;
};

export type HeartRate = {
  __typename?: 'HeartRate';
  average: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type HeartRateInput = {
  average: Scalars['Int']['input'];
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type Icon = {
  __typename?: 'Icon';
  name: Scalars['String']['output'];
  style: IconStyle;
};

export enum IconStyle {
  Fal = 'fal',
  Fas = 'fas',
  Svg = 'svg',
}

export type ImportApmlCategoriesInput = {
  truncateFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportApmlCategoriesPayload = {
  __typename?: 'ImportApmlCategoriesPayload';
  exerciseBases: Scalars['Int']['output'];
  exerciseTypeCategories: Scalars['Int']['output'];
  exerciseTypeCategoryGroups: Scalars['Int']['output'];
  exerciseTypes: Scalars['Int']['output'];
  exercisesLinked: Scalars['Int']['output'];
};

export type ImportGoogleUsersInput = {
  bucketName: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  isTestData: Scalars['Boolean']['input'];
};

export type InAppSurvey = Content &
  Node & {
    __typename?: 'InAppSurvey';
    author?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    feedback?: Maybe<FeedbackKind>;
    finishedBody?: Maybe<Scalars['String']['output']>;
    finishedCardSubtitle?: Maybe<Scalars['String']['output']>;
    finishedCardTitle?: Maybe<Scalars['String']['output']>;
    finishedTitle?: Maybe<Scalars['String']['output']>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    initialCardSubtitle?: Maybe<Scalars['String']['output']>;
    initialCardTitle?: Maybe<Scalars['String']['output']>;
    introBody?: Maybe<Scalars['String']['output']>;
    introTitle?: Maybe<Scalars['String']['output']>;
    isPublished: Scalars['Boolean']['output'];
    kind?: Maybe<Scalars['String']['output']>;
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    link: Scalars['String']['output'];
    logoPhoto?: Maybe<Photo>;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    /** @deprecated User Question.savedAnswer now */
    survey?: Maybe<Survey>;
    surveyTemplate?: Maybe<SurveyTemplate>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type InAppSurveyRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type InsightDimension = {
  __typename?: 'InsightDimension';
  description?: Maybe<Scalars['String']['output']>;
  descriptionLong?: Maybe<Array<Scalars['String']['output']>>;
  improvements?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * What the member should do next, based on their activity as of today in their
   * own timezone. It describes the present, not any day in `days`.
   */
  recommendation?: Maybe<InsightRecommendation>;
  title: Scalars['String']['output'];
  titleLong?: Maybe<Scalars['String']['output']>;
};

export type InsightRange = {
  __typename?: 'InsightRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type InsightRecommendation = {
  __typename?: 'InsightRecommendation';
  ctaLink: Scalars['String']['output'];
  ctaText: Scalars['String']['output'];
};

export type InsightScore = {
  __typename?: 'InsightScore';
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionLong?: Maybe<Array<Scalars['String']['output']>>;
  improvements?: Maybe<Array<Scalars['String']['output']>>;
  maxScore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  titleLong?: Maybe<Scalars['String']['output']>;
  usualRange?: Maybe<InsightRange>;
  verdict?: Maybe<InsightVerdict>;
};

export type InsightVerdict = {
  __typename?: 'InsightVerdict';
  description: Scalars['String']['output'];
  disclaimer: Scalars['String']['output'];
  explanation: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleLong: Scalars['String']['output'];
};

export enum IntensityLevel {
  High = 'high',
  Low = 'low',
  Moderate = 'moderate',
}

export type InviteFamilyMemberInput = {
  email: Scalars['String']['input'];
  relationship: FamilyRelationship;
};

export type InviteFamilyMemberPayload = {
  __typename?: 'InviteFamilyMemberPayload';
  familyInvitation: EligibleEmailAddress;
  user: User;
};

export type IosSleepSamples = {
  endDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  sourceId: Scalars['String']['input'];
  sourceName: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type JoinChallengePayload = {
  __typename?: 'JoinChallengePayload';
  challenge?: Maybe<Challenge>;
};

export enum KeyMetric {
  ActiveMinutes = 'ActiveMinutes',
  Activities = 'Activities',
  RestingHeartRate = 'RestingHeartRate',
  Steps = 'Steps',
  TimeAsleep = 'TimeAsleep',
}

export type LastActivity = {
  __typename?: 'LastActivity';
  heart?: Maybe<Scalars['ZonedDateTime']['output']>;
  heartWeb?: Maybe<Scalars['ZonedDateTime']['output']>;
  /** @deprecated prince is deprecated */
  prince?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type Level = {
  __typename?: 'Level';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Link = Content &
  Node & {
    __typename?: 'Link';
    author?: Maybe<Scalars['String']['output']>;
    bannerPhoto?: Maybe<Photo>;
    buttonText?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    isPublished: Scalars['Boolean']['output'];
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    link: Scalars['String']['output'];
    logoPhoto?: Maybe<Photo>;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type LinkRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type LocalDateRange = {
  end?: InputMaybe<Scalars['LocalDate']['input']>;
  start?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LocationCoachesConnection = Connection & {
  __typename?: 'LocationCoachesConnection';
  count: Scalars['Int']['output'];
  edges: Array<LocationCoachesEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type LocationCoachesEdge = Edge & {
  __typename?: 'LocationCoachesEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type LocationsFilter = {
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LogInput = {
  level?: InputMaybe<LogLevel>;
  message: Scalars['String']['input'];
};

export enum LogLevel {
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
}

export type MachineClient = {
  __typename?: 'MachineClient';
  id: Scalars['ID']['output'];
};

export type ManualActivityInput = {
  distance?: InputMaybe<DistanceInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  intensity?: InputMaybe<IntensityLevel>;
  sourceId: Scalars['String']['input'];
  startTime: Scalars['ZonedDateTime']['input'];
};

export type MboAppointment = Node & {
  __typename?: 'MboAppointment';
  canCancelOrReschedule: Scalars['Boolean']['output'];
  canCheckIn: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  endTime: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  isCheckedIn: Scalars['Boolean']['output'];
  isPaidService?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<CoachLocation>;
  mboAppointmentId: Scalars['Int']['output'];
  mboLocationId: Scalars['String']['output'];
  mboSessionTypeId: Scalars['Int']['output'];
  mboStudioId: Scalars['String']['output'];
  member?: Maybe<User>;
  name: Scalars['String']['output'];
  sessionTypeName: Scalars['String']['output'];
  startTime: Scalars['ZonedDateTime']['output'];
  studio: Studio;
};

export type MboAvailabilityStaff = {
  __typename?: 'MboAvailabilityStaff';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mboStaffId: Scalars['Int']['output'];
};

export enum MboBookingError {
  CalendarConflict = 'CalendarConflict',
  TimeNoLongerAvailable = 'TimeNoLongerAvailable',
}

export type MboBookingsFilter = {
  dates: DateRange;
  /**
   * Also include classes the member is waitlisted for. Defaults to false so
   * existing consumers (e.g. gym-arrival check-in) keep booked-only semantics.
   */
  includeWaitlisted?: InputMaybe<Scalars['Boolean']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MboClass = Node & {
  __typename?: 'MboClass';
  /**
   * The calling user's relationship to this class: Attending (a booking),
   * Waitlisted (a waitlist entry), or None. Reads both the bookings and the
   * waitlist tables; Attending takes precedence over Waitlisted.
   */
  attendanceStatus: MboClassAttendanceStatus;
  attendees: MboClassUsersConnection;
  /** @deprecated Use attendanceStatus */
  attending: Scalars['Boolean']['output'];
  /** The times at which booking for this class open and close. */
  bookingWindow?: Maybe<ZonedDateTimeRange>;
  canCancel: Scalars['Boolean']['output'];
  canCheckIn: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  category: Scalars['String']['output'];
  client: Client;
  description: Scalars['String']['output'];
  endTime: Scalars['ZonedDateTime']['output'];
  feedback?: Maybe<FeedbackKind>;
  /**
   * True when the class costs nothing to book. The external provider has two
   * separate paid states — pay now and pay later — and this flattens both to
   * false.
   */
  freeClass: Scalars['Boolean']['output'];
  full: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCheckedIn: Scalars['Boolean']['output'];
  /** True when MBO reports the class's waitlist as open. */
  isWaitlistAvailable: Scalars['Boolean']['output'];
  joinUrl?: Maybe<Scalars['String']['output']>;
  joinableTime: Scalars['ZonedDateTime']['output'];
  location?: Maybe<CoachLocation>;
  mboClassId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  room?: Maybe<Scalars['String']['output']>;
  /** The service category’s schedule type. */
  scheduleType: Scalars['String']['output'];
  share?: Maybe<Share>;
  staff?: Maybe<User>;
  staffFirstName?: Maybe<Scalars['String']['output']>;
  staffLastName?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['ZonedDateTime']['output'];
  studio: Studio;
  /** The detailed type of the class: in-person, live, or encore */
  subtype: MboClassSubtype;
  /** @deprecated Prefer subtype */
  type: MboClassType;
};

export type MboClassAttendeesArgs = {
  filter?: InputMaybe<MboClassUsersFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type MboClassActivity = Activity &
  CoachBasedActivity &
  Node &
  TimeBasedActivity & {
    __typename?: 'MboClassActivity';
    coachAvatar?: Maybe<Photo>;
    coachFirstName?: Maybe<Scalars['String']['output']>;
    coachLastName?: Maybe<Scalars['String']['output']>;
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    location?: Maybe<Scalars['String']['output']>;
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    room?: Maybe<Scalars['String']['output']>;
    source?: Maybe<MboClass>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export enum MboClassAttendanceStatus {
  Attending = 'Attending',
  None = 'None',
  Waitlisted = 'Waitlisted',
}

export type MboClassConnection = Connection & {
  __typename?: 'MboClassConnection';
  count: Scalars['Int']['output'];
  edges: Array<RootMboClassEdge>;
  nodes: Array<MboClass>;
  pageInfo: PageInfo;
};

export type MboClassDetailsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  mboClassId?: InputMaybe<Scalars['Int']['input']>;
  mboStudioId?: InputMaybe<Scalars['String']['input']>;
};

export type MboClassFilter = {
  classType: MboClassType;
  dates: DateRange;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MboClassSubtype {
  Encore = 'Encore',
  InPerson = 'InPerson',
  LiveVirtual = 'LiveVirtual',
}

export enum MboClassType {
  InPerson = 'InPerson',
  Virtual = 'Virtual',
}

export type MboClassUsersConnection = Connection & {
  __typename?: 'MboClassUsersConnection';
  count: Scalars['Int']['output'];
  edges: Array<MboClassUsersEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type MboClassUsersEdge = Edge & {
  __typename?: 'MboClassUsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type MboClassUsersFilter = {
  excludeAbsentUsers?: InputMaybe<Scalars['Boolean']['input']>;
  includeCancelledUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MboClientContract = {
  __typename?: 'MboClientContract';
  autopayStatus: AutopayStatus;
  contractId: Scalars['Int']['output'];
  contractName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isMembershipContract: Scalars['Boolean']['output'];
  /** Pre-formatted recurring price in the studio's currency, e.g. "$19.99/month". */
  priceLabel?: Maybe<Scalars['String']['output']>;
  recurringPaymentAmount?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  upcomingAutopayEvents: Array<MboUpcomingAutopayEvent>;
};

export type MboClientContractsFilter = {
  isMembershipContract?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MboContractMapping = Node & {
  __typename?: 'MboContractMapping';
  employeeType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mboServiceId: Scalars['String']['output'];
  studio: Studio;
};

export type MboContractMappingsConnection = Connection & {
  __typename?: 'MboContractMappingsConnection';
  count: Scalars['Int']['output'];
  edges: Array<MboContractMappingsEdge>;
  nodes: Array<MboContractMapping>;
  pageInfo: PageInfo;
};

export type MboContractMappingsEdge = Edge & {
  __typename?: 'MboContractMappingsEdge';
  cursor: Scalars['String']['output'];
  node: MboContractMapping;
};

export type MboContractOption = Node & {
  __typename?: 'MboContractOption';
  /** The billing period word in the studio's locale, e.g. "month" or "3 months". Null for one-time. */
  billingPeriodLabel?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Pre-formatted per-session price (total / sessions granted) in the studio's currency, e.g. "$40.00". */
  perSessionPriceLabel: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  /** Pre-formatted recurring price in the studio's currency, e.g. "$19.99/month". */
  priceLabel: Scalars['String']['output'];
  pricingOptions: Array<MboContractPricingOption>;
  /** Number of recurring payments before the contract renews, when fixed-term. */
  renewalCount?: Maybe<Scalars['Int']['output']>;
};

export type MboContractOptionEdge = Edge & {
  __typename?: 'MboContractOptionEdge';
  cursor: Scalars['String']['output'];
  node: MboContractOption;
};

export type MboContractOptionsConnection = Connection & {
  __typename?: 'MboContractOptionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<MboContractOptionEdge>;
  nodes: Array<MboContractOption>;
  pageInfo: PageInfo;
};

export type MboContractPricingOption = {
  __typename?: 'MboContractPricingOption';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  /** Pre-formatted price in the studio's currency, e.g. "$200". */
  priceLabel: Scalars['String']['output'];
};

export enum MboMembershipRequestAction {
  Cancel = 'CANCEL',
  Pause = 'PAUSE',
  Reactivate = 'REACTIVATE',
}

export type MboPricingOption = {
  __typename?: 'MboPricingOption';
  count: Scalars['Int']['output'];
  estimatedExpirationDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Pre-formatted per-session price (price / count) in the studio's currency, e.g. "$40.00". */
  perSessionPriceLabel: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  /** Pre-formatted price in the studio's currency, e.g. "$200". */
  priceLabel: Scalars['String']['output'];
};

export type MboPricingOptionsResponse = {
  __typename?: 'MboPricingOptionsResponse';
  availablePricingOptions: Array<Maybe<MboPricingOption>>;
  userPricingOptions: Array<Maybe<MboPurchasedPricingOption>>;
};

export type MboProgramBasics = {
  __typename?: 'MboProgramBasics';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MboPurchasedPricingOption = {
  __typename?: 'MboPurchasedPricingOption';
  expirationDate: Scalars['ZonedDateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  originalCount: Scalars['Int']['output'];
  pricingOptionType?: Maybe<PricingOptionType>;
  program?: Maybe<MboProgramBasics>;
  remainingCount: Scalars['Int']['output'];
};

export type MboService = {
  __typename?: 'MboService';
  isPaidService: Scalars['Boolean']['output'];
  mboSessionTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MboServiceAvailability = {
  __typename?: 'MboServiceAvailability';
  displayName: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  sessionTypeId: Scalars['Int']['output'];
  staff: Array<MboAvailabilityStaff>;
  startTime: Scalars['String']['output'];
};

export type MboServiceAvailabilityResponse = {
  __typename?: 'MboServiceAvailabilityResponse';
  availabilities: Array<MboServiceAvailability>;
  serviceName: Scalars['String']['output'];
};

export type MboServiceCategory = {
  __typename?: 'MboServiceCategory';
  mboProgramId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MboServiceResponse = {
  __typename?: 'MboServiceResponse';
  categoryName: Scalars['String']['output'];
  serviceTypes: Array<MboService>;
};

export type MboServiceStaffListResponse = {
  __typename?: 'MboServiceStaffListResponse';
  staff: Array<MboAvailabilityStaff>;
};

/** A raw MBO contract for a studio. Surfaces every contract MBO returns for the location, including membership contracts. */
export type MboStudioContract = {
  __typename?: 'MboStudioContract';
  /** Set when this contract assigns a membership (i.e. it is a membership contract). */
  assignsMembershipId?: Maybe<Scalars['Int']['output']>;
  /** Name of the membership assigned by this contract, when it is a membership contract. */
  assignsMembershipName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Recurring payment amount for the contract. */
  price: Scalars['Float']['output'];
  /** Pre-formatted recurring price in the studio's currency, e.g. "$19.99/month". */
  priceLabel?: Maybe<Scalars['String']['output']>;
};

export type MboTransaction = Node & {
  __typename?: 'MboTransaction';
  amountPaid: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  returned: Scalars['Boolean']['output'];
  saleDateTime: Scalars['String']['output'];
  saleId: Scalars['Int']['output'];
  tax: Scalars['Float']['output'];
};

export type MboTransactionConnection = Connection & {
  __typename?: 'MboTransactionConnection';
  count: Scalars['Int']['output'];
  edges: Array<MboTransactionEdge>;
  nodes: Array<MboTransaction>;
  pageInfo: PageInfo;
};

export type MboTransactionEdge = Edge & {
  __typename?: 'MboTransactionEdge';
  cursor: Scalars['String']['output'];
  node: MboTransaction;
};

export type MboUpcomingAutopayEvent = {
  __typename?: 'MboUpcomingAutopayEvent';
  clientContractId: Scalars['Int']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  scheduleDate?: Maybe<Scalars['String']['output']>;
};

export enum MemberExperience {
  CoachLed = 'coachLed',
  SelfLed = 'selfLed',
}

export type MemberExperienceInput = {
  memberExperience: MemberExperience;
  userId: Scalars['ID']['input'];
};

export type MemberExperiencePayload = {
  __typename?: 'MemberExperiencePayload';
  user: User;
};

export type MembershipLocationsFilter = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Message = Node & {
  __typename?: 'Message';
  automated: Scalars['Boolean']['output'];
  createdAt: Scalars['ZonedDateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  photos: Array<Photo>;
  previews: Array<MessagePreview>;
  reactions: Array<Reaction>;
  text: Scalars['String']['output'];
  user: User;
};

export type MessagePreview = {
  __typename?: 'MessagePreview';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Photo>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MigrateApmlExerciseDataInput = {
  deleteExisting?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MigrateApmlExercisePayload = {
  __typename?: 'MigrateApmlExercisePayload';
  count: Scalars['Int']['output'];
};

export type ModalStatus = {
  __typename?: 'ModalStatus';
  id: Scalars['ID']['output'];
  lastSeenAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  modalSeen: Scalars['Boolean']['output'];
  seenCount: Scalars['Int']['output'];
};

export type MoveUserGameplanDatesInput = {
  days: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type MoveUserGameplanDatesPayload = {
  __typename?: 'MoveUserGameplanDatesPayload';
  states: Array<CustomPlanState>;
};

export type MovementInsightDay = {
  __typename?: 'MovementInsightDay';
  dailyMovement: MovementInsightScore;
  date: Scalars['LocalDate']['output'];
  id: Scalars['ID']['output'];
  intensity: MovementInsightScore;
  lifestyleHabits: MovementInsightScore;
  movementFrequency: MovementInsightScore;
  overall: MovementInsightScore;
};

export type MovementInsightScore = {
  __typename?: 'MovementInsightScore';
  maxScore: Scalars['Float']['output'];
  score: Scalars['Float']['output'];
  usualRange?: Maybe<InsightRange>;
  verdict?: Maybe<InsightVerdict>;
};

export type MovementInsightScores = {
  __typename?: 'MovementInsightScores';
  dailyMovement: InsightScore;
  intensity: InsightScore;
  lifestyleHabits: InsightScore;
  movementFrequency: InsightScore;
  overall: InsightScore;
};

export type MovementInsights = {
  __typename?: 'MovementInsights';
  dailyMovement: InsightDimension;
  days: Array<MovementInsightDay>;
  intensity: InsightDimension;
  lifestyleHabits: InsightDimension;
  movementFrequency: InsightDimension;
  overall: InsightDimension;
};

export type MovementInsightsDaysArgs = {
  dateRange: RequiredLocalDateRange;
};

export type MovementProgression = Node & {
  __typename?: 'MovementProgression';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  repetitions?: Maybe<Scalars['String']['output']>;
};

export type MovementProgressionsConnection = Connection & {
  __typename?: 'MovementProgressionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<MovementProgressionsEdge>;
  nodes: Array<MovementProgression>;
  pageInfo: PageInfo;
};

export type MovementProgressionsEdge = Edge & {
  __typename?: 'MovementProgressionsEdge';
  cursor: Scalars['String']['output'];
  node: MovementProgression;
};

export type MovementProgressionsFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MultipleChoiceOption = {
  __typename?: 'MultipleChoiceOption';
  /**
   * If true, when this option is selected, it should clear all other multiple choice options
   * If another option is selected while this is selected, it should clear this option
   */
  clearMultipleChoice?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  iconSelected?: Maybe<Scalars['String']['output']>;
  /** if next question is supplied and this option was chosen, this is the next question to show the member */
  nextQuestion?: Maybe<Question>;
  optionIdentifier: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  textEntry: Scalars['Boolean']['output'];
};

export type MutateChatRoomPayload = {
  __typename?: 'MutateChatRoomPayload';
  chatRoom?: Maybe<ChatRoom>;
};

export type MutateClientPayload = {
  __typename?: 'MutateClientPayload';
  client: Client;
};

export type MutateCoachLocationPayload = {
  __typename?: 'MutateCoachLocationPayload';
  coachLocation: CoachLocation;
};

export type MutateCoachPayload = {
  __typename?: 'MutateCoachPayload';
  coachData: CoachData;
};

export type MutateCohortPayload = {
  __typename?: 'MutateCohortPayload';
  cohort: Cohort;
};

export type MutateDomainPayload = {
  __typename?: 'MutateDomainPayload';
  domain: Domain;
};

export type MutateEligibleEmailAddressInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  cohortId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeType?: InputMaybe<Scalars['String']['input']>;
  hpcEligibilityEnd?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  hpcEligibilityStart?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  isAppEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFcmEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  officeId?: InputMaybe<Scalars['String']['input']>;
};

export type MutateEligibleEmailAddressPayload = {
  __typename?: 'MutateEligibleEmailAddressPayload';
  eligibleEmailAddress: EligibleEmailAddress;
};

export type MutateFeatureGrantPayload = {
  __typename?: 'MutateFeatureGrantPayload';
  featureGrant: FeatureGrant;
};

export type MutateFeaturePayload = {
  __typename?: 'MutateFeaturePayload';
  feature: Feature;
};

export type MutateGenrePayload = {
  __typename?: 'MutateGenrePayload';
  genre: Genre;
};

export type MutateMboContractMappingPayload = {
  __typename?: 'MutateMboContractMappingPayload';
  mboContractMapping: MboContractMapping;
};

export type MutateNotePayload = {
  __typename?: 'MutateNotePayload';
  note?: Maybe<Note>;
};

export type MutateNotificationOptionPayload = {
  __typename?: 'MutateNotificationOptionPayload';
  notificationOption: NotificationOption;
};

export type MutateOfficePayload = {
  __typename?: 'MutateOfficePayload';
  office: Office;
};

export type MutateStudioPayload = {
  __typename?: 'MutateStudioPayload';
  studio: Studio;
};

export type Mutation = {
  __typename?: 'Mutation';
  addGymArrival: AddGymArrivalPayload;
  addManualActivity: ActivityPayload;
  addPerformanceQualityScores: AddPerformanceQualityScoresPayload;
  addReaction: Message;
  addSaved: SavedPayload;
  addToChatRoom: MutateChatRoomPayload;
  addToClient: MutateClientPayload;
  addToolActivity: ActivityPayload;
  addUserToStudio: AddUserToStudioPayload;
  /** Records a gym arrival activity for a member without calling MBO. Admin/test-data use. */
  adminAddGymArrival: Scalars['Boolean']['output'];
  adminBackfillAssessmentAttributionType: Scalars['Int']['output'];
  adminBackfillEligibilitySource: Scalars['Int']['output'];
  adminChangeUserAuthProvider: Scalars['Boolean']['output'];
  adminConfirmUser: UpdateUserPayload;
  adminDisableUserAuthProvider: Scalars['Boolean']['output'];
  adminUpdateLastActivity?: Maybe<UpdateUserPayload>;
  adminUpdateUser: UpdateUserPayload;
  answerSurvey: Survey;
  archiveAllPostOnboardingRecommendationForUser: ArchiveAllPostOnboardingRecommendationForUser;
  archiveMissedWorkoutTouchPoints: Scalars['Int']['output'];
  archivePostOnboardingRecommendation: ArchivePostOnboardingRecommendationPayload;
  assignAssessments: AssignAssessmentsPayload;
  assignFitCoach: AssignFitCoachPayload;
  assignHistoricalFitCoach: AssignFitCoachPayload;
  assignPractice: AssignPracticePayload;
  assignProgram: AssignProgramPayload;
  backfillCustomPlanTemplates: BackfillCustomPlanTemplatesPayload;
  backfillDeletedSessionCoaches?: Maybe<Scalars['Int']['output']>;
  /**
   * Loads `movement_tag_option.json`, `tag_option.json`, and `tag.json` from S3; updates
   * `exercises.bodyParts` from the body-part tag.
   */
  backfillExerciseBodyParts: ApmlJsonBackfillPayload;
  /**
   * Loads `equipment.json` and `movement_equipment.json` from S3; updates
   * `exercises.equipment` by `apmlId`.
   */
  backfillExerciseEquipment: ApmlJsonBackfillPayload;
  /**
   * Loads `movement_tag_option.json`, `tag_option.json`, and `tag.json` from S3; updates
   * `exercises.oneRepMax` with 1RM `tag_option_value` weights (kg), rounded to 0.01, sorted ascending.
   */
  backfillExerciseOneRepMax: ApmlJsonBackfillPayload;
  /** Loads `movement.json` from S3 and updates `exercises.progression` by `apmlId`. */
  backfillExerciseProgression: ApmlJsonBackfillPayload;
  backfillJpmcCustomPlanStateSessionIds: BackfillJpmcCustomPlanStateSessionIdsPayload;
  backfillPostOnboardingRecommendations: BackfillPostOnboardingRecommendationsPayload;
  blockUser: BlockUserPayload;
  bookClass: BookClassPayload;
  bookServiceAppointment: AppointmentPayload;
  bookSession: BookSessionPayload;
  bulkReassignCoachMembers: BulkReassignCoachMembersPayload;
  bulkUpdateExercises: BulkUpdateExercisesExercisePayload;
  cancelClass: CancelClassPayload;
  cancelServiceAppointment: CancelServiceAppointmentPayload;
  cancelSession: Scalars['Boolean']['output'];
  changeEmail: UpdateUserPayload;
  checkInForInPersonClass: CheckInPayload;
  clearCache: Scalars['Boolean']['output'];
  coachCreateFitUser: CreateUserPayload;
  completePractice: UpdatePracticePayload;
  completeProgram: UpdateProgramPayload;
  /** Records a debug row for an auth action (e.g. a Cognito pre-signup attempt). */
  createAuthLog: Scalars['Boolean']['output'];
  createBotChatSession?: Maybe<ChatRoom>;
  createChallenge: CreateChallengePayload;
  createChatRoom: MutateChatRoomPayload;
  createClient: MutateClientPayload;
  createCoachLocation: MutateCoachLocationPayload;
  createCoachTouchPoint: CoachTouchPoint;
  createCohort: MutateCohortPayload;
  createContentGenre: MutateGenrePayload;
  createCustomChallenge: CreateChallengePayload;
  createDomain: MutateDomainPayload;
  createEligibleEmailAddress: MutateEligibleEmailAddressPayload;
  createExercise: CreateExercisePayload;
  createExerciseBase: ExerciseBasePayload;
  createExerciseType: ExerciseTypePayload;
  createExerciseTypeCategory: ExerciseTypeCategoryPayload;
  createExerciseTypeCategoryGroup: ExerciseTypeCategoryGroupPayload;
  createFeature: MutateFeaturePayload;
  createFeatureGrant: MutateFeatureGrantPayload;
  createFeedback: FeedbackPayload;
  createMboContractMapping: MutateMboContractMappingPayload;
  createMboMembership: CreateMboMembershipPayload;
  createNote: MutateNotePayload;
  createNotificationOption: MutateNotificationOptionPayload;
  createOffice: MutateOfficePayload;
  createPlan: CreatePlanPayload;
  createStubUsers: CreateStubUsersPayload;
  createStudio: MutateStudioPayload;
  createTestUser: CreateTestUserPayload;
  createTrainingPlan: TrainingPlan;
  createTrainingPlanTemplate: TrainingPlan;
  createUser: CreateUserPayload;
  createUserGoal: CreateUserGoalPayload;
  createUsers: CreateUsersPayload;
  deleteActivity: Scalars['Boolean']['output'];
  deleteAssignedAssessment?: Maybe<AssessmentAssignment>;
  deleteClientEligibleEmails: Scalars['Int']['output'];
  deleteCoachTouchPoint: Scalars['Boolean']['output'];
  deleteContentGenre: MutateGenrePayload;
  deleteCustomChallenge: Scalars['Boolean']['output'];
  deleteFitCoach: DeleteFitCoachPayload;
  deleteMboMemberships: DeleteMboMembershipsPayload;
  deletePerformanceQualityScore: Scalars['Boolean']['output'];
  deletePlan: DeletePlanPayload;
  deleteUser: DeleteUserPayload;
  deleteUserGoal: DeleteUserGoalPayload;
  deleteUserPostOnboardingRecommendations: DeleteUserPostOnboardingRecommendationsPayload;
  deleteUsers: DeleteUsersPayload;
  dismissPostOnboardingRecommendation: DismissPostOnboardingRecommendationPayload;
  editActivity: ActivityPayload;
  enablePerformanceCoachingForMembers: EnablePerformanceCoachingForMembersPayload;
  generateSignedUrl: SignedUrlPayload;
  importApmlCategories: ImportApmlCategoriesPayload;
  importGoogleUsers: Scalars['Boolean']['output'];
  inviteFamilyMember: InviteFamilyMemberPayload;
  joinChallenge: JoinChallengePayload;
  joinLiveClass: ActivityPayload;
  leaveChallenge: JoinChallengePayload;
  leavePractice: UpdatePracticePayload;
  leaveProgram: UpdateProgramPayload;
  markBadgesSeenForChallenge: Challenge;
  markChatRead: ChatRoom;
  /** @deprecated No longer supported */
  markChatStarred: ChatRoom;
  markPlanItemComplete: PlanItem;
  markSurveyResponseViewed: SurveyResponsePayload;
  markUserStarred: User;
  migrateApmlExerciseData: MigrateApmlExercisePayload;
  moveUserGameplanDates: MoveUserGameplanDatesPayload;
  purchaseMboContract: PurchaseMboContractPayload;
  purchasePricingOption: PurchasePricingOptionPayload;
  purgeWearableData: PurgeWearableDataPayload;
  rateApp: RateAppPayload;
  rebookSession: BookSessionPayload;
  refreshContent: RefreshContentPayload;
  refreshContents: Scalars['Boolean']['output'];
  refreshMboCache: RefreshMboCachePayload;
  refreshMboStaff: RefreshMboStaffPayload;
  register: RegisterUserPayload;
  registerDevice: Scalars['Boolean']['output'];
  remindFamilyMember: InviteFamilyMemberPayload;
  removeAllE2EChallenges: Scalars['Boolean']['output'];
  removeAllUserSurveys: Scalars['Int']['output'];
  removeChallenge: Scalars['Boolean']['output'];
  removeClient: Scalars['Boolean']['output'];
  removeCoachMembers: Scalars['Boolean']['output'];
  removeCohort: Scalars['Boolean']['output'];
  removeDomain: Scalars['Boolean']['output'];
  removeEligibleEmailAddress: Scalars['Boolean']['output'];
  removeExercise: Scalars['Boolean']['output'];
  removeFamilyMember: InviteFamilyMemberPayload;
  /** Soft-deletes a grant; the row is retained for audit history. */
  removeFeatureGrant: MutateFeatureGrantPayload;
  removeFromChallenge: JoinChallengePayload;
  removeFromChatRoom: MutateChatRoomPayload;
  removeFromClient: MutateClientPayload;
  removeLocation: Scalars['Boolean']['output'];
  removeMboContractMapping: Scalars['Boolean']['output'];
  removeOffice: Scalars['Boolean']['output'];
  removeReaction: Message;
  removeSaved: SavedPayload;
  removeStudio: Scalars['Boolean']['output'];
  removeUserSurveys: Scalars['Int']['output'];
  repairClientUsers: RepairClientUsersPayload;
  replacePostOnboardingRecommendationsLookup: ReplacePostOnboardingRecommendationsLookupPayload;
  reportUser: Scalars['Boolean']['output'];
  /** @deprecated Use requestMboMembershipChange(input: { action: CANCEL, clientContractId: <MboClientContract.id> }) */
  requestMboMembershipCancellation: RequestMboMembershipCancellationPayload;
  requestMboMembershipChange: RequestMboMembershipChangePayload;
  rescheduleServiceAppointment: AppointmentPayload;
  resetPreview?: Maybe<Photo>;
  resetProgress: ResetProgressPayload;
  restartPractice: RestartPracticePayload;
  restartProgram: RestartProgramPayload;
  restoreCognitoUser: RestoreCognitoUserPayload;
  resyncIterableUser?: Maybe<User>;
  revokeCronofyProfile: RevokeCronofyProfileResponse;
  /** @deprecated Use syncWearableSamples */
  saveWearableSamples: Scalars['Boolean']['output'];
  sendBulkMessage?: Maybe<Scalars['Boolean']['output']>;
  sendHistoricalMessage: Message;
  sendMessage: Message;
  sendSupportRequest: Scalars['Boolean']['output'];
  setClassSchedulesEndDates: ClassSchedulesEndDatesResult;
  setMemberExperience: MemberExperiencePayload;
  setMinBuildNumber: Scalars['Int']['output'];
  setModalStatus: ModalStatus;
  setNotificationOptions: SetNotificationOptionsPayload;
  setSessionCredits: SessionCreditsPayload;
  setUnitsPreference: UnitsPayload;
  startPractice: StartPracticePayload;
  startProgram: StartProgramPayload;
  /** @deprecated No longer supported */
  syncChatUsers: Scalars['Boolean']['output'];
  syncContentGenres: Scalars['Boolean']['output'];
  /** @deprecated Use uploadDailySteps */
  syncDailySteps: Scalars['Boolean']['output'];
  syncEligibleEmailAddress: MutateEligibleEmailAddressPayload;
  syncEligibleMboClient: Scalars['Boolean']['output'];
  /** @deprecated Use uploadIosSleepSamples */
  syncIosSleepSamples: SyncIosSleepSamplesPayload;
  syncMboMemberships: SyncMboMembershipsPayload;
  syncMovementProgressions: Scalars['Int']['output'];
  /** @deprecated Use uploadWearableSamples */
  syncWearableSamples: Scalars['Boolean']['output'];
  tempBackfillArrivalActivities: TempBackfillArrivalActivitiesPayload;
  tempFixRocheUsers: TempFixRocheUsersPayload;
  triggerIterablePush?: Maybe<TriggerIterablePushPayload>;
  unforgetIterableUser: Scalars['Boolean']['output'];
  unforgetUser: UnforgetUserPayload;
  updateAttendance: CoachSession;
  /** @deprecated Moved to enum column "updateAttendance" */
  updateAttended: CoachSession;
  updateAvatar: UpdateAvatarPayload;
  updateChallenge: CreateChallengePayload;
  updateChatRoom: MutateChatRoomPayload;
  updateClient: MutateClientPayload;
  updateCoachCronofyTimezone: UpdateCoachCronofyTimezoneResponse;
  updateCoachData: UpdateCoachDataPayload;
  updateCoachLocation: MutateCoachLocationPayload;
  updateCoachTouchPoint: CoachTouchPoint;
  updateCohort: MutateCohortPayload;
  updateContentGenre: MutateGenrePayload;
  updateDomain: MutateDomainPayload;
  updateEligibleEmailAddress: MutateEligibleEmailAddressPayload;
  updateExercise: UpdateExercisePayload;
  updateExerciseBase: ExerciseBasePayload;
  updateExerciseType: ExerciseTypePayload;
  updateExerciseTypeCategory: ExerciseTypeCategoryPayload;
  updateExerciseTypeCategoryGroup: ExerciseTypeCategoryGroupPayload;
  updateFeature: MutateFeaturePayload;
  updateFeatureGrant: MutateFeatureGrantPayload;
  updateHealthDataConsent: UpdateHealthDataConsentPayload;
  updateLastActivity?: Maybe<UpdateUserPayload>;
  updateMboContractMapping: MutateMboContractMappingPayload;
  updateNote: MutateNotePayload;
  updateNotificationOption: MutateNotificationOptionPayload;
  updateOffice: MutateOfficePayload;
  updatePerformanceQualityScore: PerformanceQualityScore;
  updatePlan: UpdatePlanPayload;
  updatePractice: UpdatePracticePayload;
  updatePrivacyPolicyDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  updateProfileJson: UpdateProfileJsonPayload;
  updateProgram: UpdateProgramPayload;
  updateProgress: ContentEdge;
  updateStudio: MutateStudioPayload;
  updateTrainingPlan: TrainingPlan;
  updateTrainingPlanExercise: TrainingPlanExercise;
  updateTrainingPlanTemplate: TrainingPlan;
  updateTrainingPlanWorkout: TrainingPlanWorkout;
  updateUnreadCount: Scalars['Int']['output'];
  updateUser: UpdateUserPayload;
  updateUserBiometricsOption: UpdateUserBiometricsOptionPayload;
  updateUserFocusArea: UpdateUserFocusAreaResponse;
  updateUserGoal: UpdateUserGoalPayload;
  /** @deprecated Removed welcome section */
  updateWelcomeSectionDisplay: UpdateUserPayload;
  uploadDailySteps: UploadDailyStepsPayload;
  uploadIosSleepSamples: UploadIosSleepSamplesPayload;
  uploadWearableSamples: UploadWearableSamplesPayload;
};

export type MutationAddGymArrivalArgs = {
  autoCheckIn?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
};

export type MutationAddManualActivityArgs = {
  activity: ManualActivityInput;
};

export type MutationAddPerformanceQualityScoresArgs = {
  performanceQualityScores: Array<CreatePerformanceQualityScoreInput>;
};

export type MutationAddReactionArgs = {
  input: AddReactionInput;
};

export type MutationAddSavedArgs = {
  contentId: Scalars['ID']['input'];
};

export type MutationAddToChatRoomArgs = {
  chatRoomId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAddToClientArgs = {
  clientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAddToolActivityArgs = {
  activity: ToolActivityInput;
};

export type MutationAddUserToStudioArgs = {
  studioId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAdminAddGymArrivalArgs = {
  input: AdminAddGymArrivalInput;
};

export type MutationAdminBackfillAssessmentAttributionTypeArgs = {
  input: AdminBackfillAssessmentAttributionTypeInput;
};

export type MutationAdminBackfillEligibilitySourceArgs = {
  input: AdminBackfillEligibilitySourceInput;
};

export type MutationAdminChangeUserAuthProviderArgs = {
  input: AdminChangeAuthProviderInput;
};

export type MutationAdminConfirmUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationAdminDisableUserAuthProviderArgs = {
  input: AdminDisableAuthProviderInput;
};

export type MutationAdminUpdateLastActivityArgs = {
  app: App;
  date?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  platform?: TokenPlatform;
  userId: Scalars['ID']['input'];
};

export type MutationAdminUpdateUserArgs = {
  input: AdminUpdateUserInput;
};

export type MutationAnswerSurveyArgs = {
  input: AnswerSurveyInput;
};

export type MutationArchiveAllPostOnboardingRecommendationForUserArgs = {
  input?: InputMaybe<ArchiveAllPostOnboardingRecommendationForUserInput>;
};

export type MutationArchiveMissedWorkoutTouchPointsArgs = {
  input: ArchiveMissedWorkoutTouchPointsInput;
};

export type MutationArchivePostOnboardingRecommendationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignAssessmentsArgs = {
  input: AssignAssessmentsInput;
};

export type MutationAssignFitCoachArgs = {
  coachId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationAssignHistoricalFitCoachArgs = {
  coachId: Scalars['ID']['input'];
  createdAt: Scalars['ZonedDateTime']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationAssignPracticeArgs = {
  practiceId: Scalars['ID']['input'];
  restart?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationAssignProgramArgs = {
  programId: Scalars['ID']['input'];
  restart?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationBackfillCustomPlanTemplatesArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationBackfillDeletedSessionCoachesArgs = {
  input?: InputMaybe<BackfillDeletedSessionCoachesInput>;
};

export type MutationBackfillExerciseBodyPartsArgs = {
  input?: InputMaybe<BackfillExerciseApmlInput>;
};

export type MutationBackfillExerciseEquipmentArgs = {
  input?: InputMaybe<BackfillExerciseApmlInput>;
};

export type MutationBackfillExerciseOneRepMaxArgs = {
  input?: InputMaybe<BackfillExerciseApmlInput>;
};

export type MutationBackfillExerciseProgressionArgs = {
  input?: InputMaybe<BackfillExerciseApmlInput>;
};

export type MutationBackfillPostOnboardingRecommendationsArgs = {
  input: BackfillPostOnboardingRecommendationsInput;
};

export type MutationBlockUserArgs = {
  input: BlockUserInput;
};

export type MutationBookClassArgs = {
  classId: Scalars['ID']['input'];
  pricingOptionId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationBookServiceAppointmentArgs = {
  input: BookServiceAppointmentInput;
};

export type MutationBookSessionArgs = {
  input: BookSessionInput;
};

export type MutationBulkReassignCoachMembersArgs = {
  newCoachId: Scalars['ID']['input'];
  oldCoachId: Scalars['ID']['input'];
  reassignAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationBulkUpdateExercisesArgs = {
  input?: InputMaybe<BulkUpdateExercisesInput>;
};

export type MutationCancelClassArgs = {
  classId: Scalars['ID']['input'];
};

export type MutationCancelServiceAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
};

export type MutationCancelSessionArgs = {
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['ID']['input'];
  useCronofy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationChangeEmailArgs = {
  allowSSO?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationCheckInForInPersonClassArgs = {
  classId: Scalars['ID']['input'];
};

export type MutationCoachCreateFitUserArgs = {
  input: CoachCreateUserInput;
};

export type MutationCompletePracticeArgs = {
  practiceId: Scalars['ID']['input'];
};

export type MutationCompleteProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type MutationCreateAuthLogArgs = {
  input: CreateAuthLogInput;
};

export type MutationCreateChallengeArgs = {
  input: CreateChallengeInput;
};

export type MutationCreateChatRoomArgs = {
  input: CreateChatRoomInput;
};

export type MutationCreateClientArgs = {
  input: CreateClientInput;
};

export type MutationCreateCoachLocationArgs = {
  input: CreateCoachLocationInput;
};

export type MutationCreateCoachTouchPointArgs = {
  input: CreateCoachTouchPointInput;
};

export type MutationCreateCohortArgs = {
  input: CreateCohortInput;
};

export type MutationCreateContentGenreArgs = {
  input: CreateContentGenreInput;
};

export type MutationCreateCustomChallengeArgs = {
  input: CreateCustomChallengeInput;
};

export type MutationCreateDomainArgs = {
  input: CreateDomainInput;
};

export type MutationCreateEligibleEmailAddressArgs = {
  input: CreateEligibleEmailAddressInput;
};

export type MutationCreateExerciseArgs = {
  input: CreateExerciseInput;
};

export type MutationCreateExerciseBaseArgs = {
  input: CreateExerciseBaseInput;
};

export type MutationCreateExerciseTypeArgs = {
  input: CreateExerciseTypeInput;
};

export type MutationCreateExerciseTypeCategoryArgs = {
  input: CreateExerciseTypeCategoryInput;
};

export type MutationCreateExerciseTypeCategoryGroupArgs = {
  input: CreateExerciseTypeCategoryGroupInput;
};

export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};

export type MutationCreateFeatureGrantArgs = {
  input: CreateFeatureGrantInput;
};

export type MutationCreateFeedbackArgs = {
  context: FeedbackContextKind;
  feedback: FeedbackKind;
  id: Scalars['ID']['input'];
};

export type MutationCreateMboContractMappingArgs = {
  input: CreateMboContractMappingInput;
};

export type MutationCreateMboMembershipArgs = {
  contractId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};

export type MutationCreateNotificationOptionArgs = {
  input: CreateNotificationOptionInput;
};

export type MutationCreateOfficeArgs = {
  input: CreateOfficeInput;
};

export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};

export type MutationCreateStubUsersArgs = {
  input: CreateStubUsersInput;
};

export type MutationCreateStudioArgs = {
  input: CreateStudioInput;
};

export type MutationCreateTestUserArgs = {
  input: CreateTestUserInput;
};

export type MutationCreateTrainingPlanArgs = {
  input: CreateTrainingPlanInput;
};

export type MutationCreateTrainingPlanTemplateArgs = {
  input: CreateTrainingPlanTemplateInput;
};

export type MutationCreateUserArgs = {
  input: CreateUserInput;
};

export type MutationCreateUserGoalArgs = {
  input: CreateUserGoalInput;
};

export type MutationCreateUsersArgs = {
  input: CreateUsersInput;
};

export type MutationDeleteActivityArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAssignedAssessmentArgs = {
  assignmentId: Scalars['ID']['input'];
};

export type MutationDeleteClientEligibleEmailsArgs = {
  clientId: Scalars['String']['input'];
};

export type MutationDeleteCoachTouchPointArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteContentGenreArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteCustomChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFitCoachArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeleteMboMembershipsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDeletePerformanceQualityScoreArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeletePlanArgs = {
  planId: Scalars['ID']['input'];
};

export type MutationDeleteUserArgs = {
  forgetIterable?: Scalars['Boolean']['input'];
  forgetMbo?: Scalars['Boolean']['input'];
  isBulkDelete?: Scalars['Boolean']['input'];
  jira?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationDeleteUserGoalArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationDeleteUserPostOnboardingRecommendationsArgs = {
  input: DeleteUserPostOnboardingRecommendationsInput;
};

export type MutationDeleteUsersArgs = {
  forgetIterable?: Scalars['Boolean']['input'];
  jira?: InputMaybe<Scalars['String']['input']>;
  userIds: Array<Scalars['ID']['input']>;
};

export type MutationDismissPostOnboardingRecommendationArgs = {
  input: DismissPostOnboardingRecommendationInput;
};

export type MutationEditActivityArgs = {
  activity: EditActivityInput;
};

export type MutationEnablePerformanceCoachingForMembersArgs = {
  input: EnablePerformanceCoachingForMembersInput;
};

export type MutationGenerateSignedUrlArgs = {
  input: SignedUrlInput;
};

export type MutationImportApmlCategoriesArgs = {
  input?: InputMaybe<ImportApmlCategoriesInput>;
};

export type MutationImportGoogleUsersArgs = {
  input: ImportGoogleUsersInput;
};

export type MutationInviteFamilyMemberArgs = {
  input: InviteFamilyMemberInput;
};

export type MutationJoinChallengeArgs = {
  challengeTeamId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationJoinLiveClassArgs = {
  classId: Scalars['String']['input'];
};

export type MutationLeaveChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationLeavePracticeArgs = {
  practiceId: Scalars['ID']['input'];
};

export type MutationLeaveProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type MutationMarkBadgesSeenForChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkChatReadArgs = {
  chatId: Scalars['ID']['input'];
  lastMessageRead: Scalars['ZonedDateTime']['input'];
};

export type MutationMarkChatStarredArgs = {
  chatId: Scalars['ID']['input'];
  isStarred: Scalars['Boolean']['input'];
};

export type MutationMarkPlanItemCompleteArgs = {
  id: Scalars['ID']['input'];
};

export type MutationMarkSurveyResponseViewedArgs = {
  surveyResponseId: Scalars['ID']['input'];
};

export type MutationMarkUserStarredArgs = {
  isStarred: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationMigrateApmlExerciseDataArgs = {
  input?: InputMaybe<MigrateApmlExerciseDataInput>;
};

export type MutationMoveUserGameplanDatesArgs = {
  input: MoveUserGameplanDatesInput;
};

export type MutationPurchaseMboContractArgs = {
  input: PurchaseMboContractInput;
};

export type MutationPurchasePricingOptionArgs = {
  input: PurchasePricingOptionInput;
};

export type MutationPurgeWearableDataArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRateAppArgs = {
  feedback: FeedbackKind;
};

export type MutationRebookSessionArgs = {
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId: Scalars['ID']['input'];
  start: Scalars['ZonedDateTime']['input'];
  update?: InputMaybe<RebookSessionUpdateInput>;
  useCronofy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRefreshContentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRefreshContentsArgs = {
  input?: InputMaybe<RefreshContentsInput>;
};

export type MutationRefreshMboCacheArgs = {
  input: RefreshMboCacheInput;
};

export type MutationRefreshMboStaffArgs = {
  input: RefreshMboStaffInput;
};

export type MutationRegisterArgs = {
  input: RegisterUserInput;
};

export type MutationRegisterDeviceArgs = {
  app?: InputMaybe<App>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationRemindFamilyMemberArgs = {
  input: RemindFamilyMemberInput;
};

export type MutationRemoveChallengeArgs = {
  id: Scalars['ID']['input'];
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationRemoveClientArgs = {
  clientId: Scalars['ID']['input'];
};

export type MutationRemoveCoachMembersArgs = {
  clientId: Scalars['ID']['input'];
  coachId: Scalars['ID']['input'];
};

export type MutationRemoveCohortArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveDomainArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveEligibleEmailAddressArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveExerciseArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveFamilyMemberArgs = {
  input: RemoveFamilyMemberInput;
};

export type MutationRemoveFeatureGrantArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveFromChallengeArgs = {
  challengeId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveFromChatRoomArgs = {
  chatRoomId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationRemoveFromClientArgs = {
  clientId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRemoveLocationArgs = {
  locationId: Scalars['ID']['input'];
};

export type MutationRemoveMboContractMappingArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveOfficeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveReactionArgs = {
  reactionId: Scalars['ID']['input'];
};

export type MutationRemoveSavedArgs = {
  contentId: Scalars['ID']['input'];
};

export type MutationRemoveStudioArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveUserSurveysArgs = {
  surveyIdentifier: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationRepairClientUsersArgs = {
  clientId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationReplacePostOnboardingRecommendationsLookupArgs = {
  input?: InputMaybe<ReplacePostOnboardingRecommendationsLookupInput>;
};

export type MutationReportUserArgs = {
  input: ReportUserInput;
};

export type MutationRequestMboMembershipChangeArgs = {
  input: RequestMboMembershipChangeInput;
};

export type MutationRescheduleServiceAppointmentArgs = {
  input: RescheduleServiceAppointmentInput;
};

export type MutationResetPreviewArgs = {
  extension?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationResetProgressArgs = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationRestartPracticeArgs = {
  practiceId: Scalars['ID']['input'];
};

export type MutationRestartProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type MutationRestoreCognitoUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationResyncIterableUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationRevokeCronofyProfileArgs = {
  input: RevokeCronofyProfileInput;
};

export type MutationSaveWearableSamplesArgs = {
  data: WearableSamplesInput;
};

export type MutationSendBulkMessageArgs = {
  input: BulkMessageInput;
};

export type MutationSendHistoricalMessageArgs = {
  chatId: Scalars['ID']['input'];
  createdAt: Scalars['ZonedDateTime']['input'];
  text: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationSendMessageArgs = {
  chatId: Scalars['ID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  optimisticId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type MutationSendSupportRequestArgs = {
  app: App;
  type: SupportRequestType;
};

export type MutationSetClassSchedulesEndDatesArgs = {
  input: ClassSchedulesEndDatesInput;
};

export type MutationSetMemberExperienceArgs = {
  input: MemberExperienceInput;
};

export type MutationSetMinBuildNumberArgs = {
  input: SetMinBuildNumberInput;
};

export type MutationSetModalStatusArgs = {
  status: SetModalStatus;
};

export type MutationSetNotificationOptionsArgs = {
  input: Array<NotificationOptionInput>;
};

export type MutationSetSessionCreditsArgs = {
  input: SessionCreditsInput;
};

export type MutationSetUnitsPreferenceArgs = {
  input: UnitsInput;
};

export type MutationStartPracticeArgs = {
  practiceId: Scalars['ID']['input'];
};

export type MutationStartProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type MutationSyncDailyStepsArgs = {
  data: SyncDailyStepsInput;
};

export type MutationSyncEligibleEmailAddressArgs = {
  input: SyncEligibleEmailAddressInput;
};

export type MutationSyncEligibleMboClientArgs = {
  clientId: Scalars['ID']['input'];
};

export type MutationSyncIosSleepSamplesArgs = {
  build: Scalars['String']['input'];
  platformVersion: Scalars['String']['input'];
  samples: Array<IosSleepSamples>;
};

export type MutationSyncMboMembershipsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationSyncWearableSamplesArgs = {
  data: WearableSamplesInput;
};

export type MutationTempBackfillArrivalActivitiesArgs = {
  input: TempBackfillArrivalActivitiesInput;
};

export type MutationTempFixRocheUsersArgs = {
  input: TempFixRocheUsersInput;
};

export type MutationTriggerIterablePushArgs = {
  campaignId: Scalars['Int']['input'];
  dataFields?: InputMaybe<Scalars['JSONObject']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationUnforgetIterableUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationUnforgetUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationUpdateAttendanceArgs = {
  attendance: CoachSessionAttendance;
  sessionId: Scalars['ID']['input'];
};

export type MutationUpdateAttendedArgs = {
  attended: Scalars['Boolean']['input'];
  sessionId: Scalars['ID']['input'];
};

export type MutationUpdateAvatarArgs = {
  input: UpdateAvatarInput;
};

export type MutationUpdateChallengeArgs = {
  input: UpdateChallengeInput;
};

export type MutationUpdateChatRoomArgs = {
  input: UpdateChatRoomInput;
};

export type MutationUpdateClientArgs = {
  input: UpdateClientInput;
};

export type MutationUpdateCoachCronofyTimezoneArgs = {
  input: UpdateCoachCronofyTimezoneInput;
};

export type MutationUpdateCoachDataArgs = {
  input: UpdateCoachDataInput;
};

export type MutationUpdateCoachLocationArgs = {
  input: UpdateCoachLocationInput;
};

export type MutationUpdateCoachTouchPointArgs = {
  input: UpdateCoachTouchPointInput;
};

export type MutationUpdateCohortArgs = {
  input: UpdateCohortInput;
};

export type MutationUpdateContentGenreArgs = {
  input: UpdateContentGenreInput;
};

export type MutationUpdateDomainArgs = {
  input: UpdateDomainInput;
};

export type MutationUpdateEligibleEmailAddressArgs = {
  input: MutateEligibleEmailAddressInput;
};

export type MutationUpdateExerciseArgs = {
  input: UpdateExerciseInput;
};

export type MutationUpdateExerciseBaseArgs = {
  input: UpdateExerciseBaseInput;
};

export type MutationUpdateExerciseTypeArgs = {
  input: UpdateExerciseTypeInput;
};

export type MutationUpdateExerciseTypeCategoryArgs = {
  input: UpdateExerciseTypeCategoryInput;
};

export type MutationUpdateExerciseTypeCategoryGroupArgs = {
  input: UpdateExerciseTypeCategoryGroupInput;
};

export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};

export type MutationUpdateFeatureGrantArgs = {
  input: UpdateFeatureGrantInput;
};

export type MutationUpdateHealthDataConsentArgs = {
  input: UpdateHealthDataConsentInput;
};

export type MutationUpdateLastActivityArgs = {
  app: App;
  platform?: TokenPlatform;
};

export type MutationUpdateMboContractMappingArgs = {
  input: UpdateMboContractMappingInput;
};

export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};

export type MutationUpdateNotificationOptionArgs = {
  input: UpdateNotificationOptionInput;
};

export type MutationUpdateOfficeArgs = {
  input: UpdateOfficeInput;
};

export type MutationUpdatePerformanceQualityScoreArgs = {
  performanceQualityScore: UpdatePerformanceQualityScoreInput;
};

export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};

export type MutationUpdatePracticeArgs = {
  practiceId: Scalars['ID']['input'];
};

export type MutationUpdatePrivacyPolicyDateArgs = {
  newDate?: InputMaybe<Scalars['ZonedDateTime']['input']>;
};

export type MutationUpdateProfileJsonArgs = {
  input: UpdateProfileJsonInput;
};

export type MutationUpdateProgramArgs = {
  programId: Scalars['ID']['input'];
};

export type MutationUpdateProgressArgs = {
  completedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  contentId: Scalars['ID']['input'];
  customPlanItemId?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['Float']['input']>;
  sectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateStudioArgs = {
  input: UpdateStudioInput;
};

export type MutationUpdateTrainingPlanArgs = {
  input: UpdateTrainingPlanInput;
};

export type MutationUpdateTrainingPlanExerciseArgs = {
  input: UpdateTrainingPlanExerciseInput;
};

export type MutationUpdateTrainingPlanTemplateArgs = {
  input: UpdateTrainingPlanTemplateInput;
};

export type MutationUpdateTrainingPlanWorkoutArgs = {
  input: UpdateTrainingPlanWorkoutInput;
};

export type MutationUpdateUnreadCountArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserBiometricsOptionArgs = {
  input: UpdateUserBiometricsOptionInput;
};

export type MutationUpdateUserFocusAreaArgs = {
  focusArea: FocusArea;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateUserGoalArgs = {
  input: UpdateUserGoalInput;
};

export type MutationUpdateWelcomeSectionDisplayArgs = {
  display: WelcomeSectionDisplay;
};

export type MutationUploadDailyStepsArgs = {
  data: SyncDailyStepsInput;
};

export type MutationUploadIosSleepSamplesArgs = {
  data: UploadIosSleepSamplesInput;
};

export type MutationUploadWearableSamplesArgs = {
  data: WearableSamplesInput;
};

export type NewDeliveryErrorPayload = {
  __typename?: 'NewDeliveryErrorPayload';
  authorUserId: Scalars['ID']['output'];
  error: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type NewMessagePayload = {
  __typename?: 'NewMessagePayload';
  chatRoom: ChatRoom;
  message: Message;
  optimisticId?: Maybe<Scalars['ID']['output']>;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotHello = {
  __typename?: 'NotHello';
  not?: Maybe<Scalars['String']['output']>;
};

export type Note = Node & {
  __typename?: 'Note';
  coach?: Maybe<User>;
  content: Scalars['String']['output'];
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedBy?: Maybe<User>;
  member: User;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export enum NotificationKind {
  Push = 'push',
}

export type NotificationOption = Node & {
  __typename?: 'NotificationOption';
  app: App;
  description: Scalars['String']['output'];
  featureFlag?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iterableId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  push: Scalars['Boolean']['output'];
  value?: Maybe<NotificationOptionValue>;
  visible: Scalars['Boolean']['output'];
};

export type NotificationOptionConnection = Connection & {
  __typename?: 'NotificationOptionConnection';
  count: Scalars['Int']['output'];
  edges: Array<NotificationOptionEdge>;
  nodes: Array<NotificationOption>;
  pageInfo: PageInfo;
};

export type NotificationOptionEdge = Edge & {
  __typename?: 'NotificationOptionEdge';
  cursor: Scalars['String']['output'];
  node: NotificationOption;
};

export type NotificationOptionInput = {
  optionId: Scalars['String']['input'];
  push?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationOptionValue {
  Challenges = 'Challenges',
  Classes = 'Classes',
  Coaching = 'Coaching',
  ContentRating = 'ContentRating',
  DailyReminders = 'DailyReminders',
  GameplanDailyReminders = 'GameplanDailyReminders',
  Marketing = 'Marketing',
  Practices = 'Practices',
  Services = 'Services',
  Training = 'Training',
  WellBeingInsights = 'WellBeingInsights',
}

export type NumberAnswer = {
  __typename?: 'NumberAnswer';
  numberValue: Scalars['Float']['output'];
};

export type Office = Node & {
  __typename?: 'Office';
  client: Client;
  clientOfficeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAppEligible: Scalars['Boolean']['output'];
  isFcmEligible: Scalars['Boolean']['output'];
  location?: Maybe<CoachLocation>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OfficesConnection = Connection & {
  __typename?: 'OfficesConnection';
  count: Scalars['Int']['output'];
  edges: Array<OfficesEdge>;
  nodes: Array<Office>;
  pageInfo: PageInfo;
};

export type OfficesEdge = Edge & {
  __typename?: 'OfficesEdge';
  cursor: Scalars['String']['output'];
  node: Office;
};

export type OfficesFilter = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  isAppEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isFcmEligible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  isCompleted: Scalars['Boolean']['output'];
  surveys: ContentConnection;
};

export type OnboardingMotivation = {
  __typename?: 'OnboardingMotivation';
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum Os {
  Android = 'android',
  Ios = 'ios',
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type ParticipantsFilter = {
  appendSelf?: InputMaybe<Scalars['Boolean']['input']>;
  challengeTeamId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  excludeUsersWithoutAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  excludeUsersWithoutScore?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ParticipantsOrder {
  CreatedAt = 'createdAt',
  FirstName = 'firstName',
  LastName = 'lastName',
  Score = 'score',
}

export type ParticipantsOrderBy = {
  direction: OrderDirection;
  order: ParticipantsOrder;
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  expirationMonth: Scalars['String']['output'];
  expirationYear: Scalars['String']['output'];
  lastFour: Scalars['String']['output'];
  provider: CardProvider;
};

export enum PerformanceQuality {
  BodyComposition = 'BodyComposition',
  Curiosity = 'Curiosity',
  Endurance = 'Endurance',
  FvProfile = 'FVProfile',
  Flowability = 'Flowability',
  FuelUtilization = 'FuelUtilization',
  Grit = 'Grit',
  InnerAwareness = 'InnerAwareness',
  LoadAccumulation = 'LoadAccumulation',
  MovementEfficiency = 'MovementEfficiency',
  NutrientProfile = 'NutrientProfile',
  SelfRegulation = 'SelfRegulation',
  SleepProficiency = 'SleepProficiency',
}

export type PerformanceQualityAttribute = {
  __typename?: 'PerformanceQualityAttribute';
  icon?: Maybe<Icon>;
  name: Scalars['String']['output'];
  value: PerformanceQuality;
};

export type PerformanceQualityConnection = Connection & {
  __typename?: 'PerformanceQualityConnection';
  count: Scalars['Int']['output'];
  edges: Array<PerformanceQualityEdge>;
  nodes: Array<PerformanceQualityScore>;
  pageInfo: PageInfo;
};

export type PerformanceQualityEdge = Edge & {
  __typename?: 'PerformanceQualityEdge';
  cursor: Scalars['String']['output'];
  node: PerformanceQualityScore;
};

export type PerformanceQualityScore = Node & {
  __typename?: 'PerformanceQualityScore';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  performanceQuality: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  subComponent: Scalars['String']['output'];
};

export type Photo = Node & {
  __typename?: 'Photo';
  basePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type PhotoUrlArgs = {
  circle?: InputMaybe<Scalars['Boolean']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type PhotoAnswer = {
  __typename?: 'PhotoAnswer';
  caption?: Maybe<Scalars['String']['output']>;
  photo: Photo;
};

export type PhysicalActivity = Activity &
  Node &
  TimeBasedActivity & {
    __typename?: 'PhysicalActivity';
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    distance?: Maybe<Distance>;
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    icon?: Maybe<Icon>;
    id: Scalars['ID']['output'];
    intensity?: Maybe<IntensityLevel>;
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    source?: Maybe<ActivityGenre>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type Plan = Node & {
  __typename?: 'Plan';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  assessments: Array<AssessmentAssignment>;
  commitmentLevel?: Maybe<PlanCommitmentLevel>;
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  endDate: Scalars['LocalDate']['output'];
  focusArea?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTemplate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phase?: Maybe<Scalars['Int']['output']>;
  planItems: PlanItemConnection;
  /** Number between 0 and 1 representing the percentage of plan items that have been completed */
  progress: Scalars['Float']['output'];
  startDate: Scalars['LocalDate']['output'];
  targetedPerformanceQualities: Array<PerformanceQuality>;
  targetedPerformanceQualityAttributes: Array<PerformanceQualityAttribute>;
  template?: Maybe<Plan>;
  trainingMode?: Maybe<PlanTrainingMode>;
};

export type PlanPlanItemsArgs = {
  filter?: InputMaybe<PlanItemsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export enum PlanCommitmentLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
}

export type PlanItem = {
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  date: Scalars['LocalDate']['output'];
  deletedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  type: PlanItemType;
};

export type PlanItemConnection = Connection & {
  __typename?: 'PlanItemConnection';
  count: Scalars['Int']['output'];
  edges: Array<PlanItemEdge>;
  nodes: Array<PlanItem>;
  pageInfo: PageInfo;
};

export type PlanItemEdge = Edge & {
  __typename?: 'PlanItemEdge';
  cursor: Scalars['String']['output'];
  node: PlanItem;
};

export enum PlanItemType {
  CustomTask = 'CustomTask',
  ExosContent = 'ExosContent',
}

export type PlanItemsFilter = {
  localDateRange?: InputMaybe<LocalDateRange>;
};

export type PlanTemplateEdge = Edge & {
  __typename?: 'PlanTemplateEdge';
  cursor: Scalars['String']['output'];
  node: Plan;
};

export enum PlanTrainingMode {
  Classes = 'Classes',
  TrainingPlan = 'TrainingPlan',
}

export type PracticeParticipantConnection = Connection & {
  __typename?: 'PracticeParticipantConnection';
  count: Scalars['Int']['output'];
  edges: Array<PracticeParticipantsEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type PracticeParticipantsEdge = Edge & {
  __typename?: 'PracticeParticipantsEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type PracticeParticipantsFilter = {
  excludeUsersWithoutAvatar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PracticeProgram = Content &
  Node & {
    __typename?: 'PracticeProgram';
    author?: Maybe<Scalars['String']['output']>;
    completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    congratulations?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    createdAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use subtitle now */
    eyebrow?: Maybe<Scalars['String']['output']>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    isPublished: Scalars['Boolean']['output'];
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    participants: PracticeParticipantConnection;
    progress: Scalars['Float']['output'];
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    sections: ContentCollectionSectionsConnection;
    share?: Maybe<Share>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    skills: Array<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type PracticeProgramParticipantsArgs = {
  filter?: InputMaybe<PracticeParticipantsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type PracticeProgramRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type PracticeProgramSectionsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type PracticeProgramFilter = {
  status?: InputMaybe<PracticeProgramStatus>;
};

export enum PracticeProgramStatus {
  All = 'All',
  Completed = 'Completed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export enum Prefix {
  Avatar = 'avatar',
  Challenge = 'challenge',
  Client = 'client',
  Coach = 'coach',
  ExerciseThumbnail = 'exerciseThumbnail',
  ExerciseVideo = 'exerciseVideo',
  Gym = 'gym',
  Uploads = 'uploads',
}

export enum PricingOptionType {
  Class = 'Class',
  Service = 'Service',
}

/**
 * Exactly one of `mboClassId` or `mboSessionTypeId` must be supplied: `mboClassId`
 * for the options that pay for a class, `mboSessionTypeId` for those that pay for
 * an appointment.
 */
export type PricingOptionsInput = {
  effectiveAtDate: Scalars['ZonedDateTime']['input'];
  locationId: Scalars['ID']['input'];
  mboClassId?: InputMaybe<Scalars['Int']['input']>;
  mboSessionTypeId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Principal = MachineClient | User;

export type Program = Content &
  Node & {
    __typename?: 'Program';
    author?: Maybe<Scalars['String']['output']>;
    completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    congratulations?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    createdAt?: Maybe<Scalars['ZonedDateTime']['output']>;
    currentSection?: Maybe<ContentSection>;
    equipment: Array<Scalars['String']['output']>;
    /** @deprecated use subtitle now */
    eyebrow?: Maybe<Scalars['String']['output']>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    isPublished: Scalars['Boolean']['output'];
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    participants: ProgramParticipantConnection;
    progress: Scalars['Float']['output'];
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    sections: ContentCollectionSectionsConnection;
    share?: Maybe<Share>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    skills: Array<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
  };

export type ProgramParticipantsArgs = {
  filter?: InputMaybe<ProgramParticipantsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type ProgramRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ProgramSectionsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type ProgramParticipantConnection = Connection & {
  __typename?: 'ProgramParticipantConnection';
  count: Scalars['Int']['output'];
  edges: Array<ProgramParticipantsEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type ProgramParticipantsEdge = Edge & {
  __typename?: 'ProgramParticipantsEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type ProgramParticipantsFilter = {
  excludeUsersWithoutAvatar?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProgramsConnection = Connection & {
  __typename?: 'ProgramsConnection';
  count: Scalars['Int']['output'];
  edges: Array<ProgramsEdge>;
  nodes: Array<Program>;
  pageInfo: PageInfo;
};

export type ProgramsEdge = Edge & {
  __typename?: 'ProgramsEdge';
  cursor: Scalars['String']['output'];
  node: Program;
};

export type PurchaseMboContractInput = {
  contractId: Scalars['Int']['input'];
  locationId: Scalars['ID']['input'];
};

export type PurchaseMboContractPayload = {
  __typename?: 'PurchaseMboContractPayload';
  success: Scalars['Boolean']['output'];
};

export type PurchasePricingOptionInput = {
  locationId: Scalars['ID']['input'];
  mboSessionTypeId: Scalars['Int']['input'];
  pricingOptionId: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};

export type PurchasePricingOptionPayload = {
  __typename?: 'PurchasePricingOptionPayload';
  success: Scalars['Boolean']['output'];
};

export type PurgeWearableDataPayload = {
  __typename?: 'PurgeWearableDataPayload';
  user: User;
};

export type Query = {
  __typename?: 'Query';
  activity?: Maybe<Activity>;
  activityGenre?: Maybe<ActivityGenre>;
  activityGenres: Array<ActivityGenre>;
  adminTrainingPlanTemplates: TrainingPlanConnection;
  /** @deprecated No longer supported */
  article?: Maybe<Article>;
  /** @deprecated No longer supported */
  articles: ArticlesConnection;
  assessment?: Maybe<AssessmentAssignment>;
  auditLogActions: Array<AuditLogActionAttribute>;
  auditLogCategories: Array<AuditLogCategoryAttribute>;
  auditLogs: AuditLogsConnection;
  availableAssessments: AssessmentSurveysConnection;
  availableClasses: UserAvailableClassesConnection;
  availableServiceCategories: Array<MboServiceCategory>;
  availableServices: MboServiceResponse;
  blockTrainingComponents: Array<BlockTrainingComponentAttribute>;
  challenge?: Maybe<Challenge>;
  challengeTeam?: Maybe<ChallengeTeam>;
  challengeTemplates: RootChallengeTemplatesConnection;
  challenges: RootChallengesConnection;
  chatRoom?: Maybe<ChatRoom>;
  chatRooms: RootChatRoomsConnection;
  client?: Maybe<Client>;
  clients: RootClientsConnection;
  coachLocation?: Maybe<CoachLocation>;
  coachLocations: CoachLocationsConnection;
  coachSession?: Maybe<CoachSession>;
  cohort?: Maybe<Cohort>;
  cohorts: CohortsConnection;
  content?: Maybe<Content>;
  contentBrands: Array<ContentAttribute>;
  contentCollection?: Maybe<ContentCollection>;
  contentEquipment: Array<Equipment>;
  contentGenre?: Maybe<Genre>;
  contentGenres: Array<Genre>;
  contentIntensities: Array<ContentAttribute>;
  contentLevels: Array<Level>;
  contentProjects: Array<ContentAttribute>;
  contentSplits: Array<Split>;
  contents: ContentConnection;
  contractOptions: MboContractOptionsConnection;
  countries: Array<Country>;
  customChallengeDefaults: CustomChallengeDefaults;
  customPlan: Plan;
  customPlanTemplates: CustomPlanTemplatesConnection;
  domain?: Maybe<Domain>;
  domains: DomainConnection;
  eligibleEmailAddress?: Maybe<EligibleEmailAddress>;
  eligibleEmailAddresses: RootEligibleEmailAddressesConnection;
  exercise?: Maybe<Exercise>;
  exerciseBase?: Maybe<ExerciseBase>;
  exerciseBases: ExerciseBaseConnection;
  exerciseType?: Maybe<ExerciseType>;
  exerciseTypeCategories: ExerciseTypeCategoryConnection;
  exerciseTypeCategory?: Maybe<ExerciseTypeCategory>;
  exerciseTypeCategoryGroup?: Maybe<ExerciseTypeCategoryGroup>;
  exerciseTypeCategoryGroups: ExerciseTypeCategoryGroupConnection;
  exerciseTypes: ExerciseTypeConnection;
  exerciseUnits: Array<ExerciseUnitAttribute>;
  exercises: ExerciseConnection;
  feature?: Maybe<Feature>;
  featureGrant?: Maybe<FeatureGrant>;
  featureGrants: FeatureGrantsConnection;
  features: FeaturesConnection;
  gameplanComponents: Array<ContentAttribute>;
  gameplanSubcomponents: Array<ContentAttribute>;
  getModalStatus: ModalStatus;
  hello: Scalars['String']['output'];
  /** @deprecated No longer supported */
  home: ContentConnection;
  /** Disclaimer paragraphs for a Key Metric detail screen. Empty when the metric has none. */
  keyMetricDisclaimer: Array<Scalars['String']['output']>;
  manyChallenges: Array<Challenge>;
  manyChatRooms: Array<ChatRoom>;
  manyClients: Array<Client>;
  manyCoachLocations: Array<CoachLocation>;
  manyCohorts: Array<Cohort>;
  manyContentGenres: Array<Genre>;
  manyDomains: Array<Domain>;
  manyEligibleEmailAddresses: Array<EligibleEmailAddress>;
  manyExerciseBases: Array<ExerciseBase>;
  manyExerciseTypeCategories: Array<ExerciseTypeCategory>;
  manyExerciseTypeCategoryGroups: Array<ExerciseTypeCategoryGroup>;
  manyExerciseTypes: Array<ExerciseType>;
  manyExercises: Array<Exercise>;
  /** Features by id — backs react-admin's GET_MANY (ReferenceField/Input). */
  manyFeatures: Array<Feature>;
  manyMboContractMappings: Array<MboContractMapping>;
  manyOffices: Array<Office>;
  manyStudios: Array<Studio>;
  manyUsers: Array<User>;
  mboAppointment: MboAppointment;
  mboClass?: Maybe<MboClass>;
  mboContractMapping?: Maybe<MboContractMapping>;
  mboContractMappings: MboContractMappingsConnection;
  /** All MBO contracts for the studio at the given location, unfiltered (includes membership contracts). Admin/debug use. */
  mboStudioContracts: Array<MboStudioContract>;
  /** @deprecated No longer supported */
  notHello?: Maybe<NotHello>;
  note?: Maybe<Note>;
  notificationOption: NotificationOption;
  notificationOptions: NotificationOptionConnection;
  office?: Maybe<Office>;
  offices: OfficesConnection;
  performanceQualities: Array<ContentAttribute>;
  performanceQualityAttributes: Array<PerformanceQualityAttribute>;
  performanceQualityScores: PerformanceQualityConnection;
  planItem: PlanItem;
  pricingOptions: MboPricingOptionsResponse;
  programs: ProgramsConnection;
  self?: Maybe<User>;
  serviceAvailability: MboServiceAvailabilityResponse;
  serviceStaffList: MboServiceStaffListResponse;
  studio?: Maybe<Studio>;
  studios: StudiosConnection;
  survey?: Maybe<Survey>;
  surveyTemplate?: Maybe<SurveyTemplate>;
  systemPreferences: SystemPreferences;
  tipStartDate: Scalars['LocalDate']['output'];
  tips: TipConnection;
  trainingPlan?: Maybe<TrainingPlan>;
  trainingPlanDifficulties: Array<TrainingPlanDifficultyAttribute>;
  trainingPlanDurations: Array<TrainingPlanDurationAttribute>;
  trainingPlanEquipmentCategories: Array<TrainingPlanEquipmentCategoryAttribute>;
  trainingPlanExercise?: Maybe<TrainingPlanExercise>;
  trainingPlanFrequencies: Array<TrainingPlanFrequencyAttribute>;
  trainingPlanPhases: Array<TrainingPlanPhaseAttribute>;
  trainingPlanTemplates: TrainingPlanConnection;
  trainingPlanTypes: Array<TrainingPlanTypeAttribute>;
  trainingPlanWorkout?: Maybe<TrainingPlanWorkout>;
  user?: Maybe<User>;
  userActivity?: Maybe<UserActivity>;
  userAssessmentSurvey: UserAssessmentSurvey;
  userFocusAreas: Array<UserFocusArea>;
  users: RootUsersConnection;
};

export type QueryActivityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryActivityGenreArgs = {
  id: Scalars['ID']['input'];
};

export type QueryActivityGenresArgs = {
  filter?: InputMaybe<ActivityGenresFilter>;
};

export type QueryAdminTrainingPlanTemplatesArgs = {
  filter?: InputMaybe<AdminTrainingPlanTemplatesFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<TrainingPlanOrderBy>>;
};

export type QueryArticleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAssessmentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAuditLogsArgs = {
  filter?: InputMaybe<AuditLogsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryAvailableAssessmentsArgs = {
  filter?: InputMaybe<AvailableAssessmentsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryAvailableClassesArgs = {
  filter: CoachMboClassFilter;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryAvailableServiceCategoriesArgs = {
  input?: InputMaybe<ServiceCategoriesInput>;
};

export type QueryAvailableServicesArgs = {
  input: ServicesInput;
};

export type QueryChallengeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChallengeTeamArgs = {
  id: Scalars['ID']['input'];
};

export type QueryChallengeTemplatesArgs = {
  timezone: Scalars['ZoneId']['input'];
};

export type QueryChallengesArgs = {
  filter?: InputMaybe<ChallengeFilter>;
  input?: InputMaybe<ConnectionInput>;
  sort?: InputMaybe<ChallengeSort>;
};

export type QueryChatRoomArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryChatRoomsArgs = {
  filter?: InputMaybe<ChatRoomsFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ChatRoomsOrderBy>>;
};

export type QueryClientArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryClientsArgs = {
  filter?: InputMaybe<ClientsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryCoachLocationArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCoachLocationsArgs = {
  filter?: InputMaybe<CoachLocationsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryCoachSessionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCohortArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCohortsArgs = {
  filter?: InputMaybe<CohortsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryContentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryContentCollectionArgs = {
  slug: Scalars['String']['input'];
};

export type QueryContentGenreArgs = {
  id: Scalars['ID']['input'];
};

export type QueryContentGenresArgs = {
  filter?: InputMaybe<ContentGenreFilter>;
};

export type QueryContentsArgs = {
  filter?: InputMaybe<ContentFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<ContentOrderBy>;
};

export type QueryContractOptionsArgs = {
  input: ContractOptionsInput;
};

export type QueryCustomPlanArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCustomPlanTemplatesArgs = {
  filter?: InputMaybe<CustomPlanTemplatesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryDomainArgs = {
  id: Scalars['ID']['input'];
};

export type QueryDomainsArgs = {
  filter?: InputMaybe<DomainsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryEligibleEmailAddressArgs = {
  details?: InputMaybe<EligibleEmailAddressDetailsInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryEligibleEmailAddressesArgs = {
  filter?: InputMaybe<EligibleEmailAddressesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryExerciseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExerciseBaseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExerciseBasesArgs = {
  filter?: InputMaybe<ExerciseBaseFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseBaseOrderBy>>;
};

export type QueryExerciseTypeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExerciseTypeCategoriesArgs = {
  filter?: InputMaybe<ExerciseTypeCategoryFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseTypeCategoryOrderBy>>;
};

export type QueryExerciseTypeCategoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExerciseTypeCategoryGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QueryExerciseTypeCategoryGroupsArgs = {
  filter?: InputMaybe<ExerciseTypeCategoryGroupFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseTypeCategoryGroupOrderBy>>;
};

export type QueryExerciseTypesArgs = {
  filter?: InputMaybe<ExerciseTypeFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseTypeOrderBy>>;
};

export type QueryExercisesArgs = {
  filter?: InputMaybe<ExercisesFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ExerciseOrderBy>>;
};

export type QueryFeatureArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFeatureGrantArgs = {
  id: Scalars['ID']['input'];
};

export type QueryFeatureGrantsArgs = {
  filter?: InputMaybe<FeatureGrantFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryFeaturesArgs = {
  filter?: InputMaybe<FeatureFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryGetModalStatusArgs = {
  id: Scalars['ID']['input'];
};

export type QueryKeyMetricDisclaimerArgs = {
  metric: KeyMetric;
};

export type QueryManyChallengesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyChatRoomsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyClientsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyCoachLocationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyCohortsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyContentGenresArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyDomainsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyEligibleEmailAddressesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyExerciseBasesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyExerciseTypeCategoriesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyExerciseTypeCategoryGroupsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyExerciseTypesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyExercisesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyFeaturesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyMboContractMappingsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyOfficesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyStudiosArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryManyUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryMboAppointmentArgs = {
  id: Scalars['String']['input'];
};

export type QueryMboClassArgs = {
  input: MboClassDetailsInput;
};

export type QueryMboContractMappingArgs = {
  id: Scalars['ID']['input'];
};

export type QueryMboContractMappingsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type QueryMboStudioContractsArgs = {
  locationId: Scalars['ID']['input'];
};

export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
};

export type QueryNotificationOptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<NotificationOptionValue>;
};

export type QueryNotificationOptionsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type QueryOfficeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOfficesArgs = {
  filter?: InputMaybe<OfficesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QueryPerformanceQualityScoresArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type QueryPlanItemArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPricingOptionsArgs = {
  input: PricingOptionsInput;
};

export type QueryProgramsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type QueryServiceAvailabilityArgs = {
  input: ServiceAvailabilityInput;
};

export type QueryServiceStaffListArgs = {
  input: ServiceStaffListInput;
};

export type QueryStudioArgs = {
  id: Scalars['ID']['input'];
};

export type QueryStudiosArgs = {
  filter?: InputMaybe<StudiosFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type QuerySurveyArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySurveyTemplateArgs = {
  id: Scalars['ID']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type QueryTrainingPlanArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTrainingPlanExerciseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTrainingPlanTemplatesArgs = {
  filter?: InputMaybe<TrainingPlanTemplatesFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<TrainingPlanOrderBy>>;
};

export type QueryTrainingPlanWorkoutArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mboId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryUserActivityArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUserAssessmentSurveyArgs = {
  surveyContentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UsersFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type Question = {
  __typename?: 'Question';
  answer?: Maybe<Answer>;
  backgroundImage?: Maybe<Photo>;
  canGoBack: Scalars['Boolean']['output'];
  choices: Array<MultipleChoiceOption>;
  cta?: Maybe<QuestionCta>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Show/hide conditions from Qualtrics DisplayLogic (nextQuestion/skip logic
   * redirects instead of hiding). Null/empty means always shown.
   */
  displayConditions?: Maybe<Array<QuestionDisplayCondition>>;
  /** Text above question */
  eyebrow?: Maybe<Scalars['String']['output']>;
  /** hint text below choices and above CTA */
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  layoutType?: Maybe<QuestionLayoutType>;
  nextQuestion?: Maybe<Question>;
  /** input placeholder */
  placeholder?: Maybe<Scalars['String']['output']>;
  progressIndicator?: Maybe<QuestionProgressIndicator>;
  /** Qualtrics Question Name (variable name). Stable identifier when set in Qualtrics; used for parsing logic (e.g. training plan intro survey). */
  questionName?: Maybe<Scalars['String']['output']>;
  questionSubtype?: Maybe<QuestionSubtype>;
  questionType: QuestionType;
  required: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type QuestionCta = {
  __typename?: 'QuestionCta';
  text: Scalars['String']['output'];
};

/**
 * One requirement in a `Question.displayConditions` chain, parsed from
 * Qualtrics DisplayLogic. Only the "Selected" operator is supported; anything
 * else is dropped and the question falls back to always shown.
 */
export type QuestionDisplayCondition = {
  __typename?: 'QuestionDisplayCondition';
  /** How this combines with the entry before it. Always null on the first entry (nothing precedes it) and always set on every later one — not related to whether the question has any displayConditions at all. */
  combinator?: Maybe<DisplayConditionCombinator>;
  /** MultipleChoiceOption.optionIdentifier the member must have selected on `question`. */
  optionIdentifier: Scalars['String']['output'];
  /** The question this requirement depends on. */
  question: Question;
};

export enum QuestionLayoutType {
  OnColumn = 'OnColumn',
  /** Displays tags and takes the space of the content wrapping when needed */
  Tags = 'Tags',
  TwoColumns = 'TwoColumns',
}

export type QuestionProgressIndicator = {
  __typename?: 'QuestionProgressIndicator';
  current: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum QuestionSubtype {
  Multiselect = 'Multiselect',
  OpenTextBox = 'OpenTextBox',
  PhotoUpload = 'PhotoUpload',
  Radio = 'Radio',
  SingleLine = 'SingleLine',
}

export enum QuestionType {
  Birthday = 'Birthday',
  Height = 'Height',
  Intro = 'Intro',
  MultipleChoice = 'MultipleChoice',
  PhotoUpload = 'PhotoUpload',
  TextEntry = 'TextEntry',
  ValueProp = 'ValueProp',
  Weight = 'Weight',
}

export type RateAppPayload = {
  __typename?: 'RateAppPayload';
  user?: Maybe<User>;
};

export type Reaction = {
  __typename?: 'Reaction';
  id: Scalars['ID']['output'];
  kind: ReactionKind;
  user: User;
};

export enum ReactionKind {
  Clap = 'clap',
  Fire = 'fire',
  Grimacing = 'grimacing',
  Laugh = 'laugh',
  RatingNegative = 'rating_negative',
  RatingPositive = 'rating_positive',
  Smile = 'smile',
  Thumbsup = 'thumbsup',
}

export type RebookSessionUpdateInput = {
  duration: Scalars['Int']['input'];
  locationId?: InputMaybe<Scalars['ID']['input']>;
  sessionStyle: CoachSessionStyle;
  sessionType: CoachSessionType;
};

export type RefreshContentPayload = {
  __typename?: 'RefreshContentPayload';
  content?: Maybe<Content>;
};

export type RefreshContentsInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  maxPages?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type RefreshMboCacheInput = {
  mboStudioId: Scalars['String']['input'];
};

export type RefreshMboCachePayload = {
  __typename?: 'RefreshMboCachePayload';
  success: Scalars['Boolean']['output'];
};

export type RefreshMboStaffInput = {
  studioId: Scalars['ID']['input'];
};

export type RefreshMboStaffPayload = {
  __typename?: 'RefreshMboStaffPayload';
  archivedCount: Scalars['Int']['output'];
  upsertedCount: Scalars['Int']['output'];
};

export type RegisterUserInput = {
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  consentDate?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  shareDataWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  shareEEPData?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  user?: Maybe<User>;
};

export type RemindFamilyMemberInput = {
  eligibleEmailAddressId: Scalars['ID']['input'];
};

export type RemoveFamilyMemberInput = {
  eligibleEmailAddressId: Scalars['ID']['input'];
};

export type RepairClientUsersPayload = {
  __typename?: 'RepairClientUsersPayload';
  processed: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
};

export type ReplacePostOnboardingRecommendationsLookupInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReplacePostOnboardingRecommendationsLookupPayload = {
  __typename?: 'ReplacePostOnboardingRecommendationsLookupPayload';
  count: Scalars['Int']['output'];
};

export type ReportUserInput = {
  chatRoomId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  surveyResponseId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type RequestMboMembershipChangeInput = {
  action: MboMembershipRequestAction;
  /**
   * The `id` of the `MboClientContract` the user is requesting to change.
   * Used to disambiguate when the user has multiple active contracts and to
   * include the contract name in the email to the studio.
   */
  clientContractId: Scalars['Int']['input'];
};

export type RequestMboMembershipChangePayload = {
  __typename?: 'RequestMboMembershipChangePayload';
  success: Scalars['Boolean']['output'];
};

export type RequiredLocalDateRange = {
  end: Scalars['LocalDate']['input'];
  start: Scalars['LocalDate']['input'];
};

export type RescheduleServiceAppointmentInput = {
  endTime: Scalars['ZonedDateTime']['input'];
  id: Scalars['String']['input'];
  mboStaffId: Scalars['Int']['input'];
  startTime: Scalars['ZonedDateTime']['input'];
};

export type ResetProgressPayload = {
  __typename?: 'ResetProgressPayload';
  contentEdge?: Maybe<ContentEdge>;
  section?: Maybe<ContentSection>;
};

export type RestartPracticePayload = {
  __typename?: 'RestartPracticePayload';
  assignedPractice: AssignedPractice;
};

export type RestartProgramPayload = {
  __typename?: 'RestartProgramPayload';
  assignedProgram: AssignedProgram;
};

export type RestoreCognitoUserPayload = {
  __typename?: 'RestoreCognitoUserPayload';
  user: User;
};

export type RevokeCronofyProfileInput = {
  coachId?: InputMaybe<Scalars['ID']['input']>;
  profileId: Scalars['String']['input'];
};

export type RevokeCronofyProfileResponse = {
  __typename?: 'RevokeCronofyProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type RootChallengeTemplatesConnection = Connection & {
  __typename?: 'RootChallengeTemplatesConnection';
  count: Scalars['Int']['output'];
  edges: Array<ChallengeTemplateEdge>;
  nodes: Array<ChallengeTemplate>;
  pageInfo: PageInfo;
};

export type RootChallengesConnection = {
  __typename?: 'RootChallengesConnection';
  count: Scalars['Int']['output'];
  edges: Array<Maybe<ChallengeEdge>>;
  nodes: Array<Challenge>;
  pageInfo: PageInfo;
};

export type RootChatRoomsConnection = Connection & {
  __typename?: 'RootChatRoomsConnection';
  count: Scalars['Int']['output'];
  edges: Array<RootChatRoomsEdge>;
  nodes: Array<ChatRoom>;
  pageInfo: PageInfo;
};

export type RootChatRoomsEdge = Edge & {
  __typename?: 'RootChatRoomsEdge';
  cursor: Scalars['String']['output'];
  node: ChatRoom;
};

export type RootClientsConnection = Connection & {
  __typename?: 'RootClientsConnection';
  count: Scalars['Int']['output'];
  edges: Array<RootClientsEdge>;
  nodes: Array<Client>;
  pageInfo: PageInfo;
};

export type RootClientsEdge = Edge & {
  __typename?: 'RootClientsEdge';
  cursor: Scalars['String']['output'];
  node: Client;
};

export type RootEligibleEmailAddressesConnection = Connection & {
  __typename?: 'RootEligibleEmailAddressesConnection';
  count: Scalars['Int']['output'];
  edges: Array<RootEligibleEmailAddressesEdge>;
  nodes: Array<EligibleEmailAddress>;
  pageInfo: PageInfo;
};

export type RootEligibleEmailAddressesEdge = Edge & {
  __typename?: 'RootEligibleEmailAddressesEdge';
  cursor: Scalars['String']['output'];
  node: EligibleEmailAddress;
};

export type RootMboClassEdge = Edge & {
  __typename?: 'RootMboClassEdge';
  cursor: Scalars['String']['output'];
  node: MboClass;
};

export type RootUsersConnection = Connection & {
  __typename?: 'RootUsersConnection';
  count: Scalars['Int']['output'];
  edges: Array<RootUsersEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type RootUsersEdge = Edge & {
  __typename?: 'RootUsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SsoIdentity = {
  __typename?: 'SSOIdentity';
  connection?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type SavedPayload = {
  __typename?: 'SavedPayload';
  content: Content;
  saved: Scalars['Boolean']['output'];
};

export enum ScoreUnit {
  Activities = 'Activities',
  Arrivals = 'Arrivals',
  Hours = 'Hours',
  Kilometers = 'Kilometers',
  Miles = 'Miles',
  Minutes = 'Minutes',
  Steps = 'Steps',
}

export type ServiceAvailabilityInput = {
  endTime: Scalars['ZonedDateTime']['input'];
  locationId: Scalars['ID']['input'];
  mboSessionTypeId: Scalars['Int']['input'];
  mboStaffIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startTime: Scalars['ZonedDateTime']['input'];
};

export type ServiceCategoriesInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  onlyBookable?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ServiceSlotIncrement {
  FifteenMinutes = 'fifteen_minutes',
  FortyFiveMinutes = 'forty_five_minutes',
  SessionDefault = 'session_default',
  SixtyMinutes = 'sixty_minutes',
  ThirtyMinutes = 'thirty_minutes',
}

export type ServiceStaffListInput = {
  locationId: Scalars['ID']['input'];
  mboSessionTypeId: Scalars['Int']['input'];
  startTime: Scalars['ZonedDateTime']['input'];
};

export type ServicesInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  mboProgramId: Scalars['Int']['input'];
  onlyBookable?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SessionCreditsInput = {
  count: Scalars['Int']['input'];
  rowVersion?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type SessionCreditsPayload = {
  __typename?: 'SessionCreditsPayload';
  count: Scalars['Int']['output'];
  rowVersion: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type SetMinBuildNumberInput = {
  app: App;
  buildNumber: Scalars['Int']['input'];
  os: Os;
};

export type SetModalStatus = {
  id: Scalars['ID']['input'];
  modalSeen: Scalars['Boolean']['input'];
};

export type SetNotificationOptionsPayload = {
  __typename?: 'SetNotificationOptionsPayload';
  notificationOptions: Array<NotificationOption>;
};

export type Share = {
  __typename?: 'Share';
  message?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SignedUrlInput = {
  contentType: Scalars['String']['input'];
  prefix: Prefix;
};

export type SignedUrlPayload = {
  __typename?: 'SignedUrlPayload';
  key: Scalars['String']['output'];
  photo: Photo;
  signedUrl: Scalars['String']['output'];
};

export type SimpleContentConnection = {
  count: Scalars['Int']['output'];
  nodes: Array<Content>;
  pageInfo: PageInfo;
};

export type SimpleContentEdge = {
  cursor: Scalars['String']['output'];
  node: Content;
};

export type SleepActivity = Activity &
  Node &
  TimeBasedActivity & {
    __typename?: 'SleepActivity';
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    heartRate?: Maybe<HeartRate>;
    id: Scalars['ID']['output'];
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    sleepEfficiency?: Maybe<Scalars['Float']['output']>;
    sleepOverview: SleepOverview;
    source?: Maybe<Scalars['JSONObject']['output']>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type SleepOverview = {
  __typename?: 'SleepOverview';
  asleep: Scalars['Int']['output'];
  awake: Scalars['Int']['output'];
  inbed: Scalars['Int']['output'];
};

export type SleepTrend = {
  __typename?: 'SleepTrend';
  activities: Array<SleepTrendActivity>;
  averageAsleep: Scalars['Int']['output'];
};

export type SleepTrendActivity = {
  __typename?: 'SleepTrendActivity';
  activity: Activity;
  deviation: Scalars['Float']['output'];
  preceding28DaysAverageAsleep: Scalars['Int']['output'];
};

export type SleepTrendFilter = {
  end: Scalars['ZonedDateTime']['input'];
  start: Scalars['ZonedDateTime']['input'];
};

export type Split = {
  __typename?: 'Split';
  children: Array<Split>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Split>;
  value: Scalars['String']['output'];
};

export type StartPracticePayload = {
  __typename?: 'StartPracticePayload';
  assignedPractice: AssignedPractice;
};

export type StartProgramPayload = {
  __typename?: 'StartProgramPayload';
  assignedProgram: AssignedProgram;
};

export type StringAnswer = {
  __typename?: 'StringAnswer';
  stringValue: Scalars['String']['output'];
};

export type Studio = Node & {
  __typename?: 'Studio';
  acceptedCardTypes: Array<CardProvider>;
  auditLogs: AuditLogsConnection;
  canGrantEligibility: Scalars['Boolean']['output'];
  classes?: Maybe<StudioMboClassesConnection>;
  client: Client;
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCentral: Scalars['Boolean']['output'];
  isVirtual: Scalars['Boolean']['output'];
  locations: CoachLocationsConnection;
  mboAccessToken?: Maybe<Scalars['String']['output']>;
  mboContractMappings: MboContractMappingsConnection;
  mboProgramId?: Maybe<Scalars['String']['output']>;
  mboServiceId: Scalars['String']['output'];
  mboStudioId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  requiredFields: Array<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
};

export type StudioAuditLogsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type StudioClassesArgs = {
  filter?: InputMaybe<StudioClassesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type StudioLocationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type StudioMboContractMappingsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type StudioClassesFilter = {
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  freeClass?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type StudioEdge = Edge & {
  __typename?: 'StudioEdge';
  cursor: Scalars['String']['output'];
  node: Studio;
};

export type StudioMboClassEdge = Edge & {
  __typename?: 'StudioMboClassEdge';
  cursor: Scalars['String']['output'];
  node: MboClass;
};

export type StudioMboClassesConnection = Connection & {
  __typename?: 'StudioMboClassesConnection';
  count: Scalars['Int']['output'];
  edges: Array<StudioMboClassEdge>;
  nodes: Array<MboClass>;
  pageInfo: PageInfo;
};

export type StudiosConnection = Connection & {
  __typename?: 'StudiosConnection';
  count: Scalars['Int']['output'];
  edges: Array<StudioEdge>;
  nodes: Array<Studio>;
  pageInfo: PageInfo;
};

export type StudiosFilter = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  chatRoomUpdate: ChatRoom;
  newDeliveryErrors: NewDeliveryErrorPayload;
  newMessages: NewMessagePayload;
  newTotalUnreadMessageCount: Scalars['Int']['output'];
  totalUnreadMessageCount: TotalUnreadMessageCountPayload;
  wearableSamplesUpdate: WearableSamplesUpdatePayload;
};

export type SubscriptionChatRoomUpdateArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionNewMessagesArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
};

export type SubscriptionNewTotalUnreadMessageCountArgs = {
  apps?: InputMaybe<Array<App>>;
  kinds?: InputMaybe<Array<ChatRoomKind>>;
};

export type SubscriptionTotalUnreadMessageCountArgs = {
  fromCoachedUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SupportRequestType {
  DataAccess = 'DATA_ACCESS',
  DataDeletion = 'DATA_DELETION',
}

export type Survey = Node & {
  __typename?: 'Survey';
  createdAt: Scalars['ZonedDateTime']['output'];
  id: Scalars['ID']['output'];
  responses: Array<SurveyResponse>;
  scope?: Maybe<Scalars['String']['output']>;
  surveyIdentifier: Scalars['String']['output'];
  surveyName?: Maybe<Scalars['String']['output']>;
  template?: Maybe<SurveyTemplate>;
  user: User;
};

export type SurveyFilter = {
  surveyGroup?: InputMaybe<SurveyGroup>;
  surveyIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export enum SurveyGroup {
  Assessment = 'assessment',
  Basics = 'basics',
  Motivations = 'motivations',
}

export type SurveyResponse = Node & {
  __typename?: 'SurveyResponse';
  id: Scalars['ID']['output'];
  numericValue?: Maybe<Scalars['Float']['output']>;
  question: Scalars['String']['output'];
  questionIdentifier: Scalars['String']['output'];
  /** Qualtrics Question Name when stored; null for legacy rows or non-Qualtrics surveys. */
  questionName?: Maybe<Scalars['String']['output']>;
  response: Answer;
  subcategory?: Maybe<Scalars['String']['output']>;
  survey: Survey;
  viewedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type SurveyResponseInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  choices?: InputMaybe<Array<Scalars['String']['input']>>;
  numberAnswer?: InputMaybe<Scalars['Float']['input']>;
  optionIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  questionIdentifier: Scalars['String']['input'];
  /** Qualtrics Question Name (variable name) when the client has it from the survey template. */
  questionName?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Array<Scalars['Int']['input']>>;
  selectedChoices?: InputMaybe<Array<Scalars['Int']['input']>>;
  stringAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyResponsePayload = {
  __typename?: 'SurveyResponsePayload';
  surveyResponse: SurveyResponse;
};

export type SurveyTemplate = {
  __typename?: 'SurveyTemplate';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: Array<Question>;
};

export type SyncDailyStepsInput = {
  entries: Array<DailyStepEntry>;
};

export type SyncEligibleEmailAddressInput = {
  clientId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
};

export type SyncIosSleepSamplesPayload = {
  __typename?: 'SyncIosSleepSamplesPayload';
  success: Scalars['Boolean']['output'];
};

export type SyncMboMembershipsPayload = {
  __typename?: 'SyncMboMembershipsPayload';
  user: User;
};

export type SystemPreferences = {
  __typename?: 'SystemPreferences';
  currentPrivacyPolicyDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  minFitAndroidBuild: Scalars['Int']['output'];
  minFitIosBuild: Scalars['Int']['output'];
  minPerformAndroidBuild: Scalars['Int']['output'];
  minPerformIosBuild: Scalars['Int']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  name: Scalars['String']['output'];
};

export type TempBackfillArrivalActivitiesInput = {
  locationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type TempBackfillArrivalActivitiesPayload = {
  __typename?: 'TempBackfillArrivalActivitiesPayload';
  results: Array<Maybe<TempBackfillArrivalResult>>;
};

export type TempBackfillArrivalResult = {
  __typename?: 'TempBackfillArrivalResult';
  success: Scalars['Boolean']['output'];
  userActivityId: Scalars['ID']['output'];
};

export type TempFixRocheUserResult = {
  __typename?: 'TempFixRocheUserResult';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type TempFixRocheUsersInput = {
  dryRun: Scalars['Boolean']['input'];
  userIds: Array<Scalars['ID']['input']>;
};

export type TempFixRocheUsersPayload = {
  __typename?: 'TempFixRocheUsersPayload';
  results: Array<TempFixRocheUserResult>;
};

export type TimeBasedActivity = {
  duration?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
  startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type Tip = Node & {
  __typename?: 'Tip';
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type TipConnection = Connection & {
  __typename?: 'TipConnection';
  count: Scalars['Int']['output'];
  edges: Array<TipEdge>;
  nodes: Array<Tip>;
  pageInfo: PageInfo;
};

export type TipEdge = Edge & {
  __typename?: 'TipEdge';
  cursor: Scalars['String']['output'];
  node: Tip;
};

export type Token = {
  __typename?: 'Token';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export enum TokenPlatform {
  Mobile = 'mobile',
  Web = 'web',
}

export type ToolActivityInput = {
  duration: Scalars['Int']['input'];
  progress?: InputMaybe<Scalars['Float']['input']>;
  startTime: Scalars['ZonedDateTime']['input'];
  toolType: ToolType;
};

export enum ToolType {
  BoxBreathingEnergizing = 'BoxBreathingEnergizing',
  BoxBreathingRelaxing = 'BoxBreathingRelaxing',
  FourSevenEight = 'FourSevenEight',
  FourZeroSharp = 'FourZeroSharp',
  UnguidedMeditation = 'UnguidedMeditation',
}

export type TotalUnreadMessageCountPayload = {
  __typename?: 'TotalUnreadMessageCountPayload';
  count: Scalars['Int']['output'];
};

export type TouchPointFilter = {
  dueRange?: InputMaybe<DateRange>;
  includeCompletedAfter?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  status?: InputMaybe<Array<CoachTouchPointStatus>>;
};

export type TouchPointsOrderBy = {
  direction: OrderDirection;
  order: CoachTouchPointOrder;
};

export type TrainingPlan = Node & {
  __typename?: 'TrainingPlan';
  archivedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  coach?: Maybe<User>;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  deletedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  difficulty: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  equipmentCategory?: Maybe<TrainingPlanEquipmentCategory>;
  frequency: Scalars['Int']['output'];
  heroPhoto?: Maybe<Photo>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phase: Scalars['Int']['output'];
  template?: Maybe<TrainingPlan>;
  type: TrainingPlanTypeAttribute;
  user?: Maybe<User>;
  weeks: TrainingPlanWeekConnection;
};

export type TrainingPlanWeeksArgs = {
  filter?: InputMaybe<TrainingPlanWeekFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type TrainingPlanBlock = Node & {
  __typename?: 'TrainingPlanBlock';
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  sets: TrainingPlanSetConnection;
  trainingComponent: BlockTrainingComponentAttribute;
  workout: TrainingPlanWorkout;
};

export type TrainingPlanBlockSetsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type TrainingPlanBlockConnection = Connection & {
  __typename?: 'TrainingPlanBlockConnection';
  count: Scalars['Int']['output'];
  edges: Array<TrainingPlanBlockEdge>;
  nodes: Array<TrainingPlanBlock>;
  pageInfo: PageInfo;
};

export type TrainingPlanBlockEdge = Edge & {
  __typename?: 'TrainingPlanBlockEdge';
  cursor: Scalars['String']['output'];
  node: TrainingPlanBlock;
};

export type TrainingPlanBlockInput = {
  order: Scalars['Int']['input'];
  sets: Array<TrainingPlanSetInput>;
  trainingComponent: BlockTrainingComponent;
};

export type TrainingPlanConnection = Connection & {
  __typename?: 'TrainingPlanConnection';
  count: Scalars['Int']['output'];
  edges: Array<TrainingPlanEdge>;
  nodes: Array<TrainingPlan>;
  pageInfo: PageInfo;
};

export type TrainingPlanDifficultyAttribute = {
  __typename?: 'TrainingPlanDifficultyAttribute';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TrainingPlanDurationAttribute = {
  __typename?: 'TrainingPlanDurationAttribute';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type TrainingPlanEdge = Edge & {
  __typename?: 'TrainingPlanEdge';
  cursor: Scalars['String']['output'];
  node: TrainingPlan;
};

export enum TrainingPlanEquipment {
  Bodyweight = 'Bodyweight',
  DumbbellsOnly = 'DumbbellsOnly',
  FullGym = 'FullGym',
}

export enum TrainingPlanEquipmentCategory {
  Bodyweight = 'Bodyweight',
  DumbbellsOnly = 'DumbbellsOnly',
  FullGym = 'FullGym',
  StandingOnly = 'StandingOnly',
}

export type TrainingPlanEquipmentCategoryAttribute = {
  __typename?: 'TrainingPlanEquipmentCategoryAttribute';
  name: Scalars['String']['output'];
  value?: Maybe<TrainingPlanEquipmentCategory>;
};

export type TrainingPlanExercise = Node & {
  __typename?: 'TrainingPlanExercise';
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  count: Scalars['Int']['output'];
  exercise: Exercise;
  id: Scalars['ID']['output'];
  lastSavedWeight?: Maybe<Scalars['Float']['output']>;
  lastTrackedCount?: Maybe<Scalars['Int']['output']>;
  nextTrainingPlanExercise?: Maybe<TrainingPlanExercise>;
  order: Scalars['Int']['output'];
  set: TrainingPlanSet;
  trackedCount?: Maybe<Scalars['Int']['output']>;
  unit: ExerciseUnitAttribute;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type TrainingPlanExerciseConnection = Connection & {
  __typename?: 'TrainingPlanExerciseConnection';
  count: Scalars['Int']['output'];
  edges: Array<TrainingPlanExerciseEdge>;
  nodes: Array<TrainingPlanExercise>;
  pageInfo: PageInfo;
};

export type TrainingPlanExerciseEdge = Edge & {
  __typename?: 'TrainingPlanExerciseEdge';
  cursor: Scalars['String']['output'];
  node: TrainingPlanExercise;
};

export type TrainingPlanExerciseInput = {
  count: Scalars['Int']['input'];
  exerciseId?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  unit: ExerciseUnit;
};

export type TrainingPlanFilter = {
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type TrainingPlanFrequencyAttribute = {
  __typename?: 'TrainingPlanFrequencyAttribute';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export enum TrainingPlanOrder {
  CreatedAt = 'createdAt',
  Name = 'name',
  Phase = 'phase',
}

export type TrainingPlanOrderBy = {
  direction: OrderDirection;
  order: TrainingPlanOrder;
};

export type TrainingPlanPhaseAttribute = {
  __typename?: 'TrainingPlanPhaseAttribute';
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type TrainingPlanSet = Node & {
  __typename?: 'TrainingPlanSet';
  block: TrainingPlanBlock;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  trainingPlanExercises: TrainingPlanExerciseConnection;
};

export type TrainingPlanSetTrainingPlanExercisesArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type TrainingPlanSetConnection = Connection & {
  __typename?: 'TrainingPlanSetConnection';
  count: Scalars['Int']['output'];
  edges: Array<TrainingPlanSetEdge>;
  nodes: Array<TrainingPlanSet>;
  pageInfo: PageInfo;
};

export type TrainingPlanSetEdge = Edge & {
  __typename?: 'TrainingPlanSetEdge';
  cursor: Scalars['String']['output'];
  node: TrainingPlanSet;
};

export type TrainingPlanSetInput = {
  order: Scalars['Int']['input'];
  trainingPlanExercises: Array<TrainingPlanExerciseInput>;
};

export type TrainingPlanTemplatesFilter = {
  difficulty?: InputMaybe<Array<Scalars['String']['input']>>;
  durationMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  equipmentCategory?: InputMaybe<
    Array<InputMaybe<TrainingPlanEquipmentCategory>>
  >;
  frequency?: InputMaybe<Array<Scalars['Int']['input']>>;
  phase?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<TrainingPlanType>>;
};

export enum TrainingPlanType {
  Hyrox = 'HYROX',
  Strength = 'Strength',
}

export type TrainingPlanTypeAttribute = {
  __typename?: 'TrainingPlanTypeAttribute';
  name: Scalars['String']['output'];
  value: TrainingPlanType;
};

export type TrainingPlanWeek = Node & {
  __typename?: 'TrainingPlanWeek';
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  trainingPlan: TrainingPlan;
  workouts: TrainingPlanWorkoutConnection;
};

export type TrainingPlanWeekWorkoutsArgs = {
  filter?: InputMaybe<TrainingPlanWorkoutFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type TrainingPlanWeekConnection = Connection & {
  __typename?: 'TrainingPlanWeekConnection';
  count: Scalars['Int']['output'];
  edges: Array<TrainingPlanWeekEdge>;
  nodes: Array<TrainingPlanWeek>;
  pageInfo: PageInfo;
};

export type TrainingPlanWeekEdge = Edge & {
  __typename?: 'TrainingPlanWeekEdge';
  cursor: Scalars['String']['output'];
  node: TrainingPlanWeek;
};

export type TrainingPlanWeekFilter = {
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingPlanWeekInput = {
  order: Scalars['Int']['input'];
  workouts: Array<TrainingPlanWorkoutInput>;
};

export type TrainingPlanWorkout = Node & {
  __typename?: 'TrainingPlanWorkout';
  blocks: TrainingPlanBlockConnection;
  completedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  progress: Scalars['Float']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  week: TrainingPlanWeek;
};

export type TrainingPlanWorkoutBlocksArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type TrainingPlanWorkoutActivity = Activity &
  Node &
  TimeBasedActivity & {
    __typename?: 'TrainingPlanWorkoutActivity';
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    source?: Maybe<TrainingPlanWorkout>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type TrainingPlanWorkoutConnection = Connection & {
  __typename?: 'TrainingPlanWorkoutConnection';
  count: Scalars['Int']['output'];
  edges: Array<TrainingPlanWorkoutEdge>;
  nodes: Array<TrainingPlanWorkout>;
  pageInfo: PageInfo;
};

export type TrainingPlanWorkoutEdge = Edge & {
  __typename?: 'TrainingPlanWorkoutEdge';
  cursor: Scalars['String']['output'];
  node: TrainingPlanWorkout;
};

export type TrainingPlanWorkoutFilter = {
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingPlanWorkoutInput = {
  blocks: Array<TrainingPlanBlockInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
};

export type TransactionHistoryFilter = {
  endDate: Scalars['LocalDate']['input'];
  startDate: Scalars['LocalDate']['input'];
};

export type TriggerIterablePushPayload = {
  __typename?: 'TriggerIterablePushPayload';
  success: Scalars['Boolean']['output'];
};

export type UnforgetUserPayload = {
  __typename?: 'UnforgetUserPayload';
  userId: Scalars['ID']['output'];
};

export type UnitsInput = {
  unitsPreference: UnitsPreference;
};

export type UnitsPayload = {
  __typename?: 'UnitsPayload';
  user: User;
};

export enum UnitsPreference {
  Imperial = 'imperial',
  Metric = 'metric',
}

export type UpdateAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressLine3?: InputMaybe<Scalars['String']['input']>;
  addressLine4?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  localityOrCity?: InputMaybe<Scalars['String']['input']>;
  postalOrZipCode?: InputMaybe<Scalars['String']['input']>;
  stateOrDistrictOrProvince?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAvatarInput = {
  avatarId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAvatarPayload = {
  __typename?: 'UpdateAvatarPayload';
  user: User;
};

export type UpdateChallengeInput = {
  backgroundId?: InputMaybe<Scalars['String']['input']>;
  badgeId?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  distanceUnit?: InputMaybe<DistanceUnit>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<UpdateChallengeTeamInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChallengeTeamInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateChatRoomInput = {
  app?: InputMaybe<App>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateClientInput = {
  allowsCoachesToCreateMembers?: InputMaybe<Scalars['Boolean']['input']>;
  biometricHardSignOutDuration?: InputMaybe<Scalars['Int']['input']>;
  biometricInactivityTimeout?: InputMaybe<Scalars['Int']['input']>;
  biometricsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  calendarPlatform?: InputMaybe<ClientCalendarPlatform>;
  collectsMemberData?: InputMaybe<Scalars['Boolean']['input']>;
  collectsMemberDataForEEP?: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domainIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  inactivityDuration?: InputMaybe<Scalars['Duration']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFcmOnly?: InputMaybe<Scalars['Boolean']['input']>;
  logoId?: InputMaybe<Scalars['String']['input']>;
  maxFamilyMembers?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsUsToFixTheirUserNames?: InputMaybe<Scalars['Boolean']['input']>;
  requiresEligibleEmailForGym?: InputMaybe<Scalars['Boolean']['input']>;
  serviceSlotIncrement?: InputMaybe<ServiceSlotIncrement>;
  ssoConnection?: InputMaybe<Scalars['String']['input']>;
  strictAppCheck?: InputMaybe<Scalars['Boolean']['input']>;
  usesCustomChallenges?: InputMaybe<Scalars['Boolean']['input']>;
  usesEligibilityServiceType?: InputMaybe<Scalars['Boolean']['input']>;
  usesFitnessCenterForEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  usesGlobalSignOut?: InputMaybe<Scalars['Boolean']['input']>;
  usesHighPerformanceCoaching?: InputMaybe<Scalars['Boolean']['input']>;
  usesMboSso?: InputMaybe<Scalars['Boolean']['input']>;
  usesPersonalTraining?: InputMaybe<Scalars['Boolean']['input']>;
  videoPlatform?: InputMaybe<ClientVideoPlatform>;
};

export type UpdateCoachCronofyTimezoneInput = {
  coachId?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['ZoneId']['input'];
};

export type UpdateCoachCronofyTimezoneResponse = {
  __typename?: 'UpdateCoachCronofyTimezoneResponse';
  user: User;
};

export type UpdateCoachDataInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  bodyPhotoId?: InputMaybe<Scalars['String']['input']>;
  calendlyUrl?: InputMaybe<Scalars['String']['input']>;
  coachClients?: InputMaybe<Array<CoachClientsInput>>;
  coachingStyle?: InputMaybe<CoachingStyle>;
  dailySessionLimit?: InputMaybe<Scalars['Int']['input']>;
  degrees?: InputMaybe<Array<Scalars['String']['input']>>;
  enableCalendarBuffer?: InputMaybe<Scalars['Boolean']['input']>;
  headshotPhotoId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inOfficeDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  mboStaffId?: InputMaybe<Scalars['String']['input']>;
  passions?: InputMaybe<Array<Scalars['String']['input']>>;
  supportedCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supportedGoals?: InputMaybe<Array<UserGoalType>>;
  titles?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<CoachType>;
};

export type UpdateCoachDataPayload = {
  __typename?: 'UpdateCoachDataPayload';
  user: User;
};

export type UpdateCoachLocationInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  gymImageId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isHeadquarters?: InputMaybe<Scalars['Boolean']['input']>;
  joinGymInstructions?: InputMaybe<Scalars['String']['input']>;
  mboLocationId?: InputMaybe<Scalars['String']['input']>;
  membershipAgreementConsentText?: InputMaybe<Scalars['String']['input']>;
  membershipAgreementLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postConnectionInstructions?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  studioId: Scalars['String']['input'];
};

export type UpdateCoachTouchPointInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  due?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCohortInput = {
  coachIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ZonedDateTime']['input']>;
};

export type UpdateContentGenreInput = {
  hideChildren?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDomainInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateEmergencyContactInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExerciseBaseInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  exerciseTypeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  progression?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateExerciseInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  bodyParts?: InputMaybe<Array<Scalars['String']['input']>>;
  canTrackWeight?: InputMaybe<Scalars['Boolean']['input']>;
  coachNotes?: InputMaybe<Scalars['String']['input']>;
  coachingKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultUnit?: InputMaybe<ExerciseUnit>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Array<Scalars['String']['input']>>;
  exerciseBaseId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  modifications?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oneRepMax?: InputMaybe<Array<Scalars['Float']['input']>>;
  progression?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExercisePayload = {
  __typename?: 'UpdateExercisePayload';
  exercise?: Maybe<Exercise>;
};

export type UpdateExerciseTypeCategoryGroupInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExerciseTypeCategoryInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  exerciseTypeCategoryGroupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExerciseTypeInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  exerciseTypeCategoryId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFeatureGrantInput = {
  id: Scalars['ID']['input'];
  /** Editable only for non-client scopes; ignored for scopeType `client`. */
  scopeId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<FeatureState>;
};

export type UpdateFeatureInput = {
  defaultState?: InputMaybe<FeatureState>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiresFeatureFlagKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHealthDataConsentInput = {
  healthDataConsent: Scalars['Boolean']['input'];
  /**
   * Dev only: lets an admin with write access set another member's consent.
   * Defaults to the logged in member.
   */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateHealthDataConsentPayload = {
  __typename?: 'UpdateHealthDataConsentPayload';
  user: User;
};

export type UpdateMboBookingsPayload = {
  __typename?: 'UpdateMboBookingsPayload';
  remainingBookings: Scalars['Int']['output'];
};

export type UpdateMboContractMappingInput = {
  employeeType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mboServiceId?: InputMaybe<Scalars['String']['input']>;
  studioId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type UpdateNotificationOptionInput = {
  app?: InputMaybe<App>;
  description?: InputMaybe<Scalars['String']['input']>;
  featureFlag?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  iterableId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<NotificationOptionValue>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOfficeInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientOfficeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAppEligible?: InputMaybe<Scalars['Boolean']['input']>;
  isFcmEligible?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePerformanceQualityScoreInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  performanceQuality?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  subComponent?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanInput = {
  /** If true, will allow admin users in the dev environment to override start date restrictions */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
  planItems?: InputMaybe<Array<UpdatePlanItemInput>>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  targetedPerformanceQualities?: InputMaybe<Array<PerformanceQuality>>;
};

export type UpdatePlanItemInput = {
  component?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['LocalDate']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PlanItemType>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  plan: Plan;
};

export type UpdatePracticePayload = {
  __typename?: 'UpdatePracticePayload';
  assignedPractice: AssignedPractice;
};

export type UpdateProfileJsonInput = {
  profileJson?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateProfileJsonPayload = {
  __typename?: 'UpdateProfileJsonPayload';
  user: User;
};

export type UpdateProgramPayload = {
  __typename?: 'UpdateProgramPayload';
  assignedProgram: AssignedProgram;
};

export type UpdateStudioInput = {
  canGrantEligibility?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCentral?: InputMaybe<Scalars['Boolean']['input']>;
  isVirtual?: InputMaybe<Scalars['Boolean']['input']>;
  mboProgramId?: InputMaybe<Scalars['String']['input']>;
  mboServiceId?: InputMaybe<Scalars['String']['input']>;
  mboStudioId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTrainingPlanExerciseInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  completedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  trackedCount?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateTrainingPlanInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  weeks?: InputMaybe<Array<TrainingPlanWeekInput>>;
};

export type UpdateTrainingPlanTemplateInput = {
  archivedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  deletedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  equipmentCategory?: InputMaybe<TrainingPlanEquipmentCategory>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phase?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TrainingPlanType>;
  weeks?: InputMaybe<Array<TrainingPlanWeekInput>>;
};

export type UpdateTrainingPlanWorkoutInput = {
  completedAt?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateUserBiometricsOptionInput = {
  optIn: Scalars['Boolean']['input'];
};

export type UpdateUserBiometricsOptionPayload = {
  __typename?: 'UpdateUserBiometricsOptionPayload';
  user: User;
};

export type UpdateUserFocusAreaResponse = {
  __typename?: 'UpdateUserFocusAreaResponse';
  user: User;
};

export type UpdateUserGoalInput = {
  coachNote?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  type: UserGoalType;
};

export type UpdateUserGoalPayload = {
  __typename?: 'UpdateUserGoalPayload';
  user: User;
};

export type UpdateUserInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<UpdateAddressInput>;
  birthday?: InputMaybe<Scalars['LocalDate']['input']>;
  clientRelationship?: InputMaybe<UserClientRelationship>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emergencyContact?: InputMaybe<UpdateEmergencyContactInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fitClientId?: InputMaybe<Scalars['ID']['input']>;
  /** Note: due to opt-in functionality for gameplan reminders, this field cannot be unset */
  gameplanReminderOffset?: InputMaybe<Scalars['Duration']['input']>;
  hasHighPerformanceCoaching?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  identity?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isCoach?: InputMaybe<Scalars['Boolean']['input']>;
  isExerciseEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isMegaAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isReadOnlyAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isSalesTeam?: InputMaybe<Scalars['Boolean']['input']>;
  isTestDataCreator?: InputMaybe<Scalars['Boolean']['input']>;
  isTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  officeLocation?: InputMaybe<Scalars['ID']['input']>;
  pronoun?: InputMaybe<Scalars['String']['input']>;
  registered?: InputMaybe<Scalars['Boolean']['input']>;
  shareDataWithEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  shareEEPData?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  workingStyle?: InputMaybe<WorkingStyle>;
};

export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  user: User;
};

export type UploadDailyStepsPayload = {
  __typename?: 'UploadDailyStepsPayload';
  count: Scalars['Int']['output'];
};

export type UploadIosSleepSamplesInput = {
  build: Scalars['String']['input'];
  platformVersion: Scalars['String']['input'];
  samples: Array<IosSleepSamples>;
};

export type UploadIosSleepSamplesPayload = {
  __typename?: 'UploadIosSleepSamplesPayload';
  count: Scalars['Int']['output'];
};

export type UploadWearableSamplesPayload = {
  __typename?: 'UploadWearableSamplesPayload';
  count: Scalars['Int']['output'];
};

export type User = Node & {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  activity: ActivityConnection;
  activityAggregates: ActivityAggregates;
  /** @deprecated Performs poorly and doesn't serve our use cases well. Prefer the app field on a chat or other object which is actually related to the interaction you're interested in. */
  app: App;
  assessmentSurveys: UserAssessmentSurveysConnection;
  assignedPrograms: UserAssignedProgramsConnection;
  auditLogs: AuditLogsConnection;
  authHistory: UserAuthHistoryConnection;
  availableClasses: UserAvailableClassesConnection;
  avatar?: Maybe<Photo>;
  biometricsOptIn: Scalars['Boolean']['output'];
  birthday?: Maybe<Scalars['LocalDate']['output']>;
  blockedUsers: UserBlockedUsersConnection;
  bookedAppointments: AppointmentBookingsConnection;
  bookedClasses: UserBookingsConnection;
  /** Creates or returns the chat between the user and the selected bot. Returns null if the user does not have access to the bot in question. */
  botChat?: Maybe<ChatRoom>;
  /** Tells the type of the bot. Returns null if the user is not a bot. */
  botKind?: Maybe<BotKind>;
  canCreateMembers: Scalars['Boolean']['output'];
  canShareData: Scalars['Boolean']['output'];
  challenges: UserChallengesConnection;
  chatRooms: UserChatRoomsConnection;
  clientRelationship?: Maybe<UserClientRelationship>;
  clientRequiresGymMembership: Scalars['Boolean']['output'];
  coachData?: Maybe<CoachData>;
  coachSessionCredits?: Maybe<CoachSessionCredits>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ZonedDateTime']['output'];
  currentCustomPlan?: Maybe<Plan>;
  currentPractice?: Maybe<AssignedPractice>;
  currentProgram?: Maybe<AssignedProgram>;
  customPlanState: CustomPlanStateConnection;
  customPlans: UserPlansConnection;
  customPlansActiveDays: Array<ActiveCustomPlanDay>;
  dailyActivityAggregates: Array<DailyActivityAggregate>;
  /** @deprecated Use `insights`, which separates each dimension's copy from its daily scores. */
  dailyInsightScores: Array<DailyInsightScores>;
  dailySteps: Array<DailySteps>;
  /** Error-level logs from the last 7 days that reference this user. */
  datadogErrors: DatadogErrors;
  devices: Array<Device>;
  eligibleEmailAddress?: Maybe<EligibleEmailAddress>;
  email: Scalars['String']['output'];
  emergencyContactDetails?: Maybe<EmergencyContactDetails>;
  /** Non-null only for ephemeral test accounts. */
  expiresAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  familyInvitations: Array<EligibleEmailAddress>;
  featureFlagState?: Maybe<FeatureFlagState>;
  /**
   * Active features resolved for this user. Clients read the whole set in one
   * round trip instead of one `hasFeature` call per key. `FeatureAccess.reason`
   * stays admin-only.
   */
  features: Array<FeatureAccess>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstSignedInAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  fitClient?: Maybe<Client>;
  fitCoach?: Maybe<User>;
  fitCoachChat?: Maybe<ChatRoom>;
  fitnessCenterMembership: FitnessCenterMembership;
  focusArea?: Maybe<UserFocusArea>;
  gameplanReminder: GameplanReminder;
  /** @deprecated Use User.gameplanReminder instead */
  gameplanReminderOffset?: Maybe<Scalars['Duration']['output']>;
  goal?: Maybe<UserGoal>;
  /** Whether a feature is enabled for this user. */
  hasFeature: Scalars['Boolean']['output'];
  hasHighPerformanceCoaching: Scalars['Boolean']['output'];
  hasInPersonMemberships: Scalars['Boolean']['output'];
  hasServicesAccess: Scalars['Boolean']['output'];
  healthDataConsent: Scalars['Boolean']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  highPerformanceEndDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  highPerformanceStartDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  hpecCohort?: Maybe<Cohort>;
  id: Scalars['ID']['output'];
  identity?: Maybe<Scalars['String']['output']>;
  /** Null while the member hasn't yet accumulated enough history to calibrate. */
  insightScoreCalibratedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  insights: UserInsights;
  isAdmin: Scalars['Boolean']['output'];
  isBlocked: Scalars['Boolean']['output'];
  isCoach: Scalars['Boolean']['output'];
  isExerciseEditor: Scalars['Boolean']['output'];
  isFamilyMember: Scalars['Boolean']['output'];
  isMegaAdmin: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isReadOnlyAdmin: Scalars['Boolean']['output'];
  isSalesTeam: Scalars['Boolean']['output'];
  isStarred: Scalars['Boolean']['output'];
  isTestDataCreator: Scalars['Boolean']['output'];
  isTestUser: Scalars['Boolean']['output'];
  iterableToken: Token;
  lastActivity: LastActivity;
  lastName?: Maybe<Scalars['String']['output']>;
  memberExperience: MemberExperience;
  membershipLocations: Array<FitnessCenterMembershipLocation>;
  needsToCompleteAccount: Scalars['Boolean']['output'];
  notes: UserNotesConnection;
  notificationOption: NotificationOption;
  notificationOptions: Array<NotificationOption>;
  officeLocation?: Maybe<CoachLocation>;
  onboarding: Onboarding;
  opportunities: Array<OnboardingMotivation>;
  practicePrograms: UserPracticeProgramsConnection;
  /**
   * App names the user has enabled Private Account on (e.g. "fit-mobile"),
   * regardless of the requesting app. Unlike `isPrivate`, which is scoped to
   * the requesting app's x-application-name. Empty when not private anywhere.
   */
  privateApps: Array<Scalars['String']['output']>;
  profileComplete: Scalars['Boolean']['output'];
  profileJson?: Maybe<Scalars['JSONObject']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  registered: Scalars['Boolean']['output'];
  savedContent: ContentSavedConnection;
  section?: Maybe<ContentSection>;
  sessions: UserCoachSessionsConnection;
  share?: Maybe<Share>;
  shareDataWithEmployer: Scalars['Boolean']['output'];
  shareEEPData: Scalars['Boolean']['output'];
  shouldSeeRateAppModal: Scalars['Boolean']['output'];
  sleepTrend: SleepTrend;
  strengths: Array<OnboardingMotivation>;
  studios: UserStudiosConnection;
  surveys: UserSurveysConnection;
  timezone?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['JSONObject']['output']>;
  trainingPlans: TrainingPlanConnection;
  unitsPreference: UnitsPreference;
  userActivity: UserActivityConnection;
  userActivityTrend: Array<UserActivitySummary>;
  userId: Scalars['String']['output'];
  wearableSamples: WearableSamplesConnection;
  wearableSamplesLastSyncedAt?: Maybe<Scalars['ZonedDateTime']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Removed welcome section */
  welcomeSectionDisplay: WelcomeSectionDisplay;
  workingStyle?: Maybe<WorkingStyle>;
};

export type UserActivityArgs = {
  filter?: InputMaybe<ActivityFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserActivityAggregatesArgs = {
  dateRange?: InputMaybe<DateRange>;
};

export type UserAssessmentSurveysArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type UserAssignedProgramsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type UserAuditLogsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type UserAvailableClassesArgs = {
  filter: MboClassFilter;
  input?: InputMaybe<ConnectionInput>;
};

export type UserBlockedUsersArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type UserBookedAppointmentsArgs = {
  filter?: InputMaybe<MboBookingsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserBookedClassesArgs = {
  filter: MboBookingsFilter;
  input?: InputMaybe<ConnectionInput>;
};

export type UserBotChatArgs = {
  bot: BotKind;
};

export type UserChallengesArgs = {
  filter?: InputMaybe<ChallengesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserChatRoomsArgs = {
  filters?: InputMaybe<ChatRoomsFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<ChatRoomsOrderBy>>;
};

export type UserCustomPlanStateArgs = {
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<CustomPlanStateOrderBy>>;
};

export type UserCustomPlansArgs = {
  filter?: InputMaybe<CustomPlansFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserCustomPlansActiveDaysArgs = {
  filter: CustomPlanActiveDaysFilter;
};

export type UserDailyActivityAggregatesArgs = {
  dateRange: RequiredLocalDateRange;
};

export type UserDailyInsightScoresArgs = {
  dateRange: RequiredLocalDateRange;
};

export type UserDailyStepsArgs = {
  dateRange: RequiredLocalDateRange;
};

export type UserDatadogErrorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFeatureFlagStateArgs = {
  appName: Scalars['String']['input'];
  key: Scalars['String']['input'];
};

export type UserHasFeatureArgs = {
  key: Scalars['String']['input'];
};

export type UserIterableTokenArgs = {
  tokenType?: InputMaybe<TokenPlatform>;
};

export type UserMembershipLocationsArgs = {
  filter?: InputMaybe<MembershipLocationsFilter>;
};

export type UserNotesArgs = {
  filter?: InputMaybe<UserNotesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserNotificationOptionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<NotificationOptionValue>;
};

export type UserNotificationOptionsArgs = {
  app: App;
};

export type UserPracticeProgramsArgs = {
  filter?: InputMaybe<PracticeProgramFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserSavedContentArgs = {
  filter?: InputMaybe<ContentFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserSectionArgs = {
  id: Scalars['String']['input'];
};

export type UserSessionsArgs = {
  dateFilter?: InputMaybe<Array<DateFilter>>;
  filter?: InputMaybe<CoachSessionFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<CoachSessionOrderBy>>;
};

export type UserSleepTrendArgs = {
  filter: SleepTrendFilter;
};

export type UserStudiosArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type UserSurveysArgs = {
  filter?: InputMaybe<SurveyFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserTrainingPlansArgs = {
  filter?: InputMaybe<TrainingPlanFilter>;
  input?: InputMaybe<ConnectionInput>;
  orderBy?: InputMaybe<Array<TrainingPlanOrderBy>>;
};

export type UserUserActivityArgs = {
  filter?: InputMaybe<UserActivityFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserWearableSamplesArgs = {
  filter?: InputMaybe<WearableSamplesFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserActivity = Node & {
  __typename?: 'UserActivity';
  activity?: Maybe<Activity>;
  attribution?: Maybe<ActivityAttribution>;
  attributionTitle?: Maybe<Scalars['String']['output']>;
  attributionType: UserActivityAttributionType;
  distance?: Maybe<Distance>;
  duration?: Maybe<Scalars['Int']['output']>;
  endTime: Scalars['ZonedDateTime']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use SleepActivity.sleepEfficiency instead */
  sleepEfficiency?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<ActivitySource>;
  startTime: Scalars['ZonedDateTime']['output'];
  title: Scalars['String']['output'];
  type: UserActivityType;
};

export enum UserActivityAttributionType {
  Assessment = 'Assessment',
  Classes = 'Classes',
  Monitoring = 'Monitoring',
  Other = 'Other',
  Practice = 'Practice',
  Program = 'Program',
  Sleep = 'Sleep',
  TrainingPlan = 'TrainingPlan',
}

export type UserActivityConnection = Connection & {
  __typename?: 'UserActivityConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserActivityEdge>;
  nodes: Array<UserActivity>;
  pageInfo: PageInfo;
};

export type UserActivityEdge = Edge & {
  __typename?: 'UserActivityEdge';
  cursor: Scalars['String']['output'];
  node: UserActivity;
};

export type UserActivityFilter = {
  attributionType?: InputMaybe<Array<InputMaybe<UserActivityAttributionType>>>;
  type?: InputMaybe<Array<InputMaybe<UserActivityType>>>;
};

export type UserActivitySummary = {
  __typename?: 'UserActivitySummary';
  classes: Scalars['Int']['output'];
  date: Scalars['LocalDate']['output'];
  other: Scalars['Int']['output'];
  practice: Scalars['Int']['output'];
  program: Scalars['Int']['output'];
};

export enum UserActivityType {
  Aod = 'Aod',
  Article = 'Article',
  Assessment = 'Assessment',
  Audio = 'Audio',
  Encore = 'Encore',
  GymArrival = 'GymArrival',
  InPerson = 'InPerson',
  ManualEntry = 'ManualEntry',
  PracticeSelection = 'PracticeSelection',
  ProgramSelection = 'ProgramSelection',
  Tool = 'Tool',
  TrainingPlan = 'TrainingPlan',
  Video = 'Video',
  Virtual = 'Virtual',
  Vod = 'Vod',
  WearableGoogleFit = 'WearableGoogleFit',
  WearableHealthConnectActivity = 'WearableHealthConnectActivity',
  WearableHealthKit = 'WearableHealthKit',
  WearableHealthKitSleep = 'WearableHealthKitSleep',
}

export type UserAssessmentAssignmentEdge = Edge & {
  __typename?: 'UserAssessmentAssignmentEdge';
  cursor: Scalars['String']['output'];
  node: AssessmentAssignment;
};

export type UserAssessmentAssignmentsConnection = Connection & {
  __typename?: 'UserAssessmentAssignmentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserAssessmentAssignmentEdge>;
  nodes: Array<AssessmentAssignment>;
  pageInfo: PageInfo;
};

export type UserAssessmentAssignmentsFilter = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAssessmentSurvey = Node & {
  __typename?: 'UserAssessmentSurvey';
  assignments: UserAssessmentAssignmentsConnection;
  id: Scalars['ID']['output'];
  /**
   * whether or not this survey is shown to members
   * these are not directly assignable and are completed by coaches
   * @deprecated Use type instead
   */
  isMemberFacing: Scalars['Boolean']['output'];
  /**
   * latest assignments will return 2 assignments per survey
   * used to show currently assigned and last completed assessments
   */
  latestAssignments: Array<AssessmentAssignment>;
  mnmrType?: Maybe<Scalars['String']['output']>;
  template: SurveyTemplate;
  title?: Maybe<Scalars['String']['output']>;
  type: AssessmentType;
};

export type UserAssessmentSurveyAssignmentsArgs = {
  filter?: InputMaybe<UserAssessmentAssignmentsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type UserAssessmentSurveyEdge = Edge & {
  __typename?: 'UserAssessmentSurveyEdge';
  cursor: Scalars['String']['output'];
  node: UserAssessmentSurvey;
};

export type UserAssessmentSurveysConnection = Connection & {
  __typename?: 'UserAssessmentSurveysConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserAssessmentSurveyEdge>;
  nodes: Array<UserAssessmentSurvey>;
  pageInfo: PageInfo;
};

export type UserAssignedProgramsConnection = Connection & {
  __typename?: 'UserAssignedProgramsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserAssignedProgramsEdge>;
  nodes: Array<AssignedProgram>;
  pageInfo: PageInfo;
};

export type UserAssignedProgramsEdge = Edge & {
  __typename?: 'UserAssignedProgramsEdge';
  cursor: Scalars['String']['output'];
  node: AssignedProgram;
};

export type UserAuthHistory = Node & {
  __typename?: 'UserAuthHistory';
  challengeResponses: Array<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['ZonedDateTime']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserAuthHistoryConnection = Connection & {
  __typename?: 'UserAuthHistoryConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserAuthHistoryEdge>;
  nodes: Array<UserAuthHistory>;
  pageInfo: PageInfo;
};

export type UserAuthHistoryEdge = Edge & {
  __typename?: 'UserAuthHistoryEdge';
  cursor: Scalars['String']['output'];
  node: UserAuthHistory;
};

export type UserAvailabilityConnection = Connection & {
  __typename?: 'UserAvailabilityConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserAvailabilityEdge>;
  nodes: Array<Calendar>;
  pageInfo: PageInfo;
};

export type UserAvailabilityEdge = Edge & {
  __typename?: 'UserAvailabilityEdge';
  cursor: Scalars['String']['output'];
  node: Calendar;
};

export type UserAvailableClassesConnection = Connection & {
  __typename?: 'UserAvailableClassesConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserAvailableClassesEdge>;
  nodes: Array<MboClass>;
  pageInfo: PageInfo;
};

export type UserAvailableClassesEdge = Edge & {
  __typename?: 'UserAvailableClassesEdge';
  cursor: Scalars['String']['output'];
  node: MboClass;
};

export type UserBlockedUsersConnection = Connection & {
  __typename?: 'UserBlockedUsersConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserBlockedUsersEdge>;
  nodes: Array<User>;
  pageInfo: PageInfo;
};

export type UserBlockedUsersEdge = Edge & {
  __typename?: 'UserBlockedUsersEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserBookingsConnection = Connection & {
  __typename?: 'UserBookingsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserBookingsEdge>;
  nodes: Array<MboClass>;
  pageInfo: PageInfo;
};

export type UserBookingsEdge = Edge & {
  __typename?: 'UserBookingsEdge';
  cursor: Scalars['String']['output'];
  node: MboClass;
};

export type UserChallengesConnection = Connection & {
  __typename?: 'UserChallengesConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserChallengesEdge>;
  nodes: Array<Challenge>;
  pageInfo: PageInfo;
};

export type UserChallengesEdge = Edge & {
  __typename?: 'UserChallengesEdge';
  cursor: Scalars['String']['output'];
  node: Challenge;
  place?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
};

export type UserChatRoomsConnection = Connection & {
  __typename?: 'UserChatRoomsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserChatRoomsEdge>;
  nodes: Array<ChatRoom>;
  pageInfo: PageInfo;
  unreadMessageCount: Scalars['Int']['output'];
};

export type UserChatRoomsEdge = Edge & {
  __typename?: 'UserChatRoomsEdge';
  cursor: Scalars['String']['output'];
  node: ChatRoom;
};

export enum UserClientRelationship {
  Dependent = 'Dependent',
  Employee = 'Employee',
}

export type UserCoachSessionsConnection = Connection & {
  __typename?: 'UserCoachSessionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserCoachSessionsEdge>;
  nodes: Array<CoachSession>;
  pageInfo: PageInfo;
};

export type UserCoachSessionsEdge = Edge & {
  __typename?: 'UserCoachSessionsEdge';
  cursor: Scalars['String']['output'];
  node: CoachSession;
};

export type UserFocusArea = {
  __typename?: 'UserFocusArea';
  description: Scalars['String']['output'];
  icon: Icon;
  name: Scalars['String']['output'];
  value: FocusArea;
};

export type UserGoal = {
  __typename?: 'UserGoal';
  coachNote?: Maybe<Scalars['String']['output']>;
  coachNoteUpdatedBy?: Maybe<User>;
  createdAt: Scalars['ZonedDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: UserGoalType;
  updatedAt: Scalars['ZonedDateTime']['output'];
};

export enum UserGoalType {
  Appearance = 'Appearance',
  Creativity = 'Creativity',
  EmotionalIntelligence = 'EmotionalIntelligence',
  EmotionalWellbeing = 'EmotionalWellbeing',
  EnergyLevels = 'EnergyLevels',
  GeneralRegulation = 'GeneralRegulation',
  Health = 'Health',
  /** @deprecated Not used */
  NotSure = 'NotSure',
  PainManagement = 'PainManagement',
  /** @deprecated Use 'PainManagement' instead */
  PainReduction = 'PainReduction',
  PhysicalPerformance = 'PhysicalPerformance',
  /** @deprecated Use 'SocialWellbeing' instead */
  Relationships = 'Relationships',
  Resilience = 'Resilience',
  SharperBrain = 'SharperBrain',
  /** @deprecated Not used */
  SocialWellbeing = 'SocialWellbeing',
  /** @deprecated Use 'PhysicalPerformance' instead */
  ToneUp = 'ToneUp',
  /** @deprecated Not used */
  TryingNewThings = 'TryingNewThings',
  /** @deprecated Not used */
  WorkPerformance = 'WorkPerformance',
}

export type UserInsights = {
  __typename?: 'UserInsights';
  movement: MovementInsights;
};

export type UserNotesConnection = Connection & {
  __typename?: 'UserNotesConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserNotesEdge>;
  nodes: Array<Note>;
  pageInfo: PageInfo;
};

export type UserNotesEdge = Edge & {
  __typename?: 'UserNotesEdge';
  cursor: Scalars['String']['output'];
  node: Note;
};

export type UserNotesFilter = {
  coachId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserPlansConnection = Connection & {
  __typename?: 'UserPlansConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserPlansEdge>;
  nodes: Array<Plan>;
  pageInfo: PageInfo;
};

export type UserPlansEdge = Edge & {
  __typename?: 'UserPlansEdge';
  cursor: Scalars['String']['output'];
  node: Plan;
};

export type UserPostOnboardingRecommendation = {
  __typename?: 'UserPostOnboardingRecommendation';
  id: Scalars['ID']['output'];
};

export type UserPracticeProgramEdge = Edge & {
  __typename?: 'UserPracticeProgramEdge';
  cursor: Scalars['String']['output'];
  node: PracticeProgram;
};

export type UserPracticeProgramsConnection = Connection & {
  __typename?: 'UserPracticeProgramsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserPracticeProgramEdge>;
  nodes: Array<PracticeProgram>;
  pageInfo: PageInfo;
};

export type UserStudiosConnection = Connection & {
  __typename?: 'UserStudiosConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserStudiosEdge>;
  nodes: Array<Studio>;
  pageInfo: PageInfo;
};

export type UserStudiosEdge = Edge & {
  __typename?: 'UserStudiosEdge';
  cursor: Scalars['String']['output'];
  node: Studio;
};

export type UserSurveysConnection = Connection & {
  __typename?: 'UserSurveysConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserSurveysEdge>;
  nodes: Array<Survey>;
  pageInfo: PageInfo;
};

export type UserSurveysEdge = Edge & {
  __typename?: 'UserSurveysEdge';
  cursor: Scalars['String']['output'];
  node: Survey;
};

export type UsersFilter = {
  clientId?: InputMaybe<Array<Scalars['String']['input']>>;
  coachId?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasSignedIn?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isCoach?: InputMaybe<Scalars['Boolean']['input']>;
  isStubUser?: InputMaybe<Scalars['Boolean']['input']>;
  isTestUser?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Video = Content &
  Node & {
    __typename?: 'Video';
    author?: Maybe<Scalars['String']['output']>;
    brand?: Maybe<Scalars['String']['output']>;
    contentEquipment: Array<Equipment>;
    contentGenre?: Maybe<Genre>;
    contentLevel?: Maybe<Level>;
    contentSplit?: Maybe<Split>;
    contentTime?: Maybe<ContentTime>;
    /** @deprecated use contentEquipment */
    equipment: Array<Scalars['String']['output']>;
    feedback?: Maybe<FeedbackKind>;
    firstPublishedAt?: Maybe<Scalars['String']['output']>;
    gameplanMetadata?: Maybe<GameplanMetadata>;
    heroPhoto?: Maybe<Photo>;
    html?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    intensity?: Maybe<Scalars['String']['output']>;
    isPublished: Scalars['Boolean']['output'];
    kind?: Maybe<Scalars['String']['output']>;
    lastPublishedAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated use contentLevel */
    level?: Maybe<Scalars['String']['output']>;
    logoPhoto?: Maybe<Photo>;
    mediaType?: Maybe<Scalars['String']['output']>;
    mnmrType?: Maybe<Scalars['String']['output']>;
    movementProgressions: MovementProgressionsConnection;
    /** @deprecated use firstPublishedAt */
    publishedAt?: Maybe<Scalars['String']['output']>;
    recommendations: ContentRecommendationsConnection;
    saved?: Maybe<Scalars['Boolean']['output']>;
    share?: Maybe<Share>;
    shortDescription?: Maybe<Scalars['String']['output']>;
    split?: Maybe<Split>;
    subGenre?: Maybe<Scalars['String']['output']>;
    subtitle?: Maybe<Scalars['String']['output']>;
    tags: Array<Scalars['String']['output']>;
    /** @deprecated use contentTime */
    time?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    trackingData?: Maybe<ContentTrackingData>;
    trainingCommitment?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    video: Scalars['String']['output'];
  };

export type VideoMovementProgressionsArgs = {
  filter?: InputMaybe<MovementProgressionsFilter>;
  input?: InputMaybe<ConnectionInput>;
};

export type VideoRecommendationsArgs = {
  input?: InputMaybe<ConnectionInput>;
};

export type VideoActivity = Activity &
  CoachBasedActivity &
  Node &
  TimeBasedActivity & {
    __typename?: 'VideoActivity';
    brand?: Maybe<Scalars['String']['output']>;
    coachAvatar?: Maybe<Photo>;
    coachFirstName?: Maybe<Scalars['String']['output']>;
    coachLastName?: Maybe<Scalars['String']['output']>;
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    heroPhoto?: Maybe<Photo>;
    id: Scalars['ID']['output'];
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    source?: Maybe<Video>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type WearableActivity = Activity &
  Node &
  TimeBasedActivity & {
    __typename?: 'WearableActivity';
    contentGenre?: Maybe<Genre>;
    date: Scalars['ZonedDateTime']['output'];
    distance?: Maybe<Distance>;
    duration?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    /** @deprecated use contentGenre */
    genre?: Maybe<Scalars['String']['output']>;
    heartRate?: Maybe<HeartRate>;
    icon?: Maybe<Icon>;
    id: Scalars['ID']['output'];
    overlappingActivity?: Maybe<Activity>;
    program?: Maybe<Program>;
    progress: Scalars['Float']['output'];
    source?: Maybe<Scalars['JSONObject']['output']>;
    startTime?: Maybe<Scalars['ZonedDateTime']['output']>;
    title: Scalars['String']['output'];
    trendType?: Maybe<ActivityTrendType>;
    type: ActivityType;
  };

export type WearableSample = Node & {
  __typename?: 'WearableSample';
  filtered: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  platform: Os;
  platformVersion: Scalars['String']['output'];
  sample: Scalars['JSONObject']['output'];
  sdk: WearableSdk;
  startDate: Scalars['ZonedDateTime']['output'];
  syncMethod: WearableSyncMethod;
};

export type WearableSampleEdge = Edge & {
  __typename?: 'WearableSampleEdge';
  cursor: Scalars['String']['output'];
  node: WearableSample;
};

export type WearableSamplesConnection = Connection & {
  __typename?: 'WearableSamplesConnection';
  count: Scalars['Int']['output'];
  edges: Array<WearableSampleEdge>;
  nodes: Array<WearableSample>;
  pageInfo: PageInfo;
};

export type WearableSamplesFilter = {
  platform?: InputMaybe<Os>;
  startDateRange?: InputMaybe<DateRange>;
};

export type WearableSamplesInput = {
  build: Scalars['String']['input'];
  platform: Os;
  platformVersion: Scalars['String']['input'];
  samples: Array<Scalars['JSONObject']['input']>;
  sdk: WearableSdk;
  syncMethod?: WearableSyncMethod;
};

export type WearableSamplesUpdatePayload = {
  __typename?: 'WearableSamplesUpdatePayload';
  processedCount: Scalars['Int']['output'];
  source: WearableUploadStream;
  user: User;
};

export enum WearableSdk {
  /** @deprecated Use HealthConnect */
  GoogleFit = 'GoogleFit',
  HealthConnect = 'HealthConnect',
  HealthKit = 'HealthKit',
}

export enum WearableSyncMethod {
  Background = 'background',
  Foreground = 'foreground',
}

export enum WearableUploadStream {
  IosSleepSamples = 'iosSleepSamples',
  WearableSamples = 'wearableSamples',
}

export enum WelcomeSectionDisplay {
  Default = 'default',
  Hidden = 'hidden',
  ShowAlways = 'showAlways',
}

export enum WorkingStyle {
  Hybrid = 'hybrid',
  Office = 'office',
  Remote = 'remote',
}

export type ZonedDateTimeRange = {
  __typename?: 'ZonedDateTimeRange';
  end?: Maybe<Scalars['ZonedDateTime']['output']>;
  start?: Maybe<Scalars['ZonedDateTime']['output']>;
};

export type ArchiveMissedWorkoutTouchPointsInput = {
  dryRun: Scalars['Boolean']['input'];
};

export type RequestMboMembershipCancellationPayload = {
  __typename?: 'requestMboMembershipCancellationPayload';
  success: Scalars['Boolean']['output'];
};

export type JoinLiveClassMutationVariables = Exact<{
  classId: Scalars['String']['input'];
}>;

export type JoinLiveClassMutation = {
  __typename?: 'Mutation';
  joinLiveClass: {
    __typename?: 'ActivityPayload';
    activity:
      | { __typename?: 'ArticleActivity'; id: string }
      | { __typename?: 'AudioActivity'; id: string }
      | { __typename?: 'MboClassActivity'; id: string }
      | { __typename?: 'PhysicalActivity'; id: string }
      | { __typename?: 'SleepActivity'; id: string }
      | { __typename?: 'TrainingPlanWorkoutActivity'; id: string }
      | { __typename?: 'VideoActivity'; id: string }
      | { __typename?: 'WearableActivity'; id: string };
  };
};

export type MessagePreviewFragment = {
  __typename?: 'MessagePreview';
  title: string;
  description?: string | null;
  url: string;
  image?: {
    __typename?: 'Photo';
    url: string;
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type MessageDetailsFragment = {
  __typename?: 'Message';
  id: string;
  text: string;
  createdAt: string;
  automated: boolean;
  user: {
    __typename?: 'User';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
  };
  photos: Array<{
    __typename?: 'Photo';
    id: string;
    preview?: string | null;
    basePath: string;
  }>;
  previews: Array<{
    __typename?: 'MessagePreview';
    title: string;
    description?: string | null;
    url: string;
    image?: {
      __typename?: 'Photo';
      url: string;
      basePath: string;
      id: string;
      preview?: string | null;
    } | null;
  }>;
};

export type ChatRoomDetailsFragment = {
  __typename?: 'ChatRoom';
  id: string;
  name?: string | null;
  kind: ChatRoomKind;
  isArchived: boolean;
  lastMessageRead?: string | null;
  lastMessageReceivedAt?: string | null;
  users: {
    __typename?: 'ChatRoomUsersConnection';
    nodes: Array<{
      __typename?: 'User';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
    }>;
  };
  messages: {
    __typename?: 'ChatRoomMessagesConnection';
    unreadMessageCount: number;
    nodes: Array<{
      __typename?: 'Message';
      id: string;
      text: string;
      createdAt: string;
      automated: boolean;
      user: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
      };
      photos: Array<{
        __typename?: 'Photo';
        id: string;
        preview?: string | null;
        basePath: string;
      }>;
      previews: Array<{
        __typename?: 'MessagePreview';
        title: string;
        description?: string | null;
        url: string;
        image?: {
          __typename?: 'Photo';
          url: string;
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
      }>;
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor: string;
    };
  };
};

export type GetUserChatRoomsQueryVariables = Exact<{
  filters?: InputMaybe<ChatRoomsFilter>;
}>;

export type GetUserChatRoomsQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    chatRooms: {
      __typename?: 'UserChatRoomsConnection';
      nodes: Array<{
        __typename?: 'ChatRoom';
        id: string;
        name?: string | null;
        kind: ChatRoomKind;
        isArchived: boolean;
        lastMessageRead?: string | null;
        lastMessageReceivedAt?: string | null;
        users: {
          __typename?: 'ChatRoomUsersConnection';
          nodes: Array<{
            __typename?: 'User';
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
          }>;
        };
        messages: {
          __typename?: 'ChatRoomMessagesConnection';
          unreadMessageCount: number;
          nodes: Array<{
            __typename?: 'Message';
            id: string;
            text: string;
            createdAt: string;
            automated: boolean;
            user: {
              __typename?: 'User';
              id: string;
              firstName?: string | null;
              lastName?: string | null;
              avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
            };
            photos: Array<{
              __typename?: 'Photo';
              id: string;
              preview?: string | null;
              basePath: string;
            }>;
            previews: Array<{
              __typename?: 'MessagePreview';
              title: string;
              description?: string | null;
              url: string;
              image?: {
                __typename?: 'Photo';
                url: string;
                basePath: string;
                id: string;
                preview?: string | null;
              } | null;
            }>;
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor: string;
          };
        };
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        endCursor: string;
      };
    };
  } | null;
};

export type GetChatRoomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  messagesInput?: InputMaybe<ConnectionInput>;
}>;

export type GetChatRoomQuery = {
  __typename?: 'Query';
  chatRoom?: {
    __typename?: 'ChatRoom';
    id: string;
    name?: string | null;
    kind: ChatRoomKind;
    isArchived: boolean;
    lastMessageRead?: string | null;
    lastMessageReceivedAt?: string | null;
    messagesWithInput: {
      __typename?: 'ChatRoomMessagesConnection';
      unreadMessageCount: number;
      nodes: Array<{
        __typename?: 'Message';
        id: string;
        text: string;
        createdAt: string;
        automated: boolean;
        user: {
          __typename?: 'User';
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
        };
        photos: Array<{
          __typename?: 'Photo';
          id: string;
          preview?: string | null;
          basePath: string;
        }>;
        previews: Array<{
          __typename?: 'MessagePreview';
          title: string;
          description?: string | null;
          url: string;
          image?: {
            __typename?: 'Photo';
            url: string;
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
        }>;
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor: string;
        endCursor: string;
      };
    };
    users: {
      __typename?: 'ChatRoomUsersConnection';
      nodes: Array<{
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
      }>;
    };
    messages: {
      __typename?: 'ChatRoomMessagesConnection';
      unreadMessageCount: number;
      nodes: Array<{
        __typename?: 'Message';
        id: string;
        text: string;
        createdAt: string;
        automated: boolean;
        user: {
          __typename?: 'User';
          id: string;
          firstName?: string | null;
          lastName?: string | null;
          avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
        };
        photos: Array<{
          __typename?: 'Photo';
          id: string;
          preview?: string | null;
          basePath: string;
        }>;
        previews: Array<{
          __typename?: 'MessagePreview';
          title: string;
          description?: string | null;
          url: string;
          image?: {
            __typename?: 'Photo';
            url: string;
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
        }>;
      }>;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        endCursor: string;
      };
    };
  } | null;
};

export type GetCoachChatRoomQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoachChatRoomQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    fitCoach?: {
      __typename?: 'User';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
    } | null;
    chatRooms: {
      __typename?: 'UserChatRoomsConnection';
      nodes: Array<{
        __typename?: 'ChatRoom';
        id: string;
        kind: ChatRoomKind;
        name?: string | null;
        isArchived: boolean;
        lastMessageRead?: string | null;
        lastMessageReceivedAt?: string | null;
        usersWithoutInput: {
          __typename?: 'ChatRoomUsersConnection';
          nodes: Array<{
            __typename?: 'User';
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
          }>;
        };
        users: {
          __typename?: 'ChatRoomUsersConnection';
          nodes: Array<{
            __typename?: 'User';
            id: string;
            firstName?: string | null;
            lastName?: string | null;
            avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
          }>;
        };
        messages: {
          __typename?: 'ChatRoomMessagesConnection';
          unreadMessageCount: number;
          nodes: Array<{
            __typename?: 'Message';
            id: string;
            text: string;
            createdAt: string;
            automated: boolean;
            user: {
              __typename?: 'User';
              id: string;
              firstName?: string | null;
              lastName?: string | null;
              avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
            };
            photos: Array<{
              __typename?: 'Photo';
              id: string;
              preview?: string | null;
              basePath: string;
            }>;
            previews: Array<{
              __typename?: 'MessagePreview';
              title: string;
              description?: string | null;
              url: string;
              image?: {
                __typename?: 'Photo';
                url: string;
                basePath: string;
                id: string;
                preview?: string | null;
              } | null;
            }>;
          }>;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            endCursor: string;
          };
        };
      }>;
    };
  } | null;
};

export type GenerateSignedUrlMutationVariables = Exact<{
  input: SignedUrlInput;
}>;

export type GenerateSignedUrlMutation = {
  __typename?: 'Mutation';
  generateSignedUrl: {
    __typename?: 'SignedUrlPayload';
    signedUrl: string;
    key: string;
    photo: {
      __typename?: 'Photo';
      id: string;
      preview?: string | null;
      basePath: string;
    };
  };
};

export type SendMessageMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;

export type SendMessageMutation = {
  __typename?: 'Mutation';
  sendMessage: {
    __typename?: 'Message';
    id: string;
    text: string;
    createdAt: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    };
    photos: Array<{
      __typename?: 'Photo';
      id: string;
      preview?: string | null;
      basePath: string;
    }>;
  };
};

export type MarkChatReadMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
  lastMessageRead: Scalars['ZonedDateTime']['input'];
}>;

export type MarkChatReadMutation = {
  __typename?: 'Mutation';
  markChatRead: {
    __typename?: 'ChatRoom';
    id: string;
    lastMessageRead?: string | null;
  };
};

export type GetCoachChatTotalUnreadQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCoachChatTotalUnreadQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    coachData?: {
      __typename?: 'CoachData';
      totalUnreadMessageCount: number;
    } | null;
  } | null;
};

export type NewMessagesSubscriptionVariables = Exact<{
  chatId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type NewMessagesSubscription = {
  __typename?: 'Subscription';
  newMessages: {
    __typename?: 'NewMessagePayload';
    optimisticId?: string | null;
    chatRoom: { __typename?: 'ChatRoom'; id: string };
    message: {
      __typename?: 'Message';
      id: string;
      text: string;
      createdAt: string;
      automated: boolean;
      user: {
        __typename?: 'User';
        id: string;
        firstName?: string | null;
        lastName?: string | null;
        avatar?: { __typename?: 'Photo'; preview?: string | null } | null;
      };
      photos: Array<{
        __typename?: 'Photo';
        id: string;
        preview?: string | null;
        basePath: string;
      }>;
      previews: Array<{
        __typename?: 'MessagePreview';
        title: string;
        description?: string | null;
        url: string;
        image?: {
          __typename?: 'Photo';
          url: string;
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
      }>;
    };
  };
};

export type NewTotalUnreadMessageCountSubscriptionVariables = Exact<{
  kinds?: InputMaybe<Array<ChatRoomKind> | ChatRoomKind>;
  apps?: InputMaybe<Array<App> | App>;
}>;

export type NewTotalUnreadMessageCountSubscription = {
  __typename?: 'Subscription';
  newTotalUnreadMessageCount: number;
};

export type GetCoachSessionsQueryVariables = Exact<{
  input?: InputMaybe<ConnectionInput>;
  dateFilter?: InputMaybe<Array<DateFilter> | DateFilter>;
  filter?: InputMaybe<CoachSessionFilter>;
}>;

export type GetCoachSessionsQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    sessions: {
      __typename?: 'UserCoachSessionsConnection';
      nodes: Array<{
        __typename?: 'CoachSession';
        id: string;
        sessionStyle: CoachSessionStyle;
        sessionType?: CoachSessionType | null;
        meetingUrl?: string | null;
        joinableTime: string;
        coach: {
          __typename?: 'User';
          firstName?: string | null;
          lastName?: string | null;
          isCoach: boolean;
          id: string;
          isTestUser: boolean;
          registered: boolean;
          avatar?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
        };
        calendar?: {
          __typename?: 'Calendar';
          id: string;
          start: string;
          end: string;
          duration: number;
        } | null;
        location?: {
          __typename?: 'CoachLocation';
          id: string;
          name?: string | null;
          studio?: { __typename?: 'Studio'; timezone: string } | null;
        } | null;
      }>;
    };
  } | null;
};

export type CoachSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CoachSessionQuery = {
  __typename?: 'Query';
  coachSession?: {
    __typename?: 'CoachSession';
    id: string;
    sessionStyle: CoachSessionStyle;
    sessionType?: CoachSessionType | null;
    meetingUrl?: string | null;
    joinableTime: string;
    coach: {
      __typename?: 'User';
      firstName?: string | null;
      lastName?: string | null;
      isCoach: boolean;
      id: string;
      isTestUser: boolean;
      registered: boolean;
      avatar?: {
        __typename?: 'Photo';
        basePath: string;
        id: string;
        preview?: string | null;
      } | null;
    };
    calendar?: {
      __typename?: 'Calendar';
      id: string;
      start: string;
      end: string;
      duration: number;
    } | null;
    location?: {
      __typename?: 'CoachLocation';
      id: string;
      name?: string | null;
      studio?: { __typename?: 'Studio'; timezone: string } | null;
    } | null;
  } | null;
};

export type CoachSessionNodeFragment = {
  __typename?: 'CoachSession';
  id: string;
  sessionStyle: CoachSessionStyle;
  sessionType?: CoachSessionType | null;
  meetingUrl?: string | null;
  joinableTime: string;
  coach: {
    __typename?: 'User';
    firstName?: string | null;
    lastName?: string | null;
    isCoach: boolean;
    id: string;
    isTestUser: boolean;
    registered: boolean;
    avatar?: {
      __typename?: 'Photo';
      basePath: string;
      id: string;
      preview?: string | null;
    } | null;
  };
  calendar?: {
    __typename?: 'Calendar';
    id: string;
    start: string;
    end: string;
    duration: number;
  } | null;
  location?: {
    __typename?: 'CoachLocation';
    id: string;
    name?: string | null;
    studio?: { __typename?: 'Studio'; timezone: string } | null;
  } | null;
};

export type CoachSessionDetailsFragment = {
  __typename?: 'CoachSession';
  id: string;
  sessionStyle: CoachSessionStyle;
  sessionType?: CoachSessionType | null;
  meetingUrl?: string | null;
  joinableTime: string;
  calendar?: {
    __typename?: 'Calendar';
    id: string;
    start: string;
    end: string;
    duration: number;
  } | null;
  location?: {
    __typename?: 'CoachLocation';
    id: string;
    name?: string | null;
    studio?: { __typename?: 'Studio'; timezone: string } | null;
  } | null;
};

export type CoachUserFragment = {
  __typename?: 'User';
  firstName?: string | null;
  lastName?: string | null;
  isCoach: boolean;
  id: string;
  isTestUser: boolean;
  registered: boolean;
  avatar?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type GetOnDemandSectionsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetOnDemandSectionsQuery = {
  __typename?: 'Query';
  contentCollection?: {
    __typename?: 'ContentCollection';
    title: string;
    subtitle?: string | null;
    sections: {
      __typename?: 'ContentCollectionSectionsConnection';
      nodes: Array<{
        __typename?: 'ContentSection';
        brand?: string | null;
        id: string;
        title?: string | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        bannerPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        logoPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
      }>;
    };
  } | null;
};

export type OnDemandSectionArticleFragment = {
  __typename?: 'Article';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionAudioFragment = {
  __typename?: 'Audio';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionBannerFragment = {
  __typename?: 'Banner';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionClickThroughMediaFragment = {
  __typename?: 'ClickThroughMedia';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionContentSectionFragment = {
  __typename?: 'ContentSection';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionInAppSurveyFragment = {
  __typename?: 'InAppSurvey';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionLinkFragment = {
  __typename?: 'Link';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionPracticeProgramFragment = {
  __typename?: 'PracticeProgram';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionProgramFragment = {
  __typename?: 'Program';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionVideoFragment = {
  __typename?: 'Video';
  id: string;
  title?: string | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type OnDemandSectionFragment =
  | OnDemandSectionArticleFragment
  | OnDemandSectionAudioFragment
  | OnDemandSectionBannerFragment
  | OnDemandSectionClickThroughMediaFragment
  | OnDemandSectionContentSectionFragment
  | OnDemandSectionInAppSurveyFragment
  | OnDemandSectionLinkFragment
  | OnDemandSectionPracticeProgramFragment
  | OnDemandSectionProgramFragment
  | OnDemandSectionVideoFragment;

export type OnDemandPreviewArticleFragment = {
  __typename?: 'Article';
  brand?: string | null;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewAudioFragment = {
  __typename?: 'Audio';
  brand?: string | null;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewBannerFragment = {
  __typename?: 'Banner';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewClickThroughMediaFragment = {
  __typename?: 'ClickThroughMedia';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewContentSectionFragment = {
  __typename?: 'ContentSection';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewInAppSurveyFragment = {
  __typename?: 'InAppSurvey';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewLinkFragment = {
  __typename?: 'Link';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewPracticeProgramFragment = {
  __typename?: 'PracticeProgram';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewProgramFragment = {
  __typename?: 'Program';
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewVideoFragment = {
  __typename?: 'Video';
  brand?: string | null;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandPreviewFragment =
  | OnDemandPreviewArticleFragment
  | OnDemandPreviewAudioFragment
  | OnDemandPreviewBannerFragment
  | OnDemandPreviewClickThroughMediaFragment
  | OnDemandPreviewContentSectionFragment
  | OnDemandPreviewInAppSurveyFragment
  | OnDemandPreviewLinkFragment
  | OnDemandPreviewPracticeProgramFragment
  | OnDemandPreviewProgramFragment
  | OnDemandPreviewVideoFragment;

export type ContentEquipmentBasicsFragment = {
  __typename?: 'Equipment';
  name: string;
  value: string;
};

export type ContentAttributeDetailsFragment = {
  __typename?: 'ContentAttribute';
  name: string;
  value: string;
};

export type ContentSplitBasicsFragment = {
  __typename?: 'Split';
  name: string;
  value: string;
};

export type ContentLevelBasicsFragment = {
  __typename?: 'Level';
  name: string;
  value: string;
};

export type ContentGenreBasicsFragment = {
  __typename?: 'Genre';
  id: string;
  name: string;
  value: string;
};

export type ContentTimeBasicsFragment = {
  __typename?: 'ContentTime';
  name: string;
  value: string;
};

export type ContentGenreWithChildrenFragment = {
  __typename?: 'Genre';
  id: string;
  name: string;
  value: string;
  children: Array<{
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
    parent?: {
      __typename?: 'Genre';
      id: string;
      name: string;
      value: string;
    } | null;
  }>;
};

export type GetOnDemandDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetOnDemandDetailsQuery = {
  __typename?: 'Query';
  content?:
    | {
        __typename?: 'Article';
        html?: string | null;
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        brand?: string | null;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Audio';
        html?: string | null;
        audio: string;
        transcript?: string | null;
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        brand?: string | null;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Banner';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'ClickThroughMedia';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'ContentSection';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'InAppSurvey';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Link';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'PracticeProgram';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Program';
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Video';
        html?: string | null;
        video: string;
        shortDescription?: string | null;
        author?: string | null;
        feedback?: FeedbackKind | null;
        isPublished: boolean;
        brand?: string | null;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        recommendations: {
          __typename?: 'ContentRecommendationsConnection';
          nodes: Array<
            | {
                __typename?: 'Article';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Audio';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Banner';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ClickThroughMedia';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'ContentSection';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'InAppSurvey';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Link';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'PracticeProgram';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Program';
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
            | {
                __typename?: 'Video';
                brand?: string | null;
                id: string;
                title?: string | null;
                time?: string | null;
                saved?: boolean | null;
                heroPhoto?: {
                  __typename?: 'Photo';
                  basePath: string;
                  id: string;
                  preview?: string | null;
                } | null;
                contentEquipment: Array<{
                  __typename?: 'Equipment';
                  name: string;
                  value: string;
                }>;
                contentGenre?: {
                  __typename?: 'Genre';
                  id: string;
                  name: string;
                  value: string;
                } | null;
                contentLevel?: {
                  __typename?: 'Level';
                  name: string;
                  value: string;
                } | null;
                contentSplit?: {
                  __typename?: 'Split';
                  name: string;
                  value: string;
                } | null;
                contentTime?: {
                  __typename?: 'ContentTime';
                  name: string;
                  value: string;
                } | null;
              }
          >;
        };
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | null;
};

export type OnDemandDetailsArticleFragment = {
  __typename?: 'Article';
  html?: string | null;
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  brand?: string | null;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsAudioFragment = {
  __typename?: 'Audio';
  html?: string | null;
  audio: string;
  transcript?: string | null;
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  brand?: string | null;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsBannerFragment = {
  __typename?: 'Banner';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsClickThroughMediaFragment = {
  __typename?: 'ClickThroughMedia';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsContentSectionFragment = {
  __typename?: 'ContentSection';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsInAppSurveyFragment = {
  __typename?: 'InAppSurvey';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsLinkFragment = {
  __typename?: 'Link';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsPracticeProgramFragment = {
  __typename?: 'PracticeProgram';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsProgramFragment = {
  __typename?: 'Program';
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsVideoFragment = {
  __typename?: 'Video';
  html?: string | null;
  video: string;
  shortDescription?: string | null;
  author?: string | null;
  feedback?: FeedbackKind | null;
  isPublished: boolean;
  brand?: string | null;
  id: string;
  title?: string | null;
  time?: string | null;
  saved?: boolean | null;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  recommendations: {
    __typename?: 'ContentRecommendationsConnection';
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
  heroPhoto?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
  contentGenre?: {
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
  } | null;
  contentLevel?: { __typename?: 'Level'; name: string; value: string } | null;
  contentSplit?: { __typename?: 'Split'; name: string; value: string } | null;
  contentTime?: {
    __typename?: 'ContentTime';
    name: string;
    value: string;
  } | null;
};

export type OnDemandDetailsFragment =
  | OnDemandDetailsArticleFragment
  | OnDemandDetailsAudioFragment
  | OnDemandDetailsBannerFragment
  | OnDemandDetailsClickThroughMediaFragment
  | OnDemandDetailsContentSectionFragment
  | OnDemandDetailsInAppSurveyFragment
  | OnDemandDetailsLinkFragment
  | OnDemandDetailsPracticeProgramFragment
  | OnDemandDetailsProgramFragment
  | OnDemandDetailsVideoFragment;

export type FilterContentsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilter>;
  input?: InputMaybe<ConnectionInput>;
}>;

export type FilterContentsQuery = {
  __typename?: 'Query';
  contents: {
    __typename?: 'ContentConnection';
    count: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor: string;
      endCursor: string;
    };
    nodes: Array<
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
    >;
  };
};

export type GetContentGenresQueryVariables = Exact<{ [key: string]: never }>;

export type GetContentGenresQuery = {
  __typename?: 'Query';
  contentGenres: Array<{
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
    children: Array<{
      __typename?: 'Genre';
      id: string;
      name: string;
      value: string;
      parent?: {
        __typename?: 'Genre';
        id: string;
        name: string;
        value: string;
      } | null;
    }>;
  }>;
};

export type GetContentAttributesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetContentAttributesQuery = {
  __typename?: 'Query';
  contentGenres: Array<{
    __typename?: 'Genre';
    id: string;
    name: string;
    value: string;
    children: Array<{
      __typename?: 'Genre';
      id: string;
      name: string;
      value: string;
      parent?: {
        __typename?: 'Genre';
        id: string;
        name: string;
        value: string;
      } | null;
    }>;
  }>;
  contentEquipment: Array<{
    __typename?: 'Equipment';
    name: string;
    value: string;
  }>;
  contentLevels: Array<{ __typename?: 'Level'; name: string; value: string }>;
  contentSplits: Array<{ __typename?: 'Split'; name: string; value: string }>;
  contentIntensities: Array<{
    __typename?: 'ContentAttribute';
    name: string;
    value: string;
  }>;
  contentBrands: Array<{
    __typename?: 'ContentAttribute';
    name: string;
    value: string;
  }>;
};

export type UpdateProgressMutationVariables = Exact<{
  sectionId?: InputMaybe<Scalars['ID']['input']>;
  contentId: Scalars['ID']['input'];
  progress: Scalars['Float']['input'];
}>;

export type UpdateProgressMutation = {
  __typename?: 'Mutation';
  updateProgress: {
    __typename?: 'ContentEdge';
    cursor: string;
    completed: boolean;
    progress?: number | null;
  };
};

export type AddSavedMutationVariables = Exact<{
  contentId: Scalars['ID']['input'];
}>;

export type AddSavedMutation = {
  __typename?: 'Mutation';
  addSaved: {
    __typename?: 'SavedPayload';
    saved: boolean;
    content:
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        };
  };
};

export type RemoveSavedMutationVariables = Exact<{
  contentId: Scalars['ID']['input'];
}>;

export type RemoveSavedMutation = {
  __typename?: 'Mutation';
  removeSaved: {
    __typename?: 'SavedPayload';
    saved: boolean;
    content:
      | {
          __typename?: 'Article';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        };
  };
};

export type GetOnDemandBasicsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetOnDemandBasicsQuery = {
  __typename?: 'Query';
  content?:
    | {
        __typename?: 'Article';
        brand?: string | null;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Audio';
        brand?: string | null;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Banner';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'ClickThroughMedia';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'ContentSection';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'InAppSurvey';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Link';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'PracticeProgram';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Program';
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | {
        __typename?: 'Video';
        brand?: string | null;
        id: string;
        title?: string | null;
        time?: string | null;
        saved?: boolean | null;
        heroPhoto?: {
          __typename?: 'Photo';
          basePath: string;
          id: string;
          preview?: string | null;
        } | null;
        contentEquipment: Array<{
          __typename?: 'Equipment';
          name: string;
          value: string;
        }>;
        contentGenre?: {
          __typename?: 'Genre';
          id: string;
          name: string;
          value: string;
        } | null;
        contentLevel?: {
          __typename?: 'Level';
          name: string;
          value: string;
        } | null;
        contentSplit?: {
          __typename?: 'Split';
          name: string;
          value: string;
        } | null;
        contentTime?: {
          __typename?: 'ContentTime';
          name: string;
          value: string;
        } | null;
      }
    | null;
};

export type CreateContentFeedbackMutationVariables = Exact<{
  contentId: Scalars['ID']['input'];
  feedback: FeedbackKind;
}>;

export type CreateContentFeedbackMutation = {
  __typename?: 'Mutation';
  createFeedback: {
    __typename?: 'FeedbackPayload';
    content?:
      | {
          __typename?: 'Article';
          html?: string | null;
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Audio';
          html?: string | null;
          audio: string;
          transcript?: string | null;
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Banner';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ClickThroughMedia';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'ContentSection';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'InAppSurvey';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Link';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'PracticeProgram';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Program';
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | {
          __typename?: 'Video';
          html?: string | null;
          video: string;
          shortDescription?: string | null;
          author?: string | null;
          feedback?: FeedbackKind | null;
          isPublished: boolean;
          brand?: string | null;
          id: string;
          title?: string | null;
          time?: string | null;
          saved?: boolean | null;
          contentEquipment: Array<{
            __typename?: 'Equipment';
            name: string;
            value: string;
          }>;
          recommendations: {
            __typename?: 'ContentRecommendationsConnection';
            nodes: Array<
              | {
                  __typename?: 'Article';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Audio';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Banner';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ClickThroughMedia';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'ContentSection';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'InAppSurvey';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Link';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'PracticeProgram';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Program';
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
              | {
                  __typename?: 'Video';
                  brand?: string | null;
                  id: string;
                  title?: string | null;
                  time?: string | null;
                  saved?: boolean | null;
                  heroPhoto?: {
                    __typename?: 'Photo';
                    basePath: string;
                    id: string;
                    preview?: string | null;
                  } | null;
                  contentEquipment: Array<{
                    __typename?: 'Equipment';
                    name: string;
                    value: string;
                  }>;
                  contentGenre?: {
                    __typename?: 'Genre';
                    id: string;
                    name: string;
                    value: string;
                  } | null;
                  contentLevel?: {
                    __typename?: 'Level';
                    name: string;
                    value: string;
                  } | null;
                  contentSplit?: {
                    __typename?: 'Split';
                    name: string;
                    value: string;
                  } | null;
                  contentTime?: {
                    __typename?: 'ContentTime';
                    name: string;
                    value: string;
                  } | null;
                }
            >;
          };
          heroPhoto?: {
            __typename?: 'Photo';
            basePath: string;
            id: string;
            preview?: string | null;
          } | null;
          contentGenre?: {
            __typename?: 'Genre';
            id: string;
            name: string;
            value: string;
          } | null;
          contentLevel?: {
            __typename?: 'Level';
            name: string;
            value: string;
          } | null;
          contentSplit?: {
            __typename?: 'Split';
            name: string;
            value: string;
          } | null;
          contentTime?: {
            __typename?: 'ContentTime';
            name: string;
            value: string;
          } | null;
        }
      | null;
  };
};

export type MboClassDetailsFragment = {
  __typename?: 'MboClass';
  id: string;
  name: string;
  subtype: MboClassSubtype;
  category: string;
  attending: boolean;
  mboClassId: number;
  cancelled: boolean;
  full: boolean;
  description: string;
  staffFirstName?: string | null;
  staffLastName?: string | null;
  room?: string | null;
  joinUrl?: string | null;
  joinableTime: string;
  endTime: string;
  startTime: string;
  staff?: {
    __typename?: 'User';
    firstName?: string | null;
    lastName?: string | null;
    isCoach: boolean;
    id: string;
    isTestUser: boolean;
    registered: boolean;
    avatar?: {
      __typename?: 'Photo';
      basePath: string;
      id: string;
      preview?: string | null;
    } | null;
  } | null;
  studio: { __typename?: 'Studio'; id: string; mboStudioId: string };
  location?: {
    __typename?: 'CoachLocation';
    id: string;
    name?: string | null;
  } | null;
};

export type MboClassQueryVariables = Exact<{
  input: MboClassDetailsInput;
}>;

export type MboClassQuery = {
  __typename?: 'Query';
  mboClass?: {
    __typename?: 'MboClass';
    id: string;
    name: string;
    subtype: MboClassSubtype;
    category: string;
    attending: boolean;
    mboClassId: number;
    cancelled: boolean;
    full: boolean;
    description: string;
    staffFirstName?: string | null;
    staffLastName?: string | null;
    room?: string | null;
    joinUrl?: string | null;
    joinableTime: string;
    endTime: string;
    startTime: string;
    staff?: {
      __typename?: 'User';
      firstName?: string | null;
      lastName?: string | null;
      isCoach: boolean;
      id: string;
      isTestUser: boolean;
      registered: boolean;
      avatar?: {
        __typename?: 'Photo';
        basePath: string;
        id: string;
        preview?: string | null;
      } | null;
    } | null;
    studio: { __typename?: 'Studio'; id: string; mboStudioId: string };
    location?: {
      __typename?: 'CoachLocation';
      id: string;
      name?: string | null;
    } | null;
  } | null;
};

export type GetBookedClassesAndSessionsByDateRangeQueryVariables = Exact<{
  filter: MboBookingsFilter;
  sessionDateFilter?: InputMaybe<Array<DateFilter> | DateFilter>;
}>;

export type GetBookedClassesAndSessionsByDateRangeQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    bookedClasses: {
      __typename?: 'UserBookingsConnection';
      count: number;
      edges: Array<{
        __typename?: 'UserBookingsEdge';
        cursor: string;
        node: {
          __typename?: 'MboClass';
          id: string;
          name: string;
          subtype: MboClassSubtype;
          category: string;
          attending: boolean;
          mboClassId: number;
          cancelled: boolean;
          full: boolean;
          description: string;
          staffFirstName?: string | null;
          staffLastName?: string | null;
          room?: string | null;
          joinUrl?: string | null;
          joinableTime: string;
          endTime: string;
          startTime: string;
          staff?: {
            __typename?: 'User';
            firstName?: string | null;
            lastName?: string | null;
            isCoach: boolean;
            id: string;
            isTestUser: boolean;
            registered: boolean;
            avatar?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
          } | null;
          studio: { __typename?: 'Studio'; id: string; mboStudioId: string };
          location?: {
            __typename?: 'CoachLocation';
            id: string;
            name?: string | null;
          } | null;
        };
      }>;
    };
    sessions: {
      __typename?: 'UserCoachSessionsConnection';
      count: number;
      edges: Array<{
        __typename?: 'UserCoachSessionsEdge';
        cursor: string;
        node: {
          __typename?: 'CoachSession';
          id: string;
          sessionStyle: CoachSessionStyle;
          sessionType?: CoachSessionType | null;
          meetingUrl?: string | null;
          joinableTime: string;
          coach: {
            __typename?: 'User';
            firstName?: string | null;
            lastName?: string | null;
            isCoach: boolean;
            id: string;
            isTestUser: boolean;
            registered: boolean;
            avatar?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
          };
          calendar?: {
            __typename?: 'Calendar';
            id: string;
            start: string;
            end: string;
            duration: number;
          } | null;
          location?: {
            __typename?: 'CoachLocation';
            id: string;
            name?: string | null;
            studio?: { __typename?: 'Studio'; timezone: string } | null;
          } | null;
        };
      }>;
    };
  } | null;
};

export type PhotoBasicsFragment = {
  __typename?: 'Photo';
  basePath: string;
  id: string;
  preview?: string | null;
};

export type SelfQueryVariables = Exact<{ [key: string]: never }>;

export type SelfQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    id: string;
    isTestUser: boolean;
    registered: boolean;
    onboarding: { __typename?: 'Onboarding'; isCompleted: boolean };
    fitClient?: { __typename?: 'Client'; id: string } | null;
    avatar?: {
      __typename?: 'Photo';
      basePath: string;
      id: string;
      preview?: string | null;
    } | null;
  } | null;
};

export type UserBasicsFragment = {
  __typename?: 'User';
  id: string;
  isTestUser: boolean;
  registered: boolean;
  avatar?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type InactivityProviderQueryVariables = Exact<{ [key: string]: never }>;

export type InactivityProviderQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    fitClient?: {
      __typename?: 'Client';
      id: string;
      inactivityDuration?: any | null;
    } | null;
  } | null;
};

export type IterableInitQueryVariables = Exact<{ [key: string]: never }>;

export type IterableInitQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    email: string;
    iterableToken: { __typename?: 'Token'; accessToken: string };
  } | null;
};

export type AuthenticatedLayoutQueryVariables = Exact<{ [key: string]: never }>;

export type AuthenticatedLayoutQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    id: string;
    email: string;
    isTestUser: boolean;
    fitCoach?: { __typename?: 'User'; id: string } | null;
    fitClient?: { __typename?: 'Client'; id: string } | null;
  } | null;
};

export type UserDetailsFragment = {
  __typename?: 'User';
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  id: string;
  isTestUser: boolean;
  registered: boolean;
  fitClient?: { __typename?: 'Client'; id: string } | null;
  avatar?: {
    __typename?: 'Photo';
    basePath: string;
    id: string;
    preview?: string | null;
  } | null;
};

export type UpdateLastActivityMutationVariables = Exact<{
  [key: string]: never;
}>;

export type UpdateLastActivityMutation = {
  __typename?: 'Mutation';
  updateLastActivity?: {
    __typename?: 'UpdateUserPayload';
    user: { __typename?: 'User'; id: string };
  } | null;
};

export type GetUserSavedContentQueryVariables = Exact<{
  connectionInput?: InputMaybe<ConnectionInput>;
}>;

export type GetUserSavedContentQuery = {
  __typename?: 'Query';
  self?: {
    __typename?: 'User';
    savedContent: {
      __typename?: 'ContentSavedConnection';
      count: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        endCursor: string;
      };
      nodes: Array<
        | {
            __typename?: 'Article';
            brand?: string | null;
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'Audio';
            brand?: string | null;
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'Banner';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'ClickThroughMedia';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'ContentSection';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'InAppSurvey';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'Link';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'PracticeProgram';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'Program';
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
        | {
            __typename?: 'Video';
            brand?: string | null;
            id: string;
            title?: string | null;
            time?: string | null;
            saved?: boolean | null;
            heroPhoto?: {
              __typename?: 'Photo';
              basePath: string;
              id: string;
              preview?: string | null;
            } | null;
            contentEquipment: Array<{
              __typename?: 'Equipment';
              name: string;
              value: string;
            }>;
            contentGenre?: {
              __typename?: 'Genre';
              id: string;
              name: string;
              value: string;
            } | null;
            contentLevel?: {
              __typename?: 'Level';
              name: string;
              value: string;
            } | null;
            contentSplit?: {
              __typename?: 'Split';
              name: string;
              value: string;
            } | null;
            contentTime?: {
              __typename?: 'ContentTime';
              name: string;
              value: string;
            } | null;
          }
      >;
    };
  } | null;
};

export const PhotoBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PhotoBasicsFragment, unknown>;
export const MessagePreviewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessagePreviewFragment, unknown>;
export const MessageDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Message' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessagePreview' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageDetailsFragment, unknown>;
export const ChatRoomDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatRoomDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChatRoom' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageRead' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessageReceivedAt' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'preview' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageDetails' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unreadMessageCount' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Message' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessagePreview' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChatRoomDetailsFragment, unknown>;
export const CoachSessionDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'meetingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'studio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timezone' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachSessionDetailsFragment, unknown>;
export const UserBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserBasicsFragment, unknown>;
export const CoachUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachUserFragment, unknown>;
export const CoachSessionNodeFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionNode' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CoachSessionDetails' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coach' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'meetingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'studio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timezone' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachSessionNodeFragment, unknown>;
export const OnDemandSectionFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandSection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnDemandSectionFragment, unknown>;
export const ContentAttributeDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentAttributeDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentAttribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentAttributeDetailsFragment, unknown>;
export const ContentGenreBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentGenreBasicsFragment, unknown>;
export const ContentGenreWithChildrenFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreWithChildren' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ContentGenreBasics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'children' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ContentGenreBasics' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentGenreWithChildrenFragment, unknown>;
export const ContentEquipmentBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentEquipmentBasicsFragment, unknown>;
export const ContentLevelBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentLevelBasicsFragment, unknown>;
export const ContentSplitBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentSplitBasicsFragment, unknown>;
export const ContentTimeBasicsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ContentTimeBasicsFragment, unknown>;
export const OnDemandPreviewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnDemandPreviewFragment, unknown>;
export const OnDemandDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'OnDemandPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedback' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'video' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandPreview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnDemandDetailsFragment, unknown>;
export const MboClassDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MboClassDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MboClass' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attending' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mboClassId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancelled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'full' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffLastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staff' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'room' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'studio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mboStudioId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MboClassDetailsFragment, unknown>;
export const UserDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fitClient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserDetailsFragment, unknown>;
export const JoinLiveClassDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'joinLiveClass' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'classId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'joinLiveClass' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'classId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'classId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  JoinLiveClassMutation,
  JoinLiveClassMutationVariables
>;
export const GetUserChatRoomsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUserChatRooms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filters' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ChatRoomsFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatRooms' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filters' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ChatRoomDetails' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Message' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessagePreview' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatRoomDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChatRoom' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageRead' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessageReceivedAt' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'preview' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageDetails' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unreadMessageCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserChatRoomsQuery,
  GetUserChatRoomsQueryVariables
>;
export const GetChatRoomDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetChatRoom' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'messagesInput' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConnectionInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'chatRoom' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ChatRoomDetails' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'messagesWithInput' },
                  name: { kind: 'Name', value: 'messages' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'messagesInput' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'MessageDetails' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasPreviousPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startCursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unreadMessageCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Message' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessagePreview' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatRoomDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChatRoom' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageRead' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessageReceivedAt' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'preview' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageDetails' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unreadMessageCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetChatRoomQuery, GetChatRoomQueryVariables>;
export const GetCoachChatRoomDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoachChatRoom' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fitCoach' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'preview' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatRooms' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filters' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'kinds' },
                            value: {
                              kind: 'ListValue',
                              values: [{ kind: 'EnumValue', value: 'direct' }],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kind' },
                            },
                            {
                              kind: 'Field',
                              alias: {
                                kind: 'Name',
                                value: 'usersWithoutInput',
                              },
                              name: { kind: 'Name', value: 'users' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'firstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'avatar',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'preview',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ChatRoomDetails' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Message' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessagePreview' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatRoomDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ChatRoom' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isArchived' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastMessageRead' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMessageReceivedAt' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'users' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatar' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'preview' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageDetails' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unreadMessageCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCoachChatRoomQuery,
  GetCoachChatRoomQueryVariables
>;
export const GenerateSignedUrlDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateSignedUrl' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SignedUrlInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateSignedUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'signedUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'basePath' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateSignedUrlMutation,
  GenerateSignedUrlMutationVariables
>;
export const SendMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'chatId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'chatId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'text' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'basePath' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const MarkChatReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkChatRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'chatId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastMessageRead' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ZonedDateTime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markChatRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'chatId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastMessageRead' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'lastMessageRead' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastMessageRead' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkChatReadMutation,
  MarkChatReadMutationVariables
>;
export const GetCoachChatTotalUnreadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCoachChatTotalUnread' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coachData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'totalUnreadMessageCount',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCoachChatTotalUnreadQuery,
  GetCoachChatTotalUnreadQueryVariables
>;
export const NewMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'NewMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'chatId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newMessages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'chatId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'chatId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'chatRoom' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'message' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MessageDetails' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'optimisticId' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessagePreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MessagePreview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'width' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'height' },
                      value: { kind: 'IntValue', value: '240' },
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MessageDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Message' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'automated' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'avatar' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'previews' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MessagePreview' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewMessagesSubscription,
  NewMessagesSubscriptionVariables
>;
export const NewTotalUnreadMessageCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'NewTotalUnreadMessageCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'kinds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ChatRoomKind' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'apps' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'App' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'newTotalUnreadMessageCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kinds' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'kinds' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'apps' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'apps' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  NewTotalUnreadMessageCountSubscription,
  NewTotalUnreadMessageCountSubscriptionVariables
>;
export const GetCoachSessionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCoachSessions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConnectionInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dateFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'DateFilter' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'CoachSessionFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'dateFilter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'dateFilter' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filter' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CoachSessionNode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'meetingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'studio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timezone' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionNode' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CoachSessionDetails' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coach' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCoachSessionsQuery,
  GetCoachSessionsQueryVariables
>;
export const CoachSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'coachSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coachSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachSessionNode' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'meetingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'studio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timezone' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionNode' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CoachSessionDetails' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coach' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CoachSessionQuery, CoachSessionQueryVariables>;
export const GetOnDemandSectionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOnDemandSections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentCollection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sections' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'brand' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'heroPhoto' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'PhotoBasics',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bannerPhoto' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'PhotoBasics',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'logoPhoto' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'PhotoBasics',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'OnDemandSection' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandSection' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnDemandSectionsQuery,
  GetOnDemandSectionsQueryVariables
>;
export const GetOnDemandDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOnDemandDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OnDemandDetails' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'OnDemandPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedback' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'video' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandPreview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnDemandDetailsQuery,
  GetOnDemandDetailsQueryVariables
>;
export const FilterContentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'filterContents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ContentFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConnectionInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandPreview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FilterContentsQuery, FilterContentsQueryVariables>;
export const GetContentGenresDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getContentGenres' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenres' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreWithChildren' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreWithChildren' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ContentGenreBasics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'children' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ContentGenreBasics' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContentGenresQuery,
  GetContentGenresQueryVariables
>;
export const GetContentAttributesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getContentAttributes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenres' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreWithChildren' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevels' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentIntensities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentAttributeDetails' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentBrands' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentAttributeDetails' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreWithChildren' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'ContentGenreBasics' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'children' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'parent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ContentGenreBasics' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentAttributeDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentAttribute' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetContentAttributesQuery,
  GetContentAttributesQueryVariables
>;
export const UpdateProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sectionId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'progress' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProgress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sectionId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sectionId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contentId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'progress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'progress' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'progress' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProgressMutation,
  UpdateProgressMutationVariables
>;
export const AddSavedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addSaved' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addSaved' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contentId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandPreview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddSavedMutation, AddSavedMutationVariables>;
export const RemoveSavedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeSaved' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeSaved' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contentId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandPreview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveSavedMutation, RemoveSavedMutationVariables>;
export const GetOnDemandBasicsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOnDemandBasics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'content' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'OnDemandPreview' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOnDemandBasicsQuery,
  GetOnDemandBasicsQueryVariables
>;
export const CreateContentFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createContentFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contentId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'feedback' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FeedbackKind' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'contentId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'feedback' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'feedback' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'context' },
                value: { kind: 'EnumValue', value: 'content' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'OnDemandPreview' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feedback' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'video' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'html' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'transcript' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isPublished' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recommendations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'OnDemandPreview' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateContentFeedbackMutation,
  CreateContentFeedbackMutationVariables
>;
export const MboClassDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'mboClass' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MboClassDetailsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mboClass' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MboClassDetails' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MboClassDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MboClass' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attending' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mboClassId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancelled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'full' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffLastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staff' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'room' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'studio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mboStudioId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MboClassQuery, MboClassQueryVariables>;
export const GetBookedClassesAndSessionsByDateRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getBookedClassesAndSessionsByDateRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MboBookingsFilter' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sessionDateFilter' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'DateFilter' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bookedClasses' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'filter' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'MboClassDetails',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sessions' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'dateFilter' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'sessionDateFilter' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursor' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'CoachSessionNode',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCoach' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionStyle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sessionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'meetingUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'calendar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'studio' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timezone' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MboClassDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'MboClass' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attending' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mboClassId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancelled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'full' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffFirstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffLastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staff' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'room' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'studio' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mboStudioId' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'joinUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'joinableTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'location' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CoachSessionNode' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CoachSession' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'CoachSessionDetails' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coach' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CoachUser' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBookedClassesAndSessionsByDateRangeQuery,
  GetBookedClassesAndSessionsByDateRangeQueryVariables
>;
export const SelfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'self' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'UserDetails' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboarding' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isCompleted' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'registered' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'avatar' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'UserDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'UserBasics' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fitClient' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelfQuery, SelfQueryVariables>;
export const InactivityProviderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'inactivityProvider' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fitClient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inactivityDuration' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InactivityProviderQuery,
  InactivityProviderQueryVariables
>;
export const IterableInitDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'iterableInit' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'iterableToken' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'tokenType' },
                      value: { kind: 'EnumValue', value: 'web' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accessToken' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IterableInitQuery, IterableInitQueryVariables>;
export const AuthenticatedLayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'authenticatedLayout' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isTestUser' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fitCoach' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fitClient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AuthenticatedLayoutQuery,
  AuthenticatedLayoutQueryVariables
>;
export const UpdateLastActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateLastActivity' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLastActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'app' },
                value: { kind: 'EnumValue', value: 'heart' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'platform' },
                value: { kind: 'EnumValue', value: 'web' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLastActivityMutation,
  UpdateLastActivityMutationVariables
>;
export const GetUserSavedContentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserSavedContent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'connectionInput' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConnectionInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'self' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'savedContent' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'input' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'connectionInput' },
                      },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'component' },
                            value: {
                              kind: 'StringValue',
                              value:
                                'view-ondemand-class,view-ondemand-audio-class,view-ondemand-article',
                              block: false,
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'hasNextPage' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endCursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'OnDemandPreview' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Photo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basePath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'preview' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentEquipmentBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Equipment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentGenreBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Genre' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentLevelBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Level' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentSplitBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Split' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ContentTimeBasics' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentTime' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'OnDemandPreview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Content' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'time' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'heroPhoto' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'PhotoBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentEquipment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentEquipmentBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentGenre' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentGenreBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentLevel' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentLevelBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentSplit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentSplitBasics' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentTime' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ContentTimeBasics' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'saved' } },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Video' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Article' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Audio' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserSavedContentQuery,
  GetUserSavedContentQueryVariables
>;
